/**
 * CLIKKER Creator Dashboard
 * Asset: clikker-profile.js
 * Version: 7.9.7 — refined creator home dashboard
 * Matches page.clikker-profile.liquid
 */
(function () {
  "use strict";

  var VERSION = "7.9.7";

  function normalizePrivateProfileURL(){
    try{
      var url=new URL(window.location.href);
      var legacyView=url.searchParams.get("view");
      var changed=false;

      if(legacyView&&!url.searchParams.get("panel")){
        url.searchParams.set("panel",legacyView);
        changed=true;
      }

      if(url.searchParams.has("view")){
        url.searchParams.delete("view");
        changed=true;
      }

      if(url.searchParams.has("creator")){
        url.searchParams.delete("creator");
        changed=true;
      }

      if(changed){
        window.history.replaceState(
          {panel:url.searchParams.get("panel")||"dashboard"},
          "",
          url.pathname+url.search+url.hash
        );
      }
    }catch(_){}
  }

  normalizePrivateProfileURL();

  var appRoot = document.getElementById("clikkerCreatorApp");

  function configuredRoute(routeKey, globalKey, datasetKey, fallback) {
    var coreRoutes =
      window.Clikker &&
      window.Clikker.config &&
      window.Clikker.config.routes
        ? window.Clikker.config.routes
        : {};

    return (
      window[globalKey] ||
      (appRoot && appRoot.dataset ? appRoot.dataset[datasetKey] : "") ||
      coreRoutes[routeKey] ||
      fallback
    );
  }

  function withQuery(url, params) {
    try {
      var parsed = new URL(url, window.location.origin);
      Object.keys(params || {}).forEach(function (key) {
        var value = params[key];
        if (value !== undefined && value !== null && value !== "") {
          parsed.searchParams.set(key, String(value));
        }
      });
      return parsed.pathname + parsed.search + parsed.hash;
    } catch (_) {
      return url;
    }
  }

  var ROUTES = {
    profile: configuredRoute(
      "profile",
      "CLIKKER_PROFILE_ROUTE",
      "profileRoute",
      "/pages/clikker-profile"
    ),
    dashboard: configuredRoute(
      "dashboard",
      "CLIKKER_DASHBOARD_ROUTE",
      "dashboardRoute",
      "/pages/clikker-profile?panel=dashboard"
    ),
    products: configuredRoute(
      "products",
      "CLIKKER_PRODUCTS_ROUTE",
      "productsRoute",
      "/pages/clikker-profile?panel=products"
    ),
    orders: configuredRoute(
      "orders",
      "CLIKKER_ORDERS_ROUTE",
      "ordersRoute",
      "/pages/clikker-profile?panel=orders"
    ),
    payouts: configuredRoute(
      "payouts",
      "CLIKKER_PAYOUTS_ROUTE",
      "payoutsRoute",
      "/pages/clikker-profile?panel=payouts"
    ),
    store: configuredRoute(
      "store",
      "CLIKKER_STORE_EDITOR_ROUTE",
      "storeRoute",
      "/pages/clikker-profile?panel=store"
    ),
    settings: configuredRoute(
      "settings",
      "CLIKKER_SETTINGS_ROUTE",
      "settingsRoute",
      "/pages/clikker-profile?panel=settings"
    ),
    login: configuredRoute(
      "login",
      "CLIKKER_LOGIN_ROUTE",
      "loginRoute",
      "/pages/clikker-login?mode=login"
    ),
    publicStore: configuredRoute(
      "publicStore",
      "CLIKKER_PUBLIC_STORE_ROUTE",
      "publicStoreRoute",
      "/pages/c?creator="
    ),
    admin: configuredRoute(
      "admin",
      "CLIKKER_ADMIN_ROUTE",
      "adminRoute",
      "/pages/clikker-admin"
    )
  };

  var state = {
    creator: null,
    store: null,
    products: [],
    orders: [],
    orderFilter: "new",
    orderSearch: "",
    activeOrder: null,
    orderDeliveryFile: null,
    ordersLoading: false,
    payouts: [],
    payoutTransactions: [],
    payoutsLoading: false,
    payoutProfile: null,
    access: {
      role: "creator",
      status: "active",
      isAdmin: false,
      userData: null
    },
    currentView: "dashboard",
    /*
      Product library filter:
      - all = all non-archived products
      - published = live products
      - draft = unpublished editable products
      - archived = retired products
    */
    productFilter: "all",
    onboarding: {
      step: 1,
      selectedType: "",
      selectedTemplate: null,
      profileImageFile: null,
      digitalFile: null,
      saving: false,
      checkingHandle: false,
      handleAvailable: null,
      handleTimer: null,
      handleCheckToken: 0,
      lastCheckedHandle: "",
      originalHandle: ""
    },
    storeEditor: {
      activeTab: "profile",
      dirty: false,
      saving: false,
      achievements: [],
      brands: [],
      profileImageFile: null,
      bannerImageFile: null
    },
    productEditor: {
      product: null,
      buyerFields: [],
      activeTab: "basic",
      dirty: false,
      saving: false,
      fieldEditIndex: -1,
      isNew: false,
      persisted: true,
      coverImageFile: null,
      fulfilmentFiles: {},
      objectURLs: []
    }
  };

  var el = {};

  /*
   * WORKFLOW ADAPTER
   * ------------------------------------------------------------------------
   * The Firebase queries, product writes, onboarding transaction, orders,
   * uploads and public-store field structure remain exactly as in the working
   * v7.4 file. Only workflow definitions come from the new engine.
   */
  var ProductEngine = window.ClikkerProductEngine;

  if (
    !ProductEngine ||
    typeof ProductEngine.listWorkflows !== "function" ||
    typeof ProductEngine.getWorkflow !== "function" ||
    typeof ProductEngine.getWorkflowMeta !== "function" ||
    typeof ProductEngine.normalizeType !== "function" ||
    typeof ProductEngine.createProductDraft !== "function" ||
    typeof ProductEngine.validateProduct !== "function" ||
    ProductEngine.supportsPublishRequired !== true ||
    ProductEngine.supportsRichWorkflowDefaults !== true
  ) {
    throw new Error(
      "A compatible Clikker Product Engine v1.2.2 or newer must load before clikker-profile.js."
    );
  }

  function workflowToLegacySchema(workflow) {
    workflow = workflow || ProductEngine.getWorkflow("custom_service");

    return {
      fulfilment: (workflow.fulfilmentFields || []).map(function (field) {
        return {
          key: field.key,
          label: field.label,
          input: field.input || field.type || "text",
          type: field.type || field.input || "text",
          placeholder: field.placeholder || "",
          helpText: field.helpText || "",
          required: field.required === true,
          publishRequired: field.publishRequired === true,
          recommended: field.recommended === true,
          defaultValue: clone(field.defaultValue),
          options: (field.options || []).map(function (option) {
            return typeof option === "object"
              ? {
                  label: clean(option.label || option.value),
                  value: clean(
                    option.value == null ? option.label : option.value
                  ),
                  disabled: option.disabled === true
                }
              : {
                  label: clean(option),
                  value: clean(option),
                  disabled: false
                };
          }),
          accept: field.accept || "",
          min: field.min,
          max: field.max,
          step: field.step,
          rows: field.rows || 4,
          multiple: field.multiple === true,
          visibleWhen: field.visibleWhen || null
        };
      }),

      buyerFields: (workflow.buyerFields || []).map(function (field) {
        return {
          key: field.key,
          label: field.label,
          type: field.type || "text",
          required: field.required === true,
          placeholder: field.placeholder || "",
          helpText: field.helpText || "",
          options: (field.options || []).map(function (option) {
            return typeof option === "object"
              ? {
                  label: clean(option.label || option.value),
                  value: clean(
                    option.value == null ? option.label : option.value
                  )
                }
              : {
                  label: clean(option),
                  value: clean(option)
                };
          }),
          system: field.system === true,
          locked: field.locked === true
        };
      }),

      workflow: workflow
    };
  }

  function workflowTemplate(workflow) {
    return {
      id: workflow.type.replace(/_/g, "-"),
      icon: workflow.meta.icon || "✨",
      title: workflow.meta.label || workflow.type,
      type: workflow.type,
      category: workflow.meta.category || "Other",
      price: Number(workflow.defaults.price || 0),
      description:
        workflow.defaults.shortDescription ||
        workflow.defaults.description ||
        workflow.meta.description ||
        "",
      defaultCoverImage: clean(
        workflow.meta.defaultCoverImage ||
        workflow.defaults.defaultCoverImage ||
        ""
      ),
      defaultCoverAlt: clean(
        workflow.meta.defaultCoverAlt ||
        workflow.meta.label ||
        workflow.type
      ),
      schemaVersion: Number(workflow.meta.schemaVersion || 1)
    };
  }

  var PRODUCT_TEMPLATES = ProductEngine.listWorkflows()
    .filter(function (workflow) {
      return workflow.meta.status === "active";
    })
    .map(workflowTemplate);

  var ICONS = {};
  var LABELS = {};
  var SCHEMAS = {};

  ProductEngine.listWorkflows({ includeInactive: true }).forEach(function (
    workflow
  ) {
    ICONS[workflow.type] = workflow.meta.icon || "✨";
    LABELS[workflow.type] = workflow.meta.label || workflow.type;
    SCHEMAS[workflow.type] = workflowToLegacySchema(workflow);
  });

  function buyer(key,label,type,required,options) {
    return { key:key,label:label,type:type,required:required,placeholder:"",helpText:"",options:options||[],system:true };
  }
  function textField(key,label,placeholder,required) { return {key:key,label:label,input:"text",placeholder:placeholder||"",required:!!required,defaultValue:""}; }
  function textareaField(key,label,placeholder,required) { return {key:key,label:label,input:"textarea",placeholder:placeholder||"",required:!!required,defaultValue:""}; }
  function numberField(key,label,value,required) { return {key:key,label:label,input:"number",defaultValue:value,required:!!required}; }
  function selectField(key,label,options,value,required) { return {key:key,label:label,input:"select",options:options,defaultValue:value,required:!!required}; }
  function toggleField(key,label,value) { return {key:key,label:label,input:"toggle",defaultValue:!!value,required:false}; }
  function fileField(key,label,accept) { return {key:key,label:label,input:"file",accept:accept||"",required:true}; }

  function byId(id){ return document.getElementById(id); }
  function installSaveProtectionStyles(){
    if(document.getElementById("clikkerSaveProtectionStyles"))return;
    var style=document.createElement("style");
    style.id="clikkerSaveProtectionStyles";
    style.textContent=
      ".ccx-editor-dialog{position:relative}"+
      ".ccx-product-saving-overlay{position:absolute;inset:0;z-index:50;display:none;place-items:center;padding:20px;background:rgba(248,250,252,.78);backdrop-filter:blur(3px)}"+
      ".ccx-product-saving-overlay.is-visible{display:grid}"+
      ".ccx-product-saving-overlay__card{width:min(390px,100%);padding:28px 24px;border:1px solid #e4e7ec;border-radius:20px;display:grid;justify-items:center;gap:12px;text-align:center;background:#fff;box-shadow:0 24px 70px rgba(16,24,40,.20)}"+
      ".ccx-product-saving-overlay__card strong{font-size:18px;color:#101828}"+
      ".ccx-product-saving-overlay__card small{color:#667085;font-size:11px;line-height:1.5}"+
      ".ccx-product-saving-overlay.is-success .ccx-product-saving-overlay__card{border-color:#abefc6;background:#ecfdf3}"+
      ".ccx-product-saving-overlay.is-success .ccx-product-saving-overlay__card strong{color:#067647}"+
      ".ccx-product-saving-overlay.is-success .ccx-product-saving-overlay__card:before{content:'✓';width:54px;height:54px;border-radius:50%;display:grid;place-items:center;background:#067647;color:#fff;font-size:26px;font-weight:900}"+
      ".ccx-editor-modal.is-saving .ccx-editor-dialog{cursor:wait}"+
      ".ccx-editor-modal.is-saving .ccx-editor-body{pointer-events:none;user-select:none}";
    document.head.appendChild(style);
  }


  function clean(v){ return String(v == null ? "" : v).trim(); }
  function clone(v){ return JSON.parse(JSON.stringify(v == null ? null : v)); }
  function escapeHTML(v){
    return String(v == null ? "" : v).replace(/[&<>"']/g,function(c){
      return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#039;"}[c];
    });
  }
  function slugify(v){
    return clean(v).toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/^-+|-+$/g,"").slice(0,64);
  }

  function digitsOnly(value){
    return clean(value).replace(/\D+/g,"");
  }

  function normalizePhoneCode(value){
    var digits=digitsOnly(value);
    return digits?"+"+digits:"+91";
  }

  function normalizeOnboardingPhone(){
    var code=normalizePhoneCode(
      el.clikkerOnboardingPhoneCode
        ?el.clikkerOnboardingPhoneCode.value
        :"+91"
    );
    var national=digitsOnly(
      el.clikkerOnboardingPhone
        ?el.clikkerOnboardingPhone.value
        :""
    );

    if(el.clikkerOnboardingPhoneCode){
      el.clikkerOnboardingPhoneCode.value=code;
    }
    if(el.clikkerOnboardingPhone){
      el.clikkerOnboardingPhone.value=national;
    }

    return {
      countryCode:code,
      nationalNumber:national,
      e164:code+national
    };
  }

  function validOnboardingPhone(phone){
    phone=phone||normalizeOnboardingPhone();

    if(phone.countryCode==="+91"){
      return /^[6-9][0-9]{9}$/.test(phone.nationalNumber);
    }

    return /^[0-9]{7,15}$/.test(phone.nationalNumber)
      && phone.e164.length<=16;
  }
  function splitList(v){ return clean(v).split(/[\n,]+/).map(clean).filter(Boolean); }
  function db(){ return window.firebase.firestore(); }
  function serverTimestamp(){ return window.firebase.firestore.FieldValue.serverTimestamp(); }
  function uid(){ return window.Clikker.currentFirebaseUser ? window.Clikker.currentFirebaseUser.uid : ""; }

  function firebaseProviderData(providerId){
    var firebaseUser=(window.Clikker&&window.Clikker.currentFirebaseUser)||null;
    var rows=firebaseUser&&Array.isArray(firebaseUser.providerData)
      ?firebaseUser.providerData
      :[];

    return rows.find(function(row){
      return clean(row&&row.providerId)===clean(providerId||"google.com");
    })||rows[0]||null;
  }

  function firebaseAccountData(){
    var firebaseUser=(window.Clikker&&window.Clikker.currentFirebaseUser)||null;
    var accessUser=state&&state.access?state.access.userData:null;
    var provider=firebaseProviderData("google.com")||{};

    return {
      uid:clean(
        (firebaseUser&&firebaseUser.uid)||
        (accessUser&&accessUser.uid)||
        ""
      ),
      name:clean(
        (firebaseUser&&firebaseUser.displayName)||
        provider.displayName||
        (accessUser&&(
          accessUser.authDisplayName||
          accessUser.auth_display_name||
          accessUser.name||
          accessUser.displayName||
          accessUser.display_name
        ))||
        ""
      ),
      email:clean(
        (firebaseUser&&firebaseUser.email)||
        provider.email||
        (accessUser&&(
          accessUser.googleEmail||
          accessUser.google_email||
          accessUser.email
        ))||
        ""
      ),
      photoURL:clean(
        (firebaseUser&&firebaseUser.photoURL)||
        provider.photoURL||
        (accessUser&&(
          accessUser.googlePhotoURL||
          accessUser.google_photo_url||
          accessUser.photoURL||
          accessUser.photo_url||
          accessUser.profileImage||
          accessUser.profile_image
        ))||
        ""
      )
    };
  }

  function firebaseAccountPhoto(){ return firebaseAccountData().photoURL; }
  function firebaseAccountName(){ return firebaseAccountData().name; }
  function firebaseAccountEmail(){ return firebaseAccountData().email; }
  function typeOf(p){ return clean(p.fulfilmentType || p.fulfillmentType || p.type || "custom_service").toLowerCase(); }
  function iconOf(type){
    var meta=ProductEngine.getWorkflowMeta(type);
    return meta&&meta.icon||ICONS[type]||"✨";
  }
  function labelOf(type){
    var meta=ProductEngine.getWorkflowMeta(type);
    return meta&&meta.label||LABELS[type]||type;
  }

  /*
   * PRODUCT COVER IMAGE RESOLUTION
   * ----------------------------------------------------------------------
   * Display priority:
   * 1. Creator-uploaded product cover
   * 2. Workflow default cover from clikker-product-workflows.js v1.2.4+
   * 3. Existing workflow emoji/icon
   *
   * Default workflow covers are NOT copied into Firestore. This keeps product
   * documents creator-specific and lets Clikker replace a default image later
   * without migrating every product document.
   */
  function workflowDefaultCover(type){
    type=ProductEngine.normalizeType(type||"custom_service");
    var workflow=ProductEngine.getWorkflow(type);
    var url=clean(
      workflow&&workflow.meta&&workflow.meta.defaultCoverImage ||
      workflow&&workflow.defaults&&workflow.defaults.defaultCoverImage ||
      ""
    );

    if(
      !url &&
      window.ClikkerProductWorkflows &&
      typeof window.ClikkerProductWorkflows.getDefaultCoverImage==="function"
    ){
      url=clean(window.ClikkerProductWorkflows.getDefaultCoverImage(type));
    }

    return url;
  }

  function workflowDefaultCoverAlt(type){
    type=ProductEngine.normalizeType(type||"custom_service");
    var workflow=ProductEngine.getWorkflow(type);
    return clean(
      workflow&&workflow.meta&&workflow.meta.defaultCoverAlt ||
      workflow&&workflow.meta&&workflow.meta.label ||
      labelOf(type) ||
      "Product"
    );
  }

  function creatorProductCover(p){
    p=p||{};
    var cover=p.coverImage||p.cover_image||null;

    if(typeof cover==="string"&&clean(cover))return clean(cover);

    if(cover&&typeof cover==="object"){
      var objectURL=clean(
        cover.downloadURL||
        cover.downloadUrl||
        cover.url||
        cover.src||
        ""
      );
      if(objectURL)return objectURL;
    }

    return clean(
      p.coverImageURL||
      p.coverImageUrl||
      p.cover_image_url||
      p.imageURL||
      p.imageUrl||
      p.image_url||
      ""
    );
  }

  function productCoverURL(p){
    return creatorProductCover(p)||workflowDefaultCover(typeOf(p));
  }

  function productCoverAlt(p){
    p=p||{};
    return clean(p.title)||workflowDefaultCoverAlt(typeOf(p));
  }

  function productCoverMarkup(p,options){
    options=options||{};
    var url=productCoverURL(p);
    var type=typeOf(p);
    var className=clean(options.className||"ccx-product-cover-image");
    var extra=clean(options.extra||"");

    if(url){
      return '<img src="'+escapeHTML(url)+
        '" alt="'+escapeHTML(productCoverAlt(p))+
        '" class="'+escapeHTML(className)+
        '" loading="'+(options.eager?"eager":"lazy")+
        '" decoding="async"'+
        (extra?' '+extra:'')+
        '>';
    }

    return '<span class="ccx-product-cover-fallback" aria-hidden="true">'+
      escapeHTML(iconOf(type))+
      '</span>';
  }
  function schemaOf(type){
    type=ProductEngine.normalizeType(type||"custom_service");
    if(!SCHEMAS[type]){
      var workflow=ProductEngine.getWorkflow(type)||ProductEngine.getWorkflow("custom_service");
      SCHEMAS[type]=workflowToLegacySchema(workflow);
    }
    return SCHEMAS[type]||SCHEMAS.custom_service;
  }
  function money(value,code){
    try {
      return new Intl.NumberFormat("en-IN",{style:"currency",currency:code||"INR",maximumFractionDigits:0}).format(Number(value||0));
    } catch(_) { return "₹"+Number(value||0).toLocaleString("en-IN"); }
  }
  function normalizeHex(v,fallback){ return /^#[0-9a-f]{6}$/i.test(clean(v)) ? clean(v) : fallback; }

  var TIMEOUTS = {
    core: 15000,
    handle: 12000,
    upload: 60000,
    transaction: 25000,
    context: 15000,
    query: 15000
  };

  function timeoutError(label){
    var error=new Error(label+" is taking too long. Check your internet connection and try again.");
    error.code="clikker/timeout";
    return error;
  }

  function withTimeout(promise,ms,label){
    var timer;
    return Promise.race([
      Promise.resolve(promise),
      new Promise(function(_,reject){
        timer=setTimeout(function(){reject(timeoutError(label||"This operation"));},ms);
      })
    ]).finally(function(){clearTimeout(timer);});
  }

  function firebaseErrorCode(error){
    return clean(error&&error.code).toLowerCase();
  }

  function isPermissionError(error){
    var code=firebaseErrorCode(error);
    var message=clean(error&&error.message).toLowerCase();
    return code==="permission-denied" ||
      code==="firestore/permission-denied" ||
      code==="storage/unauthorized" ||
      /missing or insufficient permissions|permission denied|insufficient permissions/.test(message);
  }

  function optionalFallbackLog(label,error){
    /*
      Optional compatibility/fallback reads must not surface a permission warning
      when the dashboard can continue normally. Keep non-permission failures
      visible to developers because they may indicate a genuine data/network issue.
    */
    if(isPermissionError(error)){
      if(console&&typeof console.debug==="function"){
        console.debug(label+" — using working fallback.");
      }
      return;
    }
    console.warn(label,error);
  }

  function firebaseMessage(error,fallback){
    var code=firebaseErrorCode(error);

    /*
      Do not expose internal Firestore/Storage rule wording in creator-facing UI.
      The action-specific fallback tells the creator what actually failed.
    */
    if(isPermissionError(error)){
      return fallback||"This action could not be completed. Please refresh and try again.";
    }

    if(code==="storage/canceled")return "The upload was cancelled.";
    if(code==="storage/retry-limit-exceeded")return "The upload could not finish. Check your connection and try again.";
    if(code==="unavailable"||code==="firestore/unavailable")return "The service is temporarily unavailable. Please try again.";
    return clean(error&&error.message)||fallback||"Something went wrong.";
  }

  function cache(){
    [
      "clikkerCreatorApp","clikkerCreatorLoading","clikkerCreatorError","clikkerCreatorErrorTitle","clikkerCreatorErrorMessage","clikkerCreatorRetry",
      "clikkerQuickOnboarding","clikkerOnboardingProgressText","clikkerOnboardingProgressPercent","clikkerOnboardingProgressBar",
      "clikkerOnboardingAlert","clikkerOnboardingAvatarPreview","clikkerOnboardingAvatar","clikkerOnboardingName",
      "clikkerOnboardingHandle","clikkerOnboardingHandleState","clikkerOnboardingCategory","clikkerOnboardingSupportEmail","clikkerOnboardingPhoneCode","clikkerOnboardingPhone",
      "clikkerOnboardingBio","clikkerOnboardingProductChoices","clikkerOnboardingProductTitle","clikkerOnboardingProductPrice",
      "clikkerOnboardingProductCurrency","clikkerOnboardingDeliveryHours","clikkerOnboardingDailyLimit",
      "clikkerOnboardingProductDescription","clikkerOnboardingDigitalFileWrap","clikkerOnboardingDigitalFile",
      "clikkerOnboardingDigitalFileHelp","clikkerOnboardingOfferIcon","clikkerOnboardingOfferTitle",
      "clikkerOnboardingOfferDelivery","clikkerOnboardingOfferPrice","clikkerOnboardingSuccess",
      "clikkerOnboardingPublicLink","clikkerOnboardingCopyLink","clikkerOnboardingViewStore",
      "clikkerOnboardingOpenDashboard","clikkerOnboardingActions","clikkerOnboardingBack",
      "clikkerOnboardingNext","clikkerOnboardingCreate","clikkerOnboardingPublishConfirmation",
      "clikkerCreatorShell","clikkerCreatorSidebar","clikkerCreatorNavigation","clikkerCreatorMobileMenu","clikkerCreatorLogout","clikkerCreatorAdminLink",
      "clikkerCreatorUserAvatar","clikkerCreatorUserName","clikkerCreatorUserEmail","clikkerCreatorPageTitle","clikkerCreatorPageSubtitle",
      "clikkerCreatorTopbarActions","clikkerCreatorAlert","clikkerCreatorView","clikkerStoreEditor","clikkerStoreEditorTabs",
      "clikkerStoreEditorAlert","clikkerStoreProfileScore","clikkerStoreProfileBar","storeProfileChecklist","storeProfilePublishSummary",
      "storeProfileSaveStatus","storeOpenPrivatePreview","storeSaveDraft","storePublishProfile","clikkerProductEditor",
      "clikkerProductEditorIcon","clikkerProductEditorTitle","clikkerProductEditorType","clikkerProductEditorSaveStatus",
      "clikkerProductEditorClose","clikkerProductEditorTabs","clikkerProductEditorAlert","clikkerProductFulfilmentFields",
      "clikkerBuyerFieldList","clikkerBuyerFieldEmpty","clikkerAddBuyerField","clikkerLoadRecommendedFields",
      "clikkerProductPublishSummary","clikkerEditorPreviewCover","clikkerEditorPreviewType","clikkerEditorPreviewTitle",
      "clikkerEditorPreviewDescription","clikkerEditorPreviewPrice","clikkerEditorPreviewStatus","clikkerProductReadinessScore",
      "clikkerProductReadinessBar","clikkerProductReadinessList","clikkerCustomerFormPreview","clikkerArchiveProduct",
      "clikkerCancelProductEdit","clikkerSaveProductDraft","clikkerPublishProduct","clikkerProductSaveState","clikkerBuyerFieldDrawer",
      "clikkerProductPreviousStep","clikkerProductNextStep","storeProfileStatusLabel","storeProfileVisibilityLabel","productEditorVisibilityLabel",
      "clikkerBuyerFieldDrawerTitle","clikkerBuyerFieldDrawerClose","buyerFieldLabel","buyerFieldKey","buyerFieldType",
      "buyerFieldPlaceholder","buyerFieldHelpText","buyerFieldOptionsWrap","buyerFieldOptions","buyerFieldRequired",
      "clikkerCancelBuyerField","clikkerSaveBuyerField",
      "clikkerOrdersNavCount","clikkerOrdersViewTemplate","clikkerPayoutsViewTemplate","clikkerOrderDrawer",
      "clikkerOrderDrawerClose","clikkerOrderDrawerStatus","clikkerOrderDrawerTitle",
      "clikkerOrderDrawerMeta","clikkerOrderDrawerAlert","clikkerOrderBuyerName",
      "clikkerOrderBuyerEmail","clikkerOrderBuyerPhone","clikkerOrderProductTitle",
      "clikkerOrderInstagram","clikkerOrderPaidAmount","clikkerOrderShopifyName",
      "clikkerOrderPaidAt","clikkerOrderDeadline","clikkerOrderPreferredFormat",
      "clikkerOrderQuestion","clikkerOrderExtraRequirements","clikkerOrderRequirementsList",
      "clikkerOrderRequestTitle","clikkerOrderRequestHelp","clikkerOrderTypeBadge",
      "clikkerOrderTypeIcon","clikkerOrderTypeLabel","clikkerOrderFulfilmentTitle",
      "clikkerOrderFulfilmentHelp","clikkerOrderFulfilmentProduct",
      "clikkerOrderFulfilmentSummary","clikkerOrderFulfilmentState",
      "clikkerOrderDynamicFulfilmentFields","clikkerOrderDeliveryFormat",
      "clikkerOrderDeliveryLink","clikkerOrderDeliveryLinkLabel",
      "clikkerOrderDeliveryLinkHelp","clikkerOrderScheduleFields",
      "clikkerOrderScheduledAt","clikkerOrderDeliveryPlatform",
      "clikkerOrderReplyText","clikkerOrderReplyTextLabel","clikkerOrderReplyTextHelp",
      "clikkerOrderReplyCount","clikkerOrderDeliveryFile",
      "clikkerOrderDeliveryFileLabel","clikkerOrderDeliveryFileHelp",
      "clikkerOrderDeliveryFileState","clikkerOrderTimelineList",
      "clikkerOrderSaveStatus","clikkerOrderStart","clikkerOrderSaveReply",
      "clikkerOrderMarkDelivered"
    ].forEach(function(id){ el[id]=byId(id); });
  }

  function setAppState(value){
    if(el.clikkerCreatorApp)el.clikkerCreatorApp.dataset.state=value;
  }

  function showLoading(){
    setAppState("loading");
    el.clikkerCreatorLoading.hidden=false;
    el.clikkerCreatorError.hidden=true;
    el.clikkerCreatorShell.hidden=true;
    if(el.clikkerQuickOnboarding)el.clikkerQuickOnboarding.hidden=true;
  }
  function showError(title,message){
    setAppState("error");
    el.clikkerCreatorLoading.hidden=true;
    el.clikkerCreatorShell.hidden=true;
    if(el.clikkerQuickOnboarding)el.clikkerQuickOnboarding.hidden=true;
    el.clikkerCreatorError.hidden=false;
    el.clikkerCreatorErrorTitle.textContent=title;
    el.clikkerCreatorErrorMessage.textContent=message;
  }
  function showShell(){
    setAppState("ready");
    el.clikkerCreatorLoading.hidden=true;
    el.clikkerCreatorError.hidden=true;
    if(el.clikkerQuickOnboarding)el.clikkerQuickOnboarding.hidden=true;
    el.clikkerCreatorShell.hidden=false;
  }

  function showQuickOnboarding(){
    setAppState("onboarding");
    el.clikkerCreatorLoading.hidden=true;
    el.clikkerCreatorError.hidden=true;
    el.clikkerCreatorShell.hidden=true;
    el.clikkerQuickOnboarding.hidden=false;
  }
  function showAlert(message,type){
    el.clikkerCreatorAlert.className="ccx-alert is-visible ccx-alert--"+(type||"info");
    el.clikkerCreatorAlert.textContent=message;
  }
  function clearAlert(){ el.clikkerCreatorAlert.className="ccx-alert"; el.clikkerCreatorAlert.textContent=""; }

  function normalizedRole(value){
    return clean(value).toLowerCase().replace(/[\s-]+/g,"_");
  }

  function normalizedAccountStatus(value){
    return clean(value||"active").toLowerCase();
  }

  function isAdminRole(role){
    role=normalizedRole(role);
    return role==="admin"||role==="super_admin";
  }

  async function loadAccessProfile(){
    var authUser=window.Clikker.currentFirebaseUser||{};
    var account=firebaseAccountData();
    var fallback={
      uid:account.uid||authUser.uid||"",
      email:account.email||authUser.email||"",
      name:account.name||authUser.displayName||"",
      photoURL:account.photoURL||authUser.photoURL||"",
      googlePhotoURL:account.photoURL||authUser.photoURL||"",
      google_photo_url:account.photoURL||authUser.photoURL||"",
      role:"creator",
      status:"active"
    };

    if(!authUser.uid){
      state.access={
        role:"creator",
        status:"active",
        isAdmin:false,
        userData:fallback
      };
      return state.access;
    }

    try{
      var snap=await withTimeout(
        db().collection("users").doc(authUser.uid).get(),
        TIMEOUTS.context,
        "Loading creator account"
      );
      var data=snap.exists?Object.assign({uid:authUser.uid},snap.data()):fallback;
      var role=normalizedRole(data.role||"creator")||"creator";
      var status=normalizedAccountStatus(data.status||"active")||"active";

      state.access={
        role:role,
        status:status,
        isAdmin:isAdminRole(role)&&status==="active",
        userData:data
      };
    }catch(error){
      optionalFallbackLog("[Clikker Creator] Account profile fallback",error);
      state.access={
        role:"creator",
        status:"active",
        isAdmin:false,
        userData:fallback
      };
    }

    return state.access;
  }

  function syncAdminAccessUI(){
    if(!el.clikkerCreatorAdminLink)return;
    el.clikkerCreatorAdminLink.hidden=!state.access.isAdmin;
    el.clikkerCreatorAdminLink.href=ROUTES.admin;
  }

  async function waitForCore(){
    var attempts=0;
    while(!window.Clikker && attempts<120){
      await new Promise(function(resolve){setTimeout(resolve,50);});
      attempts++;
    }

    if(!window.Clikker){
      throw new Error("Clikker Firebase did not load.");
    }

    if(typeof window.Clikker.waitUntilReady==="function"){
      await withTimeout(
        window.Clikker.waitUntilReady(),
        TIMEOUTS.core,
        "Loading Clikker Firebase"
      );
      return;
    }

    if(window.Clikker.readyPromise){
      await withTimeout(
        window.Clikker.readyPromise,
        TIMEOUTS.core,
        "Loading Clikker Firebase"
      );
      return;
    }

    throw new Error("Clikker Firebase readiness API is unavailable.");
  }

  async function boot(){
    installSaveProtectionStyles();
    showLoading();
    try{
      await waitForCore();

      if(!window.Clikker.isAuthenticated()){
        location.href=withQuery(ROUTES.login,{next:ROUTES.profile});
        return;
      }

      await loadAccessProfile();

      var googleIdentity=firebaseAccountData();
      console.info("[Clikker Creator] Auth identity",{
        uid:googleIdentity.uid,
        name:googleIdentity.name,
        email:googleIdentity.email,
        hasPhoto:Boolean(googleIdentity.photoURL)
      });

      if(state.access.status!=="active"){
        throw new Error("Your Clikker account is not active.");
      }

      if(typeof window.Clikker.refreshCurrentContext==="function"){
        try{
          await withTimeout(
            window.Clikker.refreshCurrentContext(),
            TIMEOUTS.context,
            "Loading your creator account"
          );
        }catch(contextError){
          optionalFallbackLog(
            "[Clikker Creator] Context refresh fallback",
            contextError
          );
        }
      }

      state.creator=window.Clikker.currentCreator;
      state.store=window.Clikker.currentStore;

      /*
       * Prefer the canonical creators/{authUid} record whenever it exists.
       * This prevents an older/random legacy creator document returned by the
       * shared core from becoming the write target for this private dashboard.
       */
      var canonicalContext=await loadCanonicalCreatorContextDirect();
      if(canonicalContext&&canonicalContext.creator){
        state.creator=canonicalContext.creator;
        if(canonicalContext.store)state.store=canonicalContext.store;
      }

      /*
        A brand-new authenticated user may not have a creators document yet.
        Onboarding is responsible for creating it, so create a lightweight
        local context instead of blocking the workspace.
      */
      if(!state.creator){
        var authUser=window.Clikker.currentFirebaseUser||{};
        var accountData=firebaseAccountData();
        state.creator={
          id:accountData.uid||authUser.uid||"",
          userId:accountData.uid||authUser.uid||"",
          displayName:accountData.name||clean(authUser.displayName||""),
          handle:"",
          category:"",
          bio:"",
          supportEmail:accountData.email||clean(authUser.email||""),
          phone:"",
          phoneCountryCode:"+91",
          profileImage:accountData.photoURL||clean(authUser.photoURL||""),
          storeId:"",
          status:"active",
          raw:{
            userId:accountData.uid||authUser.uid||"",
            user_id:accountData.uid||authUser.uid||"",
            displayName:accountData.name||clean(authUser.displayName||""),
            name:accountData.name||clean(authUser.displayName||""),
            email:accountData.email||clean(authUser.email||""),
            supportEmail:accountData.email||clean(authUser.email||""),
            phone:"",
            mobile:"",
            phoneCountryCode:"+91",
            phone_country_code:"+91",
            photoURL:accountData.photoURL||clean(authUser.photoURL||""),
            googlePhotoURL:accountData.photoURL||clean(authUser.photoURL||""),
            google_photo_url:accountData.photoURL||clean(authUser.photoURL||""),
            onboardingCompleted:false,
            onboarding_completed:false,
            status:"active"
          },
          __provisional:true
        };
      }

      var creatorRaw=state.creator.raw||{};
      var storeRaw=state.store&&state.store.raw||{};
      var onboardingComplete=
        creatorRaw.onboardingCompleted===true ||
        creatorRaw.onboarding_completed===true ||
        storeRaw.onboardingCompleted===true ||
        storeRaw.onboarding_completed===true;

      if(!onboardingComplete){
        prepareQuickOnboarding();
        showQuickOnboarding();
        console.info("[Clikker Creator] Quick onboarding ready",VERSION);
        return;
      }

      if(!state.store){
        throw new Error("Your creator store could not be found.");
      }

      await loadProducts(true);
      try{
        await loadOrders(false);
      }catch(orderLoadError){
        optionalFallbackLog("[Clikker Orders] Initial load fallback",orderLoadError);
      }
      renderUser();
      syncAdminAccessUI();
      showShell();
      var profileURL=new URL(location.href);
      var initialPanel=
        profileURL.searchParams.get("panel")||
        profileURL.searchParams.get("view")||
        "dashboard";
      renderView(initialPanel);
      console.info("[Clikker Creator] Ready",VERSION,{
        productEngine:ProductEngine.version||"",
        workflows:window.ClikkerProductWorkflows&&window.ClikkerProductWorkflows.version||"",
        creatorDefaults:true,
        minimalPublishBlockers:true,
        defaultProductCovers:ProductEngine.listWorkflows().filter(function(workflow){
          return !!clean(
            workflow.meta&&workflow.meta.defaultCoverImage||
            workflow.defaults&&workflow.defaults.defaultCoverImage||
            ""
          );
        }).length,
        firebase:window.Clikker&&window.Clikker.version||""
      });
    }catch(error){
      console.error(error);
      showError("Unable to open creator workspace",error.message||"Something went wrong.");
    }
  }


  var ONBOARDING_DEFAULTS = {};

  ProductEngine.listWorkflows().forEach(function(workflow){
    var type=workflow.type;
    var defaults=workflow.defaults||{};
    var schema=schemaOf(type);
    var deliveryField=schema.fulfilment.find(function(field){
      return field.key==="delivery_hours";
    });

    ONBOARDING_DEFAULTS[type]={
      icon:workflow.meta.icon||"✨",
      defaultCoverImage:clean(
        workflow.meta.defaultCoverImage||
        defaults.defaultCoverImage||
        ""
      ),
      defaultCoverAlt:clean(
        workflow.meta.defaultCoverAlt||
        workflow.meta.label||
        type
      ),
      title:clean(defaults.title||workflow.meta.label||type),
      price:Number(defaults.price||0),
      deliveryHours:deliveryField
        ?Number(deliveryField.defaultValue||0)
        :(type==="scheduled_call"?24:0),
      description:clean(
        defaults.shortDescription||
        defaults.description||
        workflow.meta.description||
        ""
      )
    };
  });


  function creatorRaw(){
    return state.creator&&state.creator.raw||{};
  }

  function storeRaw(){
    return state.store&&state.store.raw||{};
  }

  /*
   * Canonical creator identity
   * ----------------------------------------------------------------------
   * A creator document always uses the Firebase Authentication UID as its
   * Firestore document ID. Legacy/random creator IDs may still be read by
   * older core code, but all profile/onboarding/product writes use the auth
   * UID so ownership is deterministic for every account.
   */
  function creatorDocumentId(){
    return uid();
  }

  function creatorStateFromDoc(doc){
    if(!doc||!doc.exists)return null;
    var raw=doc.data()||{};
    return {
      id:doc.id,
      userId:clean(raw.userId||raw.user_id||raw.ownerId||uid()),
      displayName:clean(raw.displayName||raw.display_name||raw.name||firebaseAccountName()),
      handle:clean(raw.handle||raw.username||""),
      category:clean(raw.category||""),
      bio:clean(raw.bio||""),
      supportEmail:clean(raw.supportEmail||raw.support_email||firebaseAccountEmail()),
      phone:clean(raw.phone||raw.mobile||raw.phoneNumber||raw.phone_number||""),
      mobile:clean(raw.mobile||raw.phone||raw.phoneNumber||raw.phone_number||""),
      phoneCountryCode:clean(raw.phoneCountryCode||raw.phone_country_code||"+91"),
      phoneNationalNumber:clean(raw.phoneNationalNumber||raw.phone_national_number||""),
      profileImage:clean(raw.profileImageURL||raw.profileImage||raw.photoURL||firebaseAccountPhoto()),
      storeId:clean(raw.storeId||raw.store_id||""),
      status:clean(raw.status||"active")||"active",
      raw:raw,
      __canonical:true
    };
  }

  function storeStateFromDoc(doc){
    if(!doc||!doc.exists)return null;
    var raw=doc.data()||{};
    return Object.assign({
      id:doc.id,
      creatorId:clean(raw.creatorId||raw.creator_id||uid()),
      ownerId:clean(raw.ownerId||raw.owner_id||uid()),
      storeName:clean(raw.storeName||raw.displayName||raw.name||firebaseAccountName()),
      displayName:clean(raw.displayName||raw.storeName||raw.name||firebaseAccountName()),
      slug:clean(raw.slug||raw.handle||""),
      handle:clean(raw.handle||raw.slug||""),
      category:clean(raw.category||""),
      about:clean(raw.about||raw.shortBio||""),
      shortBio:clean(raw.shortBio||raw.about||""),
      profileImage:clean(raw.profileImageURL||raw.profileImage||firebaseAccountPhoto()),
      profileImageURL:clean(raw.profileImageURL||raw.profileImage||firebaseAccountPhoto()),
      status:clean(raw.status||"draft")||"draft",
      visibility:clean(raw.visibility||"private")||"private",
      raw:raw,
      __canonical:true
    },raw);
  }

  async function loadCanonicalCreatorContextDirect(){
    var authUid=uid();
    if(!authUid)return null;

    try{
      var creatorSnap=await withTimeout(
        db().collection("creators").doc(authUid).get(),
        TIMEOUTS.context,
        "Loading canonical creator profile"
      );
      if(!creatorSnap.exists)return null;

      var creator=creatorStateFromDoc(creatorSnap);
      var store=null;
      var canonicalStoreId=clean(creator&&creator.storeId);
      if(canonicalStoreId){
        try{
          var storeSnap=await withTimeout(
            db().collection("stores").doc(canonicalStoreId).get(),
            TIMEOUTS.context,
            "Loading canonical creator store"
          );
          store=storeStateFromDoc(storeSnap);
        }catch(storeError){
          optionalFallbackLog("[Clikker Creator] Canonical store fallback",storeError);
        }
      }

      return {creator:creator,store:store};
    }catch(error){
      optionalFallbackLog("[Clikker Creator] Canonical creator fallback",error);
      return null;
    }
  }

  function prepareQuickOnboarding(){
    var user=window.Clikker.currentFirebaseUser||{};
    var account=firebaseAccountData();
    var cr=creatorRaw();
    var sr=storeRaw();
    var suggestedName=clean(
      (state.creator&&state.creator.displayName)||
      cr.displayName||
      cr.display_name||
      cr.name||
      account.name||
      user.displayName||
      ""
    );
    var suggestedHandle=slugify(
      (state.store&&state.store.slug)||
      sr.slug||
      (state.creator&&state.creator.handle)||
      cr.handle||
      cr.username||
      suggestedName||
      (account.email||user.email||"").split("@")[0]
    );
    var supportEmail=clean(
      (sr.contact&&sr.contact.supportEmail)||
      sr.supportEmail||
      cr.supportEmail||
      account.email||
      user.email||
      ""
    );

    var existingPhone=clean(
      cr.phone||
      cr.mobile||
      cr.phoneNumber||
      cr.phone_number||
      (sr.contact&&(
        sr.contact.phone||
        sr.contact.mobile||
        sr.contact.whatsappNumber
      ))||
      ""
    );
    var existingPhoneCode=normalizePhoneCode(
      cr.phoneCountryCode||
      cr.phone_country_code||
      (sr.contact&&(
        sr.contact.phoneCountryCode||
        sr.contact.phone_country_code
      ))||
      "+91"
    );
    var existingPhoneDigits=digitsOnly(existingPhone);
    var existingCodeDigits=digitsOnly(existingPhoneCode);

    if(
      existingPhoneDigits &&
      existingCodeDigits &&
      existingPhoneDigits.indexOf(existingCodeDigits)===0
    ){
      existingPhoneDigits=existingPhoneDigits.slice(existingCodeDigits.length);
    }

    state.onboarding.step=1;
    state.onboarding.selectedType="";
    state.onboarding.selectedTemplate=null;
    state.onboarding.profileImageFile=null;
    state.onboarding.digitalFile=null;
    state.onboarding.saving=false;
    state.onboarding.handleAvailable=null;
    state.onboarding.originalHandle=suggestedHandle;

    if(el.clikkerOnboardingPublishConfirmation){
      el.clikkerOnboardingPublishConfirmation.checked=false;
    }

    el.clikkerOnboardingName.value=suggestedName;
    el.clikkerOnboardingHandle.value=suggestedHandle;
    el.clikkerOnboardingCategory.value=clean(sr.category||cr.category||"");
    el.clikkerOnboardingSupportEmail.value=supportEmail;
    if(el.clikkerOnboardingPhoneCode){
      el.clikkerOnboardingPhoneCode.value=existingPhoneCode;
    }
    if(el.clikkerOnboardingPhone){
      el.clikkerOnboardingPhone.value=existingPhoneDigits;
    }
    el.clikkerOnboardingBio.value=clean(sr.about||sr.shortBio||cr.bio||"");
    el.clikkerOnboardingProductCurrency.value=clean(sr.currency||cr.currency||"INR")||"INR";

    ensureOnboardingDigitalFileField(false);
    renderOnboardingAvatar();
    renderOnboardingStep();
    checkOnboardingHandle(true);
  }

  function renderOnboardingStep(){
    var step=state.onboarding.step;
    var isSuccess=step==="success";
    var numericStep=isSuccess?3:(Number(step)||1);
    var percent=isSuccess?100:Math.min(100,Math.max(33,Math.round(numericStep/3*100)));

    el.clikkerQuickOnboarding.querySelectorAll("[data-onboarding-step]").forEach(function(panel){
      panel.classList.toggle("is-active",String(panel.dataset.onboardingStep)===String(step));
    });

    el.clikkerQuickOnboarding.querySelectorAll(".ccx-onboarding__mini-steps li").forEach(function(item,index){
      var itemStep=index+1;
      var active=!isSuccess&&itemStep===numericStep;
      var complete=isSuccess||itemStep<numericStep;
      item.classList.toggle("is-active",active);
      item.classList.toggle("is-complete",complete);
      if(active)item.setAttribute("aria-current","step");
      else item.removeAttribute("aria-current");
    });

    el.clikkerOnboardingProgressText.textContent=isSuccess?"Store created":"Step "+numericStep+" of 3";
    el.clikkerOnboardingProgressPercent.textContent=percent+"%";
    el.clikkerOnboardingProgressBar.style.width=percent+"%";

    if(isSuccess){
      el.clikkerOnboardingActions.hidden=true;
      return;
    }

    el.clikkerOnboardingActions.hidden=false;
    el.clikkerOnboardingBack.hidden=numericStep===1;
    el.clikkerOnboardingNext.hidden=numericStep===3;
    el.clikkerOnboardingCreate.hidden=numericStep!==3;

    if(!state.onboarding.saving){
      el.clikkerOnboardingNext.textContent=numericStep===1
        ?"Next: Choose Product →"
        :"Next: Set Price →";
      el.clikkerOnboardingCreate.textContent="Create My Store";
    }
  }

  function onboardingMessage(message,type){
    el.clikkerOnboardingAlert.className="ccx-alert ccx-onboarding__alert is-visible ccx-alert--"+(type||"info");
    el.clikkerOnboardingAlert.textContent=message;
  }

  function clearOnboardingMessage(){
    el.clikkerOnboardingAlert.className="ccx-alert ccx-onboarding__alert";
    el.clikkerOnboardingAlert.textContent="";
  }

  function renderOnboardingAvatar(){
    var node=el.clikkerOnboardingAvatarPreview;
    node.innerHTML="";
    var file=state.onboarding.profileImageFile;
    var existing=
      creatorRaw().profileImageURL||
      creatorRaw().profileImageUrl||
      creatorRaw().profileImage||
      creatorRaw().avatarURL||
      creatorRaw().photoURL||
      storeRaw().profileImageURL||
      storeRaw().profileImage||
      firebaseAccountPhoto()||
      "";
    if(file){
      var reader=new FileReader();
      reader.onload=function(){
        node.innerHTML='<img alt="Profile preview" src="'+escapeHTML(reader.result)+'">';
      };
      reader.readAsDataURL(file);
      return;
    }
    if(existing){
      node.innerHTML='<img alt="Profile preview" src="'+escapeHTML(existing)+'">';
      return;
    }
    var name=clean(el.clikkerOnboardingName.value)||"Creator";
    node.textContent=name.charAt(0).toUpperCase();
  }

  function normalizedOnboardingHandle(){
    var value=slugify(el.clikkerOnboardingHandle.value);
    el.clikkerOnboardingHandle.value=value;
    return value;
  }

  async function checkOnboardingHandle(immediate){
    clearTimeout(state.onboarding.handleTimer);
    var handle=normalizedOnboardingHandle();

    if(handle.length<3){
      state.onboarding.handleAvailable=false;
      state.onboarding.lastCheckedHandle="";
      el.clikkerOnboardingHandleState.className="ccx-onboarding__handle-state is-error";
      el.clikkerOnboardingHandleState.textContent="Use at least 3 letters or numbers.";
      return false;
    }

    if(
      handle===state.onboarding.lastCheckedHandle &&
      state.onboarding.handleAvailable!==null &&
      !state.onboarding.checkingHandle
    ){
      return state.onboarding.handleAvailable;
    }

    var token=++state.onboarding.handleCheckToken;

    var run=async function(){
      state.onboarding.checkingHandle=true;
      el.clikkerOnboardingHandleState.className="ccx-onboarding__handle-state";
      el.clikkerOnboardingHandleState.textContent="Checking username…";

      try{
        var snap=await withTimeout(
          db().collection("storeHandles").doc(handle).get(),
          TIMEOUTS.handle,
          "Checking the username"
        );

        if(token!==state.onboarding.handleCheckToken){
          return state.onboarding.handleAvailable;
        }

        var data=snap.exists?snap.data():null;
        var sameStore=!!(
          data &&
          state.store &&
          clean(data.storeId)===clean(state.store.id)
        );
        var sameOwner=!!(
          data &&
          clean(data.ownerId)===uid()
        );
        var available=!snap.exists||sameStore||sameOwner;

        state.onboarding.lastCheckedHandle=handle;
        state.onboarding.handleAvailable=available;
        el.clikkerOnboardingHandleState.className=
          "ccx-onboarding__handle-state "+(available?"is-success":"is-error");
        el.clikkerOnboardingHandleState.textContent=available
          ? "✓ Username is available"
          : "This username is already taken.";

        return available;
      }catch(error){
        if(token!==state.onboarding.handleCheckToken){
          return state.onboarding.handleAvailable;
        }

        optionalFallbackLog("[Clikker Onboarding] Username pre-check fallback",error);
        state.onboarding.lastCheckedHandle="";
        state.onboarding.handleAvailable=null;
        el.clikkerOnboardingHandleState.className="ccx-onboarding__handle-state";
        el.clikkerOnboardingHandleState.textContent=
          "Username will be verified when you create the store.";
        return null;
      }finally{
        if(token===state.onboarding.handleCheckToken){
          state.onboarding.checkingHandle=false;
        }
      }
    };

    if(immediate)return run();

    return new Promise(function(resolve){
      state.onboarding.handleTimer=setTimeout(function(){
        run().then(resolve);
      },600);
    });
  }

  function validateOnboardingStepOne(){
    var errors=[];
    var name=clean(el.clikkerOnboardingName.value);
    var handle=normalizedOnboardingHandle();
    var category=clean(el.clikkerOnboardingCategory.value);
    var email=clean(el.clikkerOnboardingSupportEmail.value);
    var phone=normalizeOnboardingPhone();
    var bio=clean(el.clikkerOnboardingBio.value);

    if(name.length<2)errors.push("Add your display name.");
    if(handle.length<3)errors.push("Choose a username with at least 3 characters.");
    if(!category)errors.push("Choose your main category.");
    if(!bio||bio.length<12)errors.push("Add a short bio of at least 12 characters.");
    if(email&&!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))errors.push("Enter a valid support email.");
    if(!phone.nationalNumber){
      errors.push("Enter your mobile number.");
    }else if(!validOnboardingPhone(phone)){
      errors.push(
        phone.countryCode==="+91"
          ?"Enter a valid 10-digit Indian mobile number beginning with 6, 7, 8 or 9."
          :"Enter a valid mobile number for the selected country code."
      );
    }
    if(state.onboarding.handleAvailable===false)errors.push("Choose another public username.");

    return errors;
  }

  function validateOnboardingStepTwo(){
    return state.onboarding.selectedType?[]:["Choose one product to continue."];
  }

  function validateOnboardingStepThree(){
    var errors=[];
    var title=clean(el.clikkerOnboardingProductTitle.value);
    var description=clean(el.clikkerOnboardingProductDescription.value);
    var price=Number(el.clikkerOnboardingProductPrice.value||0);

    if(title.length<3)errors.push("Add a product title.");
    if(price<=0)errors.push("Enter a price greater than zero.");
    if(description.length<12)errors.push("Add a short product description.");
    if(state.onboarding.selectedType==="digital_download"&&!state.onboarding.digitalFile){
      errors.push("Upload the digital product file.");
    }
    if(
      el.clikkerOnboardingPublishConfirmation &&
      !el.clikkerOnboardingPublishConfirmation.checked
    ){
      errors.push("Confirm that you want to publish your creator page and first offer.");
    }
    return errors;
  }

  function selectOnboardingProduct(button){
    var type=button.dataset.onboardingProduct;
    var defaults=ONBOARDING_DEFAULTS[type];
    if(!defaults)return;

    state.onboarding.selectedType=type;
    state.onboarding.selectedTemplate=clone(defaults);

    el.clikkerOnboardingProductChoices.querySelectorAll("[data-onboarding-product]").forEach(function(item){
      var selected=item===button;
      item.classList.toggle("is-selected",selected);
      item.setAttribute("aria-checked",selected?"true":"false");
      var status=item.querySelector("[data-selection-status]");
      if(status)status.textContent=selected?"Selected ✓":"Choose";
    });

    el.clikkerOnboardingProductTitle.value=defaults.title;
    el.clikkerOnboardingProductPrice.value=defaults.price;
    el.clikkerOnboardingDeliveryHours.value=String(defaults.deliveryHours);
    el.clikkerOnboardingProductDescription.value=defaults.description;

    ensureOnboardingDigitalFileField(type==="digital_download");
    updateOnboardingOfferPreview();
    clearOnboardingMessage();
  }

  function ensureOnboardingDigitalFileField(show){
    var wrap=el.clikkerOnboardingDigitalFileWrap||byId("clikkerOnboardingDigitalFileWrap");
    var input=el.clikkerOnboardingDigitalFile||byId("clikkerOnboardingDigitalFile");
    if(!wrap)return;

    wrap.hidden=!show;
    wrap.setAttribute("aria-hidden",show?"false":"true");

    if(input){
      input.disabled=!show;
      input.required=!!show;
      input.tabIndex=show?0:-1;
    }

    if(!show){
      if(input)input.value="";
      state.onboarding.digitalFile=null;
      if(el.clikkerOnboardingDigitalFileHelp){
        el.clikkerOnboardingDigitalFileHelp.textContent="Maximum 50 MB. Buyers receive this file after payment.";
      }
    }
  }

  function updateOnboardingOfferPreview(){
    var type=state.onboarding.selectedType||"creator_reply";
    var onboardingDefaults=ONBOARDING_DEFAULTS[type]||{};
    var icon=onboardingDefaults.icon||"✨";
    var cover=clean(onboardingDefaults.defaultCoverImage||workflowDefaultCover(type));
    var title=clean(el.clikkerOnboardingProductTitle.value)||"Your product";
    var price=Number(el.clikkerOnboardingProductPrice.value||0);
    var currency=el.clikkerOnboardingProductCurrency.value||"INR";
    var hours=Number(el.clikkerOnboardingDeliveryHours.value||0);

    if(cover){
      el.clikkerOnboardingOfferIcon.innerHTML=
        '<img src="'+escapeHTML(cover)+
        '" alt="'+escapeHTML(onboardingDefaults.defaultCoverAlt||title)+
        '" loading="eager" decoding="async" style="width:100%;height:100%;object-fit:cover;display:block;border-radius:inherit">';
    }else{
      el.clikkerOnboardingOfferIcon.textContent=icon;
    }
    el.clikkerOnboardingOfferTitle.textContent=title;
    el.clikkerOnboardingOfferPrice.textContent=money(price,currency);
    el.clikkerOnboardingOfferDelivery.textContent=
      hours===0?"Available instantly":
      hours===24?"Delivered within 24 hours":
      hours===48?"Delivered within 48 hours":
      hours===72?"Delivered within 3 days":
      hours===120?"Delivered within 5 days":
      hours===168?"Delivered within 7 days":
      "Delivery time configured";
  }

  async function moveOnboardingStep(direction){
    clearOnboardingMessage();
    var step=Number(state.onboarding.step)||1;
    if(direction>0){
      var errors=step===1?validateOnboardingStepOne():validateOnboardingStepTwo();
      if(errors.length){
        onboardingMessage(errors[0],"error");
        return;
      }
      if(step===1){
        var available=await checkOnboardingHandle(true);
        if(available===false){
          onboardingMessage("That username is already being used. Choose another one.","error");
          return;
        }
      }
      step=Math.min(3,step+1);
    }else{
      step=Math.max(1,step-1);
    }
    state.onboarding.step=step;
    renderOnboardingStep();
    if(step===3)updateOnboardingOfferPreview();
  }

  function onboardingProductPayload(productId,storeId,uploads){
    var type=state.onboarding.selectedType;
    var schema=schemaOf(type);
    var workflow=ProductEngine.getWorkflow(type);
    var defaults=workflow&&workflow.defaults||{};
    var title=clean(el.clikkerOnboardingProductTitle.value);
    var shortDescription=clean(el.clikkerOnboardingProductDescription.value);
    var deliveryHours=Number(el.clikkerOnboardingDeliveryHours.value||0);
    var dailyLimit=Number(el.clikkerOnboardingDailyLimit.value||0);

    var draft=ProductEngine.createProductDraft(type,{
      id:productId,
      ownerId:uid(),
      creatorId:creatorDocumentId(),
      storeId:storeId,
      title:title,
      price:Number(el.clikkerOnboardingProductPrice.value||0),
      currency:el.clikkerOnboardingProductCurrency.value||"INR",
      shortDescription:shortDescription,
      status:"published",
      visibility:"public"
    });

    var product={
      id:productId,
      ownerId:uid(),
      creatorId:creatorDocumentId(),
      storeId:storeId,
      productType:type,
      workflowType:type,
      fulfilmentType:type,
      fulfillmentType:type,
      type:type,
      schemaVersion:Number(
        (ProductEngine.getWorkflowMeta(type)||{}).schemaVersion||1
      ),
      templateId:"quick-onboarding-"+type,
      title:title||clean(draft.title),
      slug:slugify(title||draft.title)+"-"+productId.slice(0,6),
      category:labelOf(type),
      price:Number(draft.price||0),
      currency:clean(draft.currency||"INR")||"INR",
      priceModel:clean(draft.priceModel||defaults.priceModel||"fixed")||"fixed",
      badge:clean(draft.badge||defaults.badge||"none")||"none",
      shortDescription:shortDescription||
        clean(draft.shortDescription||defaults.shortDescription||draft.description),
      description:clean(
        draft.description||
        defaults.description||
        shortDescription
      ),
      customerInstructions:clean(
        draft.customerInstructions||
        defaults.customerInstructions||
        ""
      ),
      deliveryHours:deliveryHours,
      dailyLimit:dailyLimit,
      buyerFields:clone(
        Array.isArray(draft.buyerFields)&&draft.buyerFields.length
          ?draft.buyerFields
          :schema.buyerFields
      ),
      policies:policiesFromWorkflow(type,draft.policies),
      status:"published",
      visibility:"public",
      featured:true,
      sortOrder:1,
      onboardingProduct:true,
      createdAt:serverTimestamp(),
      updatedAt:serverTimestamp(),
      publishedAt:serverTimestamp()
    };

    var fulfilmentValues=
      draft.fulfilment&&typeof draft.fulfilment==="object"
        ?draft.fulfilment
        :{};

    schema.fulfilment.forEach(function(field){
      if(field.input==="file"||field.input==="image")return;
      var value=Object.prototype.hasOwnProperty.call(fulfilmentValues,field.key)
        ?fulfilmentValues[field.key]
        :field.defaultValue;
      product[field.key]=clone(value);
    });

    /*
      Quick onboarding exposes delivery-hours / daily-limit controls.
      Apply those explicit creator choices last where the workflow uses them.
    */
    if(schema.fulfilment.some(function(field){return field.key==="delivery_hours";})){
      product.delivery_hours=deliveryHours;
      product.deliveryHours=deliveryHours;
    }
    if(schema.fulfilment.some(function(field){return field.key==="daily_limit";})){
      product.daily_limit=dailyLimit;
      product.dailyLimit=dailyLimit;
    }

    if(uploads&&uploads.digitalFile){
      product.digitalFile=uploads.digitalFile;
      product.digital_file=uploads.digitalFile;
      product.fulfilmentFiles={digitalFile:uploads.digitalFile};
    }

    return applyWorkflowDefaults(product);
  }


  function setOnboardingBusy(busy,label){
    state.onboarding.saving=busy;
    [
      el.clikkerOnboardingBack,
      el.clikkerOnboardingNext,
      el.clikkerOnboardingCreate
    ].forEach(function(node){
      if(node)node.disabled=busy;
    });
    if(el.clikkerOnboardingCreate){
      el.clikkerOnboardingCreate.textContent=busy?(label||"Creating Your Store…"):"Create My Store";
      el.clikkerOnboardingCreate.setAttribute("aria-busy",busy?"true":"false");
    }
    if(!busy)renderOnboardingStep();
  }

  function setOnboardingStage(message,buttonLabel){
    onboardingMessage(message,"info");
    if(el.clikkerOnboardingCreate&&buttonLabel){
      el.clikkerOnboardingCreate.textContent=buttonLabel;
    }
  }

  async function reserveOnboardingHandle(transaction,handle,storeId){
    var handleRef=db().collection("storeHandles").doc(handle);
    var handleSnap=await transaction.get(handleRef);
    if(handleSnap.exists){
      var existing=handleSnap.data()||{};
      var belongsToSameOwner=clean(existing.ownerId)===uid();
      var belongsToSameStore=clean(existing.storeId)===clean(storeId);
      if(!belongsToSameOwner&&!belongsToSameStore){
        throw new Error("That username was just taken. Please choose another one.");
      }
    }
    transaction.set(handleRef,{
      handle:handle,
      storeId:storeId,
      creatorId:creatorDocumentId(),
      ownerId:uid(),
      status:"active",
      updatedAt:serverTimestamp(),
      createdAt:handleSnap.exists?(handleSnap.data().createdAt||serverTimestamp()):serverTimestamp()
    },{merge:true});
  }

  async function deleteUploadedPath(path){
    path=clean(path);
    if(!path||!window.firebase||!window.firebase.storage)return;
    try{
      await withTimeout(window.firebase.storage().ref(path).delete(),12000,"Cleaning up an incomplete upload");
    }catch(error){
      console.warn("[Clikker Upload Cleanup]",path,error);
    }
  }

  async function rollbackOnboardingUploads(uploads){
    if(!uploads)return;
    var paths=[];
    if(uploads.profileImage&&uploads.profileImage.storagePath)paths.push(uploads.profileImage.storagePath);
    if(uploads.digitalFile&&uploads.digitalFile.storagePath)paths.push(uploads.digitalFile.storagePath);
    await Promise.all(paths.map(deleteUploadedPath));
  }

  async function uploadOnboardingFiles(storeId,productId){
    var result={profileImage:null,digitalFile:null};

    if(state.onboarding.profileImageFile){
      validateFile(state.onboarding.profileImageFile,"image");
      onboardingMessage("Uploading your profile image…","info");
      var profileUpload=await withTimeout(uploadFile(
        state.onboarding.profileImageFile,
        "creator-stores/"+uid()+"/"+storeId+"/profile",
        "profile_image"
      ),TIMEOUTS.upload,"Uploading the profile image");
      result.profileImage={
        downloadURL:profileUpload.downloadURL,
        storagePath:profileUpload.fullPath||profileUpload.storagePath||profileUpload.path||"",
        fileName:state.onboarding.profileImageFile.name,
        type:state.onboarding.profileImageFile.type,
        size:state.onboarding.profileImageFile.size
      };
    }

    if(state.onboarding.digitalFile){
      validateFile(state.onboarding.digitalFile,"file");
      onboardingMessage("Uploading your digital product…","info");
      var digitalUpload=await withTimeout(uploadFile(
        state.onboarding.digitalFile,
        "creator-products/"+uid()+"/"+productId+"/delivery/digitalFile",
        "digital_product"
      ),TIMEOUTS.upload,"Uploading the digital product");
      result.digitalFile={
        downloadURL:digitalUpload.downloadURL,
        storagePath:digitalUpload.fullPath||digitalUpload.storagePath||digitalUpload.path||"",
        fileName:state.onboarding.digitalFile.name,
        type:state.onboarding.digitalFile.type,
        size:state.onboarding.digitalFile.size,
        uploadedAt:new Date().toISOString()
      };
    }

    return result;
  }

  async function verifyOnboardingCreation(handle,storeId){
    try{
      var results=await Promise.all([
        withTimeout(
          db().collection("stores").doc(storeId).get(),
          TIMEOUTS.query,
          "Checking the created store"
        ),
        withTimeout(
          db().collection("storeHandles").doc(handle).get(),
          TIMEOUTS.query,
          "Checking the reserved username"
        )
      ]);

      var storeSnap=results[0];
      var handleSnap=results[1];
      var handleData=handleSnap.exists?handleSnap.data():{};

      return !!(
        storeSnap.exists &&
        handleSnap.exists &&
        clean(handleData.storeId)===clean(storeId) &&
        clean(handleData.ownerId)===uid()
      );
    }catch(error){
      optionalFallbackLog("[Clikker Onboarding] Creation verification fallback",error);
      return false;
    }
  }

  async function createOnboardingStore(){
    if(state.onboarding.saving)return;
    clearOnboardingMessage();

    var errors=validateOnboardingStepThree();
    if(errors.length){
      onboardingMessage(errors[0],"error");
      return;
    }

    var stepOneErrors=validateOnboardingStepOne();
    if(stepOneErrors.length){
      state.onboarding.step=1;
      renderOnboardingStep();
      onboardingMessage(stepOneErrors[0],"error");
      return;
    }

    setOnboardingBusy(true,"Checking Details…");
    var uploads=null;
    var transactionCompleted=false;

    try{
      var handle=normalizedOnboardingHandle();
      var available=await checkOnboardingHandle(true);
      if(available===false)throw new Error("That username is already taken.");

      var creatorId=creatorDocumentId();
      var creatorRef=db().collection("creators").doc(creatorId);
      var userRef=db().collection("users").doc(uid());
      var storeRef=state.store&&state.store.id
        ?db().collection("stores").doc(state.store.id)
        :db().collection("stores").doc();
      var productRef=db().collection("products").doc();

      setOnboardingStage("Preparing your images and files…","Preparing Files…");
      uploads=await uploadOnboardingFiles(storeRef.id,productRef.id);

      var displayName=clean(el.clikkerOnboardingName.value);
      var category=clean(el.clikkerOnboardingCategory.value);
      var supportEmail=clean(el.clikkerOnboardingSupportEmail.value)||firebaseAccountEmail()||clean((window.Clikker.currentFirebaseUser||{}).email||"");
      var phone=normalizeOnboardingPhone();
      var mobile=phone.e164;
      var phoneCountryCode=phone.countryCode;
      var phoneNationalNumber=phone.nationalNumber;
      var bio=clean(el.clikkerOnboardingBio.value);
      var currency=el.clikkerOnboardingProductCurrency.value||"INR";
      var existingStore=storeRaw();
      var profileImageURL=uploads.profileImage
        ?uploads.profileImage.downloadURL
        :(
          creatorRaw().profileImageURL||
          creatorRaw().profileImage||
          existingStore.profileImageURL||
          existingStore.profileImage||
          firebaseAccountPhoto()||
          ""
        );

      setOnboardingStage("Creating your profile, public page and first product…","Creating Store…");

      var transactionPromise=db().runTransaction(async function(transaction){
        await reserveOnboardingHandle(transaction,handle,storeRef.id);

        // Firestore rules v2.5.2+ must allow the immutable self `uid` field
        // together with the onboarding linkage fields below.
        transaction.set(userRef,{
          uid:uid(),
          email:firebaseAccountEmail()||clean((window.Clikker.currentFirebaseUser||{}).email||""),
          name:displayName||firebaseAccountName(),
          authDisplayName:firebaseAccountName(),
          auth_display_name:firebaseAccountName(),
          photoURL:firebaseAccountPhoto(),
          photo_url:firebaseAccountPhoto(),
          googlePhotoURL:firebaseAccountPhoto(),
          google_photo_url:firebaseAccountPhoto(),
          phone:mobile,
          mobile:mobile,
          phoneNumber:mobile,
          phone_number:mobile,
          phoneCountryCode:phoneCountryCode,
          phone_country_code:phoneCountryCode,
          phoneNationalNumber:phoneNationalNumber,
          phone_national_number:phoneNationalNumber,
          role:state.access.role||"creator",
          status:state.access.status||"active",
          creatorId:creatorId,
          creator_id:creatorId,
          storeId:storeRef.id,
          store_id:storeRef.id,
          onboardingStatus:"completed",
          onboarding_status:"completed",
          onboardingCompleted:true,
          onboarding_completed:true,
          onboardingCompletedAt:serverTimestamp(),
          updatedAt:serverTimestamp(),
          updated_at:serverTimestamp()
        },{merge:true});

        transaction.set(creatorRef,{
          ownerId:uid(),
          userId:uid(),
          user_id:uid(),
          displayName:displayName,
          name:displayName,
          handle:handle,
          username:handle,
          category:category,
          bio:bio,
          supportEmail:supportEmail,
          phone:mobile,
          mobile:mobile,
          phoneNumber:mobile,
          phone_number:mobile,
          phoneCountryCode:phoneCountryCode,
          phone_country_code:phoneCountryCode,
          phoneNationalNumber:phoneNationalNumber,
          phone_national_number:phoneNationalNumber,
          phoneVisibility:"private",
          phone_visibility:"private",
          storeId:storeRef.id,
          store_id:storeRef.id,
          profileImageURL:profileImageURL,
          profileImage:profileImageURL,
          googlePhotoURL:firebaseAccountPhoto(),
          google_photo_url:firebaseAccountPhoto(),
          profileImageMeta:
            uploads.profileImage||
            creatorRaw().profileImageMeta||
            null,
          currency:currency,
          status:"active",
          onboardingCompleted:true,
          onboarding_completed:true,
          onboardingCompletedAt:serverTimestamp(),
          updatedAt:serverTimestamp(),
          createdAt:creatorRaw().createdAt||serverTimestamp()
        },{merge:true});

        transaction.set(storeRef,{
          ownerId:uid(),
          creatorId:creatorId,
          storeName:displayName,
          displayName:displayName,
          slug:handle,
          handle:handle,
          tagline:"Welcome to "+displayName+"'s creator store",
          category:category,
          about:bio,
          shortBio:bio,
          currency:currency,
          profileImageURL:profileImageURL,
          profileImage:profileImageURL,
          googlePhotoURL:firebaseAccountPhoto(),
          google_photo_url:firebaseAccountPhoto(),
          profileImageMeta:
            uploads.profileImage||
            existingStore.profileImageMeta||
            null,
          contact:{
            supportEmail:supportEmail,
            businessEmail:"",
            phone:mobile,
            mobile:mobile,
            phoneCountryCode:phoneCountryCode,
            phoneNationalNumber:phoneNationalNumber,
            phoneVisibility:"private",
            whatsappNumber:"",
            responseTime:"Within 24 hours",
            supportHours:"",
            contactFormEnabled:true
          },
          branding:Object.assign({
            primaryColor:"#101828",
            secondaryColor:"#667085",
            buttonColor:"#101828",
            textColor:"#101828",
            storeLayout:"modern",
            productCardStyle:"clean",
            bannerPosition:"center",
            showSocialLinks:true,
            showFollowerCount:false
          },existingStore.branding||{}),
          sections:Object.assign({
            hero:true,
            products:true,
            about:true,
            socials:true,
            achievements:true,
            brands:true,
            testimonials:false,
            faq:false,
            contact:true,
            featuredContent:false
          },existingStore.sections||{}),
          status:"published",
          visibility:"public",
          onboardingStatus:"completed",
          onboarding_status:"completed",
          onboardingCompleted:true,
          onboarding_completed:true,
          onboardingCompletedAt:serverTimestamp(),
          publishedAt:serverTimestamp(),
          updatedAt:serverTimestamp(),
          createdAt:existingStore.createdAt||serverTimestamp()
        },{merge:true});

        transaction.set(productRef,onboardingProductPayload(
          productRef.id,
          storeRef.id,
          uploads
        ));
      });

      try{
        await withTimeout(
          transactionPromise,
          TIMEOUTS.transaction,
          "Creating your creator store"
        );
        transactionCompleted=true;
      }catch(transactionError){
        console.error("[Clikker Onboarding] Firestore transaction failed",{
          code:transactionError&&transactionError.code||"",
          message:transactionError&&transactionError.message||"",
          uid:uid(),
          creatorId:creatorId,
          storeId:storeRef.id,
          productId:productRef.id,
          handle:handle
        });
        if(clean(transactionError&&transactionError.code)!=="clikker/timeout"){
          throw transactionError;
        }

        setOnboardingStage(
          "Store creation is taking longer than expected. Verifying the result…",
          "Checking Store…"
        );

        try{
          await withTimeout(
            transactionPromise,
            15000,
            "Confirming your creator store"
          );
          transactionCompleted=true;
        }catch(confirmError){
          transactionCompleted=await verifyOnboardingCreation(handle,storeRef.id);
          if(!transactionCompleted){
            throw confirmError;
          }
        }
      }

      setOnboardingStage("Publishing your store and preparing the dashboard…","Publishing Store…");
      if(typeof window.Clikker.refreshCurrentContext==="function"){
        try{
          await withTimeout(window.Clikker.refreshCurrentContext(),TIMEOUTS.context,"Refreshing your creator account");
        }catch(contextError){
          optionalFallbackLog("[Clikker Onboarding] Context refresh fallback",contextError);
        }
      }
      var canonicalAfterCreate=await loadCanonicalCreatorContextDirect();
      state.creator=(canonicalAfterCreate&&canonicalAfterCreate.creator)||{
        id:creatorId,
        userId:uid(),
        displayName:displayName,
        handle:handle,
        category:category,
        bio:bio,
        supportEmail:supportEmail,
        phone:mobile,
        mobile:mobile,
        phoneCountryCode:phoneCountryCode,
        phoneNationalNumber:phoneNationalNumber,
        profileImage:profileImageURL,
        storeId:storeRef.id,
        status:"active",
        raw:{
          displayName:displayName,
          handle:handle,
          category:category,
          bio:bio,
          supportEmail:supportEmail,
          phone:mobile,
          mobile:mobile,
          phoneCountryCode:phoneCountryCode,
          phoneNationalNumber:phoneNationalNumber,
          phoneVisibility:"private",
          profileImage:profileImageURL,
          profileImageURL:profileImageURL,
          storeId:storeRef.id,
          onboardingCompleted:true,
          onboarding_completed:true,
          status:"active"
        }
      };
      state.store=(canonicalAfterCreate&&canonicalAfterCreate.store)||Object.assign({
        id:storeRef.id,
        creatorId:creatorId,
        ownerId:uid(),
        storeName:displayName,
        displayName:displayName,
        slug:handle,
        handle:handle,
        category:category,
        about:bio,
        shortBio:bio,
        profileImage:profileImageURL,
        profileImageURL:profileImageURL,
        status:"published",
        visibility:"public",
        onboardingCompleted:true,
        raw:{
          creatorId:creatorId,
          ownerId:uid(),
          slug:handle,
          handle:handle,
          status:"published",
          visibility:"public",
          onboardingCompleted:true,
          onboarding_completed:true
        }
      },storeRaw());

      try{
        await loadProducts();
      }catch(productLoadError){
        optionalFallbackLog("[Clikker Onboarding] Product refresh fallback",productLoadError);
      }

      var publicPath=ROUTES.publicStore+encodeURIComponent(handle);
      el.clikkerOnboardingPublicLink.textContent=location.origin+publicPath;
      el.clikkerOnboardingViewStore.href=publicPath;
      state.onboarding.step="success";
      renderOnboardingStep();
      clearOnboardingMessage();
    }catch(error){
      console.error("[Clikker Onboarding]",error);

      if(transactionCompleted){
        onboardingMessage(
          "Your store was created, but the dashboard could not finish refreshing. Reload this page to continue.",
          "success"
        );
        return;
      }

      if(uploads){
        onboardingMessage("Creation failed. Cleaning up incomplete uploads…","info");
        await rollbackOnboardingUploads(uploads);
      }

      onboardingMessage(
        firebaseMessage(error,"We could not create your store. Please try again."),
        "error"
      );
    }finally{
      setOnboardingBusy(false);
    }
  }

  function openDashboardAfterOnboarding(){
    if(!state.store){
      location.reload();
      return;
    }
    renderUser();
    syncAdminAccessUI();
    showShell();
    renderView("dashboard");
  }

  async function copyOnboardingLink(){
    var value=clean(el.clikkerOnboardingPublicLink.textContent);
    try{
      await navigator.clipboard.writeText(value);
      el.clikkerOnboardingCopyLink.textContent="Copied";
      setTimeout(function(){el.clikkerOnboardingCopyLink.textContent="Copy";},1500);
    }catch(_){
      window.prompt("Copy your store link",value);
    }
  }

  async function loadProducts(showFailure){
    state.products=[];
    if(!state.store||!state.store.id)return;

    var attempts=[
      {
        label:"ownerId",
        query:function(){
          return db().collection("products").where("ownerId","==",uid()).get();
        }
      },
      {
        label:"creatorId",
        query:function(){
          return db().collection("products")
            .where("creatorId","==",creatorDocumentId()).get();
        }
      },
      {
        label:"storeId",
        query:function(){
          return db().collection("products")
            .where("storeId","==",state.store.id).get();
        }
      },
      {
        label:"store_id",
        query:function(){
          return db().collection("products")
            .where("store_id","==",state.store.id).get();
        }
      }
    ];

    var errors=[];
    for(var i=0;i<attempts.length;i++){
      try{
        var snap=await withTimeout(
          attempts[i].query(),
          TIMEOUTS.query,
          "Loading products"
        );

        var rows=snap.docs.map(function(d){
          return Object.assign({id:d.id},d.data());
        });

        /*
          Ownership queries may include products from an older store owned by
          the same creator. Keep only the active store where store information
          is present, while retaining legacy products without a store field.
        */
        state.products=rows.filter(function(product){
          var productStoreId=clean(product.storeId||product.store_id);
          return !productStoreId||productStoreId===clean(state.store.id);
        });

        console.info(
          "[Clikker Products] Loaded",
          state.products.length,
          "using",
          attempts[i].label
        );
        break;
      }catch(error){
        errors.push({query:attempts[i].label,error:error});
      }
    }

    if(!state.products.length&&errors.length===attempts.length){
      var productPermissionOnly=errors.length&&errors.every(function(item){
        return isPermissionError(item&&item.error);
      });
      if(!productPermissionOnly){
        console.warn("[Clikker Products] All queries failed",errors);
      }
      if(showFailure){
        if(el.clikkerQuickOnboarding&&!el.clikkerQuickOnboarding.hidden){
          onboardingMessage(
            "Your store is available, but products could not be refreshed right now.",
            "info"
          );
        }else{
          showAlert(
            "Products could not be loaded right now. Please refresh and try again.",
            "error"
          );
        }
      }
    }

    state.products.sort(function(a,b){
      var aArchived=isArchivedProduct(a)?1:0;
      var bArchived=isArchivedProduct(b)?1:0;
      if(aArchived!==bArchived)return aArchived-bArchived;

      return Number(a.sortOrder||a.sort_order||999)-
        Number(b.sortOrder||b.sort_order||999);
    });
  }

  function renderUser(){
    var user=window.Clikker.currentFirebaseUser||{};
    var raw=(state.creator&&state.creator.raw)||{};
    var storeRawData=(state.store&&state.store.raw)||{};
    var name=clean(
      (state.creator&&state.creator.displayName)||
      raw.displayName||
      raw.name||
      user.displayName||
      "Creator"
    );
    var image=clean(
      (state.creator&&state.creator.profileImage)||
      raw.profileImageURL||
      raw.profileImage||
      raw.photoURL||
      (state.store&&state.store.profileImage)||
      storeRawData.profileImageURL||
      storeRawData.profileImage||
      user.photoURL||
      firebaseAccountPhoto()||
      (firebaseProviderData("google.com")&&firebaseProviderData("google.com").photoURL)||
      ""
    );

    el.clikkerCreatorUserName.textContent=name;
    el.clikkerCreatorUserEmail.textContent=user.email||"";
    el.clikkerCreatorUserAvatar.innerHTML=image
      ? '<img src="'+escapeHTML(image)+'" alt="'+escapeHTML(name)+'">'
      : escapeHTML(name.charAt(0).toUpperCase());
  }

  function setHeader(title,subtitle,actions){
    el.clikkerCreatorPageTitle.textContent=title;
    el.clikkerCreatorPageSubtitle.textContent=subtitle;
    el.clikkerCreatorTopbarActions.innerHTML=actions||"";
  }

  function normalizeView(view){
    return ["dashboard","products","orders","payouts","store","settings"].indexOf(view)>=0
      ? view
      : "dashboard";
  }

  function syncViewURL(view){
    try{
      var url=new URL(location.href);

      /*
        Shopify reserves the "view" query parameter for alternate templates.
        Using it causes a full-page refresh to render the default Shopify page.
        "panel" is safe for Clikker's internal dashboard routing.
      */
      url.searchParams.delete("view");
      url.searchParams.delete("creator");

      if(view==="dashboard"){
        url.searchParams.delete("panel");
      }else{
        url.searchParams.set("panel",view);
      }

      history.replaceState(
        {panel:view},
        "",
        url.pathname+url.search+url.hash
      );
    }catch(_){}
  }

  function renderView(view){
    view=normalizeView(view);
    state.currentView=view;
    syncViewURL(view);

    el.clikkerCreatorNavigation.querySelectorAll("[data-view]").forEach(function(btn){
      btn.classList.toggle("is-active",btn.dataset.view===view);
      if(btn.dataset.view===view)btn.setAttribute("aria-current","page");
      else btn.removeAttribute("aria-current");
    });

    if(el.clikkerStoreEditor&&view!=="store")el.clikkerStoreEditor.hidden=true;

    if(view==="products")renderProducts();
    else if(view==="orders")renderOrders();
    else if(view==="payouts")renderPayouts();
    else if(view==="store")renderStore();
    else if(view==="settings")renderSettings();
    else renderDashboard();

    el.clikkerCreatorSidebar.classList.remove("is-open");
    window.scrollTo({top:0,behavior:"auto"});
  }

  function stat(label,value,note){
    return '<div class="ccx-stat"><span>'+escapeHTML(label)+'</span><strong>'+escapeHTML(value)+'</strong><small>'+escapeHTML(note)+'</small></div>';
  }

  function productStatus(p){
    return clean(p&&p.status||"draft").toLowerCase()||"draft";
  }

  function isArchivedProduct(p){
    return productStatus(p)==="archived";
  }

  function activeProducts(){
    return state.products.filter(function(product){
      return !isArchivedProduct(product);
    });
  }

  function productCounts(){
    var counts={
      all:0,
      published:0,
      draft:0,
      archived:0
    };

    state.products.forEach(function(product){
      var status=productStatus(product);
      if(status==="archived"){
        counts.archived++;
        return;
      }

      counts.all++;
      if(status==="published")counts.published++;
      else counts.draft++;
    });

    return counts;
  }

  function filteredProducts(){
    var filter=clean(state.productFilter||"all").toLowerCase();
    if(["all","published","draft","archived"].indexOf(filter)<0){
      filter="all";
      state.productFilter="all";
    }

    return state.products.filter(function(product){
      var status=productStatus(product);

      if(filter==="archived")return status==="archived";
      if(status==="archived")return false;
      if(filter==="published")return status==="published";
      if(filter==="draft")return status!=="published";
      return true;
    });
  }

  function productFilterButton(key,label,count){
    var active=state.productFilter===key;
    return '<button type="button" data-product-filter="'+escapeHTML(key)+
      '" class="'+(active?'is-active':'')+'" role="tab" aria-selected="'+
      (active?'true':'false')+'">'+escapeHTML(label)+
      ' <span>'+Number(count||0)+'</span></button>';
  }

  function productRow(p){
    var type=typeOf(p);
    var status=productStatus(p);
    var archived=status==="archived";

    var action=archived
      ? '<button class="ccx-btn ccx-btn--secondary" type="button" data-restore-product="'+
          escapeHTML(p.id)+'">Restore</button>'
      : '<button class="ccx-btn ccx-btn--secondary" type="button" data-edit-product="'+
          escapeHTML(p.id)+'">Configure</button>';

    return '<div class="ccx-product-row" data-product-status="'+escapeHTML(status)+'">'+
      '<span class="ccx-product-row__icon ccx-product-row__cover">'+
        productCoverMarkup(p,{
          className:"ccx-product-row__cover-image",
          extra:'style="width:100%;height:100%;object-fit:cover;display:block;border-radius:inherit"'
        })+
      '</span>'+
      '<div><h4>'+escapeHTML(p.title||"Untitled product")+'</h4>'+
      '<div class="ccx-product-row__meta">'+
      '<span>'+escapeHTML(money(p.price,p.currency||"INR"))+'</span>'+
      '<span>'+escapeHTML(labelOf(type))+'</span>'+
      '<span>'+escapeHTML(status)+'</span>'+
      '</div></div>'+
      '<div class="ccx-product-row__actions">'+action+'</div>'+
      '</div>';
  }


  function renderDashboard(){
    clearAlert();

    var dashboardProducts=activeProducts();
    var published=dashboardProducts.filter(function(product){
      return productStatus(product)==="published";
    }).length;
    var drafts=Math.max(0,dashboardProducts.length-published);
    var publicURL=state.store.slug
      ? "/pages/c?creator="+encodeURIComponent(state.store.slug)
      : "";
    var absolutePublicURL=publicURL
      ? new URL(publicURL,window.location.origin).href
      : "";
    var storeIsLive=clean(state.store.status).toLowerCase()==="published" &&
      clean(state.store.visibility).toLowerCase()==="public";

    setHeader(
      "Home",
      "Your Clikker store at a glance",
      ""
    );

    var shareCard=publicURL
      ? '<section class="ccx-share-store '+(storeIsLive?'is-live':'is-private')+'">'+
          '<div class="ccx-share-store__content">'+
            '<div class="ccx-share-store__status">'+
              '<span class="ccx-share-store__dot" aria-hidden="true"></span>'+
              '<span>'+(storeIsLive?'Your store is live':'Your store link is ready')+'</span>'+
            '</div>'+
            '<h2>'+(storeIsLive?'Your creator store is ready to grow':'Preview and prepare your store')+'</h2>'+
            '<p>'+(storeIsLive
              ?'Share your public link with followers, customers and brands to start receiving orders.'
              :'Your store is not publicly visible yet. Preview it, make changes and publish when ready.')+'</p>'+
            '<div class="ccx-share-store__link" title="'+escapeHTML(absolutePublicURL)+'">'+
              '<span class="ccx-share-store__link-icon" aria-hidden="true">↗</span>'+
              '<code>'+escapeHTML(absolutePublicURL)+'</code>'+
            '</div>'+
          '</div>'+
          '<div class="ccx-share-store__actions">'+
            '<button class="ccx-btn ccx-btn--primary ccx-share-store__primary" type="button" data-share-store>'+
              '<span class="ccx-share-store__button-icon" aria-hidden="true">↗</span><span>Share Store</span>'+
            '</button>'+
            '<div class="ccx-share-store__secondary-actions">'+
              '<button class="ccx-share-store__mini-action" type="button" data-copy-store-link>'+
                '<span aria-hidden="true">⧉</span><span>Copy link</span>'+
              '</button>'+
              '<a class="ccx-share-store__mini-action" target="_blank" rel="noopener" href="'+publicURL+'&preview=1">'+
                '<span aria-hidden="true">◉</span><span>Preview</span>'+
              '</a>'+
              '<button class="ccx-share-store__mini-action" type="button" data-go-view="store">'+
                '<span aria-hidden="true">✎</span><span>Edit store</span>'+
              '</button>'+
            '</div>'+
          '</div>'+
        '</section>'
      : '<section class="ccx-share-store is-private">'+
          '<div class="ccx-share-store__content">'+
            '<div class="ccx-share-store__status"><span class="ccx-share-store__dot" aria-hidden="true"></span><span>Complete your store</span></div>'+
            '<h2>Create your shareable store link</h2>'+
            '<p>Finish your public profile and publish your store before sharing it with your audience.</p>'+
          '</div>'+
          '<div class="ccx-share-store__actions">'+
            '<button class="ccx-btn ccx-btn--primary" type="button" data-go-view="store">Finish Store</button>'+
          '</div>'+
        '</section>';

    el.clikkerCreatorView.innerHTML=
      shareCard+
      '<div class="ccx-stats ccx-block--spaced">'+
        stat("Store",titleCase(state.store.status||"draft"),state.store.visibility==="public"?"Visible to everyone":"Not publicly visible")+
        stat("Products",dashboardProducts.length,published+" published")+
        stat("New orders",state.orders.filter(function(order){return orderStatusKey(order)==="new";}).length,"Paid and waiting")+
        stat("Paid orders",state.orders.length,state.orders.filter(function(order){return orderStatusKey(order)==="delivered";}).length+" delivered")+
        stat("Public link",state.store.slug?"@"+state.store.slug:"Not created",state.store.slug?"Ready to share":"Complete your profile")+
      '</div>'+
      '<section class="ccx-card ccx-block--spaced">'+
        '<div class="ccx-card__head">'+
          '<div><h2>Recent products</h2><p>Continue editing your offers or add another product.</p></div>'+
          '<button class="ccx-btn ccx-btn--primary" type="button" data-go-view="products">Manage Products</button>'+
        '</div>'+
        '<div class="ccx-card__body">'+
          (dashboardProducts.length
            ? '<div class="ccx-product-list">'+dashboardProducts.slice(0,5).map(productRow).join("")+'</div>'
            : '<div class="ccx-empty"><h3>Add your first product</h3><p>Choose a ready product type and customise its price, delivery and buyer questions.</p><button class="ccx-btn ccx-btn--primary ccx-block--spaced" type="button" data-go-view="products">Add Product</button></div>')+
        '</div>'+
      '</section>';

    el.clikkerCreatorView.querySelectorAll("[data-go-view]").forEach(function(button){
      button.onclick=function(){renderView(button.dataset.goView);};
    });

    document.querySelectorAll("[data-share-store]").forEach(function(button){
      button.onclick=async function(){
        if(!absolutePublicURL)return;

        var shareTitle=clean(
          state.store.storeName ||
          state.store.displayName ||
          (state.creator&&state.creator.displayName) ||
          "My Clikker Store"
        );

        try{
          if(navigator.share){
            await navigator.share({
              title:shareTitle,
              text:"Visit my Clikker store",
              url:absolutePublicURL
            });
            return;
          }

          if(navigator.clipboard&&window.isSecureContext){
            await navigator.clipboard.writeText(absolutePublicURL);
            var original=button.textContent;
            button.textContent="Link Copied";
            setTimeout(function(){button.textContent=original;},1500);
            return;
          }

          window.prompt("Copy your store link",absolutePublicURL);
        }catch(error){
          if(error&&error.name==="AbortError")return;
          console.warn("[Clikker Share Store]",error);
          window.prompt("Copy your store link",absolutePublicURL);
        }
      };
    });

    var copyLinkButton=el.clikkerCreatorView.querySelector("[data-copy-store-link]");
    if(copyLinkButton){
      copyLinkButton.onclick=async function(){
        if(!absolutePublicURL)return;

        try{
          if(navigator.clipboard&&window.isSecureContext){
            await navigator.clipboard.writeText(absolutePublicURL);
            copyLinkButton.textContent="Copied";
            copyLinkButton.classList.add("is-copied");
            setTimeout(function(){
              copyLinkButton.textContent="Copy Link";
              copyLinkButton.classList.remove("is-copied");
            },1500);
            return;
          }

          window.prompt("Copy your store link",absolutePublicURL);
        }catch(error){
          console.warn("[Clikker Copy Store Link]",error);
          window.prompt("Copy your store link",absolutePublicURL);
        }
      };
    }
bindProductButtons();
  }

  function productTemplateCard(template){
    var cover=clean(template.defaultCoverImage||workflowDefaultCover(template.type));
    var media=cover
      ? '<div class="ccx-product-template__cover"><img src="'+escapeHTML(cover)+
          '" alt="'+escapeHTML(template.defaultCoverAlt||template.title)+
          '" loading="lazy" decoding="async" style="width:100%;height:100%;object-fit:cover;display:block;border-radius:inherit"></div>'
      : '<div class="ccx-product-row__icon" aria-hidden="true">'+escapeHTML(template.icon)+'</div>';

    return '<article class="ccx-store-section ccx-product-template-card">'+
      media+
      '<h3>'+escapeHTML(template.title)+'</h3>'+
      '<p class="ccx-help-copy">'+escapeHTML(template.description)+'</p>'+
      '<button class="ccx-btn ccx-btn--primary ccx-block--spaced" type="button" data-add-template="'+escapeHTML(template.id)+'">Add Product</button>'+
    '</article>';
  }

  function renderProducts(){
    clearAlert();

    var counts=productCounts();
    var visibleProducts=filteredProducts();
    var showingArchived=state.productFilter==="archived";

    setHeader(
      "Products",
      "Create and manage what you sell",
      '<button id="addProductButton" class="ccx-btn ccx-btn--primary" type="button">Add Product</button>'
    );

    var filters=
      '<div class="ccx-orders__filters ccx-product-filters" role="tablist" aria-label="Filter products">'+
        productFilterButton("all","All",counts.all)+
        productFilterButton("published","Published",counts.published)+
        productFilterButton("draft","Drafts",counts.draft)+
        productFilterButton("archived","Archived",counts.archived)+
      '</div>';

    var emptyState=showingArchived
      ? '<div class="ccx-empty"><h3>No archived products</h3><p>Products you archive will be kept here and can be restored later.</p></div>'
      : state.productFilter==="published"
        ? '<div class="ccx-empty"><h3>No published products</h3><p>Publish a draft when you are ready to make it available on your store.</p></div>'
        : state.productFilter==="draft"
          ? '<div class="ccx-empty"><h3>No drafts</h3><p>New unpublished products will appear here.</p></div>'
          : '<div class="ccx-empty"><h3>No active products yet</h3><p>Select Add Product to create your first offer.</p></div>';

    el.clikkerCreatorView.innerHTML=
      '<section id="productLibrary" class="ccx-card" hidden>'+
        '<div class="ccx-card__head"><div><h2>Choose a product</h2><p>Start with a ready template, then customise it.</p></div></div>'+
        '<div class="ccx-card__body"><div class="ccx-grid ccx-grid--3">'+
          PRODUCT_TEMPLATES.map(productTemplateCard).join("")+
        '</div></div>'+
      '</section>'+
      '<section class="ccx-card ccx-block--spaced">'+
        '<div class="ccx-card__head">'+
          '<div><h2>'+(
            showingArchived
              ?'Archived products'
              :'Your products'
          )+'</h2><p>'+(
            showingArchived
              ?'Archived offers are private and unavailable for new purchases. Restore one to continue editing it.'
              :'Manage pricing, delivery, buyer questions and publishing.'
          )+'</p></div>'+
        '</div>'+
        '<div class="ccx-card__body">'+
          filters+
          '<div class="ccx-block--spaced">'+
            (visibleProducts.length
              ? '<div class="ccx-product-list">'+visibleProducts.map(productRow).join("")+'</div>'
              : emptyState)+
          '</div>'+
        '</div>'+
      '</section>';

    var addButton=byId("addProductButton");
    var library=byId("productLibrary");

    if(addButton&&library){
      addButton.onclick=function(){
        library.hidden=!library.hidden;
        addButton.textContent=library.hidden?"Add Product":"Close Library";
        if(!library.hidden)library.scrollIntoView({behavior:"smooth",block:"start"});
      };
    }

    el.clikkerCreatorView.querySelectorAll("[data-product-filter]").forEach(function(button){
      button.onclick=function(){
        state.productFilter=clean(button.dataset.productFilter||"all").toLowerCase();
        renderProducts();
      };
    });

    document.querySelectorAll("[data-add-template]").forEach(function(button){
      button.onclick=function(){createProduct(button.dataset.addTemplate);};
    });

    bindProductButtons();
  }


  function bindProductButtons(){
    document.querySelectorAll("[data-edit-product]").forEach(function(btn){
      btn.onclick=function(){
        openProductEditor(btn.dataset.editProduct);
      };
    });

    document.querySelectorAll("[data-restore-product]").forEach(function(btn){
      btn.onclick=function(){
        restoreProduct(btn.dataset.restoreProduct);
      };
    });
  }

  async function restoreProduct(productId){
    productId=clean(productId);
    if(!productId)return;

    var product=state.products.find(function(item){
      return clean(item.id)===productId;
    });

    if(!product||!isArchivedProduct(product))return;

    if(!confirm(
      'Restore "'+(product.title||"this product")+'"? It will return as a private draft and will not be published automatically.'
    )){
      return;
    }

    btnBusyProduct(productId,true);

    try{
      await db().collection("products").doc(productId).set({
        status:"draft",
        visibility:"private",
        restoredAt:serverTimestamp(),
        updatedAt:serverTimestamp()
      },{merge:true});

      await loadProducts();
      state.productFilter="draft";
      renderProducts();
      showAlert(
        '"'+(product.title||"Product")+'" was restored as a draft. Configure it when you are ready.',
        "success"
      );
    }catch(error){
      showAlert(
        firebaseMessage(error,"Unable to restore this product right now."),
        "error"
      );
    }finally{
      btnBusyProduct(productId,false);
    }
  }

  function btnBusyProduct(productId,busy){
    document.querySelectorAll(
      '[data-restore-product="'+String(productId).replace(/"/g,'\\"')+'"]'
    ).forEach(function(button){
      button.disabled=busy;
      button.textContent=busy?"Restoring…":"Restore";
    });
  }

  function workflowDefaults(type){
    var workflow=ProductEngine.getWorkflow(type);
    return workflow&&workflow.defaults?clone(workflow.defaults):{};
  }

  function workflowTerms(type){
    var defaults=workflowDefaults(type);
    return defaults&&defaults.terms&&typeof defaults.terms==="object"
      ?clone(defaults.terms)
      :{};
  }

  function policiesFromWorkflow(type,existing){
    var base=defaultPolicies();
    var terms=workflowTerms(type);
    var current=existing&&typeof existing==="object"?clone(existing):{};

    Object.keys(base).forEach(function(key){
      var fromCurrent=current[key];
      var fromWorkflow=clean(terms[key]);

      if(fromCurrent&&typeof fromCurrent==="object"){
        base[key]={
          enabled:fromCurrent.enabled!==false,
          text:clean(fromCurrent.text)||fromWorkflow||base[key].text
        };
      }else if(fromWorkflow){
        base[key]={enabled:true,text:fromWorkflow};
      }
    });

    return base;
  }

  function applyWorkflowDefaults(product){
    product=clone(product||{});
    var type=typeOf(product);
    var workflow=ProductEngine.getWorkflow(type);
    if(!workflow)return product;

    var defaults=workflow.defaults||{};
    var schema=schemaOf(type);

    function fill(key,value){
      if(value===undefined||value===null||value==="")return;
      if(
        product[key]===undefined||
        product[key]===null||
        product[key]===""
      ){
        product[key]=clone(value);
      }
    }

    fill("title",defaults.title);
    fill("shortDescription",defaults.shortDescription||defaults.description);
    fill("description",defaults.description);
    fill("customerInstructions",defaults.customerInstructions);
    fill("currency",defaults.currency||"INR");
    fill("priceModel",defaults.priceModel||"fixed");
    fill("badge",defaults.badge||"none");

    if(
      !Number.isFinite(Number(product.price))||
      Number(product.price)<=0
    ){
      product.price=Number(defaults.price||0);
    }

    if(!Array.isArray(product.buyerFields)||!product.buyerFields.length){
      product.buyerFields=clone(schema.buyerFields);
    }

    product.policies=policiesFromWorkflow(type,product.policies);

    /*
      Workflow cover is a display fallback, not creator product data.
      Keep only creator-uploaded cover fields in Firestore.
    */
    delete product.defaultCoverImage;
    delete product.default_cover_image;

    schema.fulfilment.forEach(function(field){
      if(field.input==="file"||field.input==="image")return;
      if(
        product[field.key]===undefined||
        product[field.key]===null||
        product[field.key]===""
      ){
        product[field.key]=clone(field.defaultValue);
      }
    });

    return product;
  }

  function createProduct(templateId){
    var t=PRODUCT_TEMPLATES.find(function(item){return item.id===templateId;});
    if(!t)return;

    var workflow=ProductEngine.getWorkflow(t.type);
    var schema=schemaOf(t.type);
    var draft=ProductEngine.createProductDraft(t.type,{
      id:"temp_"+Date.now()+"_"+Math.random().toString(36).slice(2,8),
      ownerId:uid(),
      creatorId:state.creator.id,
      storeId:state.store.id,
      templateId:t.id,
      category:t.category,
      status:"draft",
      visibility:"private",
      featured:false,
      sortOrder:state.products.length+1
    });

    /*
      Keep the proven flat Firestore product structure while preserving all
      rich defaults supplied by Engine/Workflows 1.2.2.
    */
    var product={
      id:draft.id,
      ownerId:uid(),
      creatorId:state.creator.id,
      storeId:state.store.id,
      templateId:t.id,
      productType:t.type,
      workflowType:t.type,
      fulfilmentType:t.type,
      fulfillmentType:t.type,
      type:t.type,
      schemaVersion:Number((workflow&&workflow.meta.schemaVersion)||1),
      title:clean(draft.title||t.title),
      category:t.category,
      price:Number(draft.price||t.price||0),
      currency:clean(draft.currency||"INR")||"INR",
      priceModel:clean(draft.priceModel||"fixed")||"fixed",
      badge:clean(draft.badge||"none")||"none",
      status:"draft",
      visibility:"private",
      featured:false,
      sortOrder:state.products.length+1,
      shortDescription:clean(
        draft.shortDescription||
        draft.short_description||
        draft.description||
        t.description
      ),
      description:clean(draft.description||t.description),
      customerInstructions:clean(draft.customerInstructions||""),
      buyerFields:clone(
        Array.isArray(draft.buyerFields)&&draft.buyerFields.length
          ?draft.buyerFields
          :schema.buyerFields
      ),
      policies:policiesFromWorkflow(t.type,draft.policies)
    };

    var fulfilmentValues=
      draft.fulfilment&&typeof draft.fulfilment==="object"
        ?draft.fulfilment
        :{};

    schema.fulfilment.forEach(function(field){
      if(field.input==="file"||field.input==="image")return;

      var value=Object.prototype.hasOwnProperty.call(fulfilmentValues,field.key)
        ?fulfilmentValues[field.key]
        :field.defaultValue;

      product[field.key]=clone(value);
    });

    product=applyWorkflowDefaults(product);
    delete product.defaultCoverImage;
    delete product.default_cover_image;
    openProductEditor(product,{isNew:true});
  }

  function defaultPolicies(){
    return {
      refund:{enabled:true,text:"Refunds are considered only when the creator cannot deliver."},
      cancellation:{enabled:true,text:"Cancellation rules apply according to the stated notice period."},
      rescheduling:{enabled:true,text:"One reschedule may be allowed before the notice period."},
      revision:{enabled:true,text:"Only the stated number of revisions is included."},
      usage:{enabled:true,text:"Delivered content may not be redistributed or resold without permission."},
      custom:{enabled:true,text:"The creator may reject unsafe, unlawful or out-of-scope requests."}
    };
  }


  function payoutTimestamp(value){
    if(!value)return 0;
    if(typeof value.toMillis==="function")return value.toMillis();
    if(typeof value.toDate==="function")return value.toDate().getTime();
    var parsed=Date.parse(value);
    return Number.isFinite(parsed)?parsed:0;
  }

  function payoutDate(value){
    var ms=payoutTimestamp(value);
    if(!ms)return "—";
    try{
      return new Intl.DateTimeFormat("en-IN",{
        day:"2-digit",
        month:"short",
        year:"numeric"
      }).format(new Date(ms));
    }catch(_){
      return new Date(ms).toLocaleDateString();
    }
  }

  function payoutStatusLabel(value){
    var key=clean(value||"pending").toLowerCase();
    var labels={
      pending:"Pending",
      processing:"Processing",
      queued:"Queued",
      paid:"Paid",
      completed:"Paid",
      failed:"Failed",
      cancelled:"Cancelled",
      reversed:"Reversed"
    };
    return labels[key]||titleCase(key.replace(/_/g," "));
  }

  function payoutStatusClass(value){
    var key=clean(value||"pending").toLowerCase();
    if(key==="paid"||key==="completed")return "ccx-badge ccx-badge--success";
    if(key==="failed"||key==="cancelled"||key==="reversed")return "ccx-badge ccx-badge--danger";
    return "ccx-badge ccx-badge--warning";
  }

  function payoutCreatorRaw(){
    return state.creator&&state.creator.raw||{};
  }

  function payoutProfileFromContext(){
    var raw=payoutCreatorRaw();
    return state.payoutProfile||
      raw.payoutProfile||
      raw.payout_profile||
      raw.payoutAccount||
      raw.payout_account||
      null;
  }

  function payoutSummary(){
    var raw=payoutCreatorRaw();
    var summary=raw.payoutSummary||raw.payout_summary||{};
    var payouts=state.payouts||[];
    var paid=payouts.filter(function(item){
      var status=clean(item.status).toLowerCase();
      return status==="paid"||status==="completed";
    });
    var processing=payouts.filter(function(item){
      var status=clean(item.status).toLowerCase();
      return status==="pending"||status==="processing"||status==="queued";
    });

    return {
      available:Number(summary.availableBalance||summary.available_balance||0),
      pending:Number(summary.pendingBalance||summary.pending_balance||
        processing.reduce(function(total,item){return total+Number(item.amount||item.netAmount||0);},0)),
      totalPaid:Number(summary.totalPaid||summary.total_paid||
        paid.reduce(function(total,item){return total+Number(item.amount||item.netAmount||0);},0)),
      nextDate:summary.nextPayoutAt||summary.next_payout_at||null,
      nextAmount:Number(summary.nextPayoutAmount||summary.next_payout_amount||0),
      currency:clean(summary.currency||"INR")||"INR"
    };
  }

  async function queryCreatorCollection(collectionName){
    var creatorId=creatorDocumentId();
    var attempts=[
      db().collection(collectionName).where("creatorId","==",creatorId),
      db().collection(collectionName).where("creator_id","==",creatorId),
      db().collection(collectionName).where("ownerId","==",uid())
    ];
    var lastError=null;

    for(var i=0;i<attempts.length;i++){
      try{
        var snap=await withTimeout(
          attempts[i].limit(100).get(),
          TIMEOUTS.query,
          "Loading payout information"
        );
        return snap.docs.map(function(doc){
          return Object.assign({id:doc.id},doc.data());
        });
      }catch(error){
        lastError=error;
      }
    }

    if(lastError)throw lastError;
    return [];
  }

  async function loadPayouts(showFailure){
    if(state.payoutsLoading)return;
    state.payoutsLoading=true;

    try{
      var results=await Promise.all([
        queryCreatorCollection("creatorPayouts").catch(function(error){
          optionalFallbackLog("[Clikker Payouts] Payout history fallback",error);
          return [];
        }),
        queryCreatorCollection("creatorLedger").catch(function(error){
          optionalFallbackLog("[Clikker Payouts] Ledger fallback",error);
          return [];
        })
      ]);

      state.payouts=results[0]||[];
      state.payoutTransactions=results[1]||[];

      state.payouts.sort(function(a,b){
        return payoutTimestamp(b.processedAt||b.paidAt||b.createdAt)-
          payoutTimestamp(a.processedAt||a.paidAt||a.createdAt);
      });

      state.payoutTransactions.sort(function(a,b){
        return payoutTimestamp(b.createdAt||b.paidAt)-
          payoutTimestamp(a.createdAt||a.paidAt);
      });
    }catch(error){
      optionalFallbackLog("[Clikker Payouts] Load fallback",error);
      if(showFailure)showPayoutAlert(
        firebaseMessage(error,"Payout information could not be loaded. Please refresh and try again."),
        "error"
      );
    }finally{
      state.payoutsLoading=false;
    }
  }

  function payoutRow(item){
    var amount=Number(item.amount||item.netAmount||item.net_amount||0);
    var currency=clean(item.currency||"INR")||"INR";
    var reference=clean(item.reference||item.referenceId||item.providerPayoutId||item.id);
    var destination=clean(item.destinationLabel||item.accountLast4||item.upiMasked||"Creator payout");

    return '<article class="ccx-payout-row">'+
      '<div>'+
        '<h4>'+escapeHTML(reference||"Payout")+'</h4>'+
        '<p>'+escapeHTML(payoutDate(item.processedAt||item.paidAt||item.createdAt))+
        ' · '+escapeHTML(destination)+'</p>'+
      '</div>'+
      '<div class="ccx-payout-row__amount">'+
        '<strong>'+escapeHTML(money(amount,currency))+'</strong>'+
        '<span class="'+payoutStatusClass(item.status)+'">'+escapeHTML(payoutStatusLabel(item.status))+'</span>'+
      '</div>'+
    '</article>';
  }

  function transactionRow(item){
    var gross=Number(item.grossAmount||item.gross_amount||item.amount||0);
    var fees=Number(item.feeAmount||item.fees||item.platformFee||0);
    var net=Number(item.netAmount||item.net_amount||(gross-fees));
    var currency=clean(item.currency||"INR")||"INR";

    return '<tr>'+
      '<td>'+escapeHTML(payoutDate(item.createdAt||item.paidAt))+'</td>'+
      '<td>'+escapeHTML(item.reference||item.orderName||item.orderId||"—")+'</td>'+
      '<td>'+escapeHTML(item.description||item.productTitle||item.type||"Creator earning")+'</td>'+
      '<td>'+escapeHTML(money(gross,currency))+'</td>'+
      '<td>'+escapeHTML(money(fees,currency))+'</td>'+
      '<td><strong>'+escapeHTML(money(net,currency))+'</strong></td>'+
      '<td><span class="'+payoutStatusClass(item.status)+'">'+escapeHTML(payoutStatusLabel(item.status))+'</span></td>'+
    '</tr>';
  }

  function showPayoutAlert(message,type){
    var node=byId("clikkerPayoutAlert")||byId("clikkerPayoutAccountMessage");
    if(!node)return;
    node.className="ccx-alert is-visible ccx-alert--"+(type||"info");
    node.textContent=message;
  }

  function clearPayoutAlerts(){
    ["clikkerPayoutAlert","clikkerPayoutAccountMessage"].forEach(function(id){
      var node=byId(id);
      if(node){
        node.className="ccx-alert";
        node.textContent="";
      }
    });
  }

  function togglePayoutMethod(){
    var methodNode=byId("clikkerPayoutMethod");
    var method=methodNode?methodNode.value:"bank";
    var bankFields=byId("clikkerPayoutBankFields");
    var upiFields=byId("clikkerPayoutUpiFields");
    if(bankFields)bankFields.hidden=method!=="bank";
    if(upiFields)upiFields.hidden=method!=="upi";
  }

  function populatePayoutProfile(){
    var profile=payoutProfileFromContext()||{};
    var method=clean(profile.method||"bank")||"bank";

    setValue("clikkerPayoutMethod",method);
    setValue("clikkerPayoutAccountHolder",profile.accountHolderName||profile.account_holder_name||"");
    setValue("clikkerPayoutBankName",profile.bankName||profile.bank_name||"");
    setValue("clikkerPayoutIfsc",profile.ifsc||profile.ifscCode||"");
    setValue("clikkerPayoutUpi",profile.upiId||profile.upi_id||"");

    var accountInput=byId("clikkerPayoutAccountNumber");
    var confirmInput=byId("clikkerPayoutAccountNumberConfirm");
    if(accountInput){
      accountInput.value="";
      accountInput.placeholder=profile.accountLast4
        ?"Account ending "+profile.accountLast4
        :"Bank account number";
    }
    if(confirmInput)confirmInput.value="";

    var panInput=byId("clikkerPayoutPan");
    if(panInput){
      panInput.value="";
      panInput.placeholder=profile.panLast4
        ?"PAN ending "+profile.panLast4
        :"ABCDE1234F";
    }

    var confirmation=byId("clikkerPayoutDetailsConfirmation");
    if(confirmation)confirmation.checked=false;

    var status=clean(profile.status||"not_connected");
    var statusNode=byId("clikkerPayoutAccountStatus");
    if(statusNode){
      statusNode.textContent=status==="verified"
        ?"Verified"
        :status==="pending_verification"
        ?"Pending verification"
        :"Account not connected";
      statusNode.className=status==="verified"
        ?"ccx-badge ccx-badge--success"
        :"ccx-badge ccx-badge--warning";
    }

    togglePayoutMethod();
  }

  function renderPayoutContent(){
    var summary=payoutSummary();
    var setText=function(id,value){
      var node=byId(id);
      if(node)node.textContent=value;
    };

    setText("clikkerPayoutAvailableBalance",money(summary.available,summary.currency));
    setText("clikkerPayoutPendingBalance",money(summary.pending,summary.currency));
    setText("clikkerPayoutTotalPaid",money(summary.totalPaid,summary.currency));
    setText("clikkerPayoutNextDate",summary.nextDate?payoutDate(summary.nextDate):"Not scheduled");
    setText("clikkerPayoutNextAmount",money(summary.nextAmount,summary.currency)+" expected");

    var list=byId("clikkerPayoutList");
    var empty=byId("clikkerPayoutEmpty");
    if(list)list.innerHTML=state.payouts.map(payoutRow).join("");
    if(empty)empty.hidden=state.payouts.length>0;

    var tbody=byId("clikkerPayoutTransactionBody");
    if(tbody){
      tbody.innerHTML=state.payoutTransactions.length
        ?state.payoutTransactions.map(transactionRow).join("")
        :'<tr id="clikkerPayoutTransactionEmpty"><td colspan="7">No payout activity is available yet.</td></tr>';
    }

    populatePayoutProfile();
  }

  async function savePayoutProfile(event){
    event.preventDefault();
    clearPayoutAlerts();

    var method=clean(byId("clikkerPayoutMethod").value||"bank");
    var holder=clean(byId("clikkerPayoutAccountHolder").value);
    var bankName=clean(byId("clikkerPayoutBankName").value);
    var accountNumber=clean(byId("clikkerPayoutAccountNumber").value).replace(/\s+/g,"");
    var confirmAccount=clean(byId("clikkerPayoutAccountNumberConfirm").value).replace(/\s+/g,"");
    var ifsc=clean(byId("clikkerPayoutIfsc").value).toUpperCase();
    var upi=clean(byId("clikkerPayoutUpi").value).toLowerCase();
    var pan=clean(byId("clikkerPayoutPan").value).toUpperCase();
    var confirmed=!!byId("clikkerPayoutDetailsConfirmation").checked;
    var existing=payoutProfileFromContext()||{};

    if(holder.length<2){
      showPayoutAlert("Enter the account holder name.","error");
      return;
    }

    if(method==="bank"){
      var hasExisting=!!existing.accountLast4;
      if(!accountNumber&&!hasExisting){
        showPayoutAlert("Enter the bank account number.","error");
        return;
      }
      if(accountNumber){
        if(!/^\d{6,24}$/.test(accountNumber)){
          showPayoutAlert("Enter a valid bank account number.","error");
          return;
        }
        if(accountNumber!==confirmAccount){
          showPayoutAlert("The bank account numbers do not match.","error");
          return;
        }
      }
      if(!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifsc)){
        showPayoutAlert("Enter a valid 11-character IFSC code.","error");
        return;
      }
    }else if(!/^[a-z0-9._-]{2,}@[a-z0-9.-]{2,}$/i.test(upi)){
      showPayoutAlert("Enter a valid UPI ID.","error");
      return;
    }

    if(pan&&!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(pan)){
      showPayoutAlert("Enter a valid PAN or leave it blank.","error");
      return;
    }

    if(!confirmed){
      showPayoutAlert("Confirm that the payout details belong to you or your business.","error");
      return;
    }

    var button=byId("clikkerPayoutAccountSave");
    if(button){
      button.disabled=true;
      button.textContent="Saving…";
    }

    /*
      Security rule:
      Raw account numbers and PAN values are intentionally not written to
      Firestore by browser JavaScript. Only masked metadata is stored here.
      A secure backend/provider integration must tokenize the full details.
    */
    var profile={
      method:method,
      accountHolderName:holder,
      bankName:method==="bank"?bankName:"",
      accountLast4:method==="bank"
        ?(accountNumber?accountNumber.slice(-4):clean(existing.accountLast4))
        :"",
      ifsc:method==="bank"?ifsc:"",
      upiMasked:method==="upi"
        ?upi.replace(/^(.{2}).*(@.*)$/,"$1••••$2")
        :"",
      panLast4:pan?pan.slice(-4):clean(existing.panLast4),
      status:"pending_verification",
      providerStatus:"not_connected",
      updatedAt:serverTimestamp()
    };

    try{
      await withTimeout(
        db().collection("creators").doc(creatorDocumentId()).set({
          payoutProfile:profile,
          payout_profile:profile,
          updatedAt:serverTimestamp()
        },{merge:true}),
        TIMEOUTS.transaction,
        "Saving payout details"
      );

      state.payoutProfile=profile;
      if(state.creator&&state.creator.raw){
        state.creator.raw.payoutProfile=profile;
        state.creator.raw.payout_profile=profile;
      }

      populatePayoutProfile();
      showPayoutAlert(
        "Payout profile saved securely. Connect the payout provider to verify and activate settlements.",
        "success"
      );
    }catch(error){
      showPayoutAlert(
        firebaseMessage(error,"Payout details could not be saved."),
        "error"
      );
    }finally{
      if(button){
        button.disabled=false;
        button.textContent="Save payout account";
      }
    }
  }

  function bindPayoutView(){
    var form=byId("clikkerPayoutAccountForm");
    var method=byId("clikkerPayoutMethod");
    var refresh=byId("clikkerPayoutRefresh");

    if(method)method.onchange=togglePayoutMethod;
    if(form)form.onsubmit=savePayoutProfile;
    if(refresh)refresh.onclick=async function(){
      refresh.disabled=true;
      refresh.textContent="Refreshing…";
      clearPayoutAlerts();
      await loadPayouts(true);
      renderPayoutContent();
      refresh.disabled=false;
      refresh.textContent="Refresh";
    };
  }

  async function renderPayouts(){
    clearAlert();
    setHeader("Payouts","Track earnings and creator settlements","");

    if(!el.clikkerPayoutsViewTemplate){
      el.clikkerCreatorView.innerHTML=
        '<section class="ccx-empty"><h3>Payouts unavailable</h3><p>The payouts template could not be found in page.clikker-profile.liquid.</p></section>';
      return;
    }

    el.clikkerCreatorView.innerHTML="";
    el.clikkerCreatorView.appendChild(
      el.clikkerPayoutsViewTemplate.content.cloneNode(true)
    );

    bindPayoutView();
    renderPayoutContent();

    var loading=byId("clikkerPayoutLoading");
    if(loading)loading.hidden=false;

    await loadPayouts(false);

    if(loading)loading.hidden=true;
    renderPayoutContent();
  }

  function renderStore(){
    clearAlert();
    setHeader("Profile","Edit how your public creator page looks",state.store.slug?'<a class="ccx-btn ccx-btn--secondary" target="_blank" href="/pages/c?creator='+encodeURIComponent(state.store.slug)+'&preview=1">Open preview</a>':"");
    el.clikkerCreatorView.innerHTML="";
    el.clikkerCreatorView.appendChild(el.clikkerStoreEditor);
    el.clikkerStoreEditor.hidden=false;
    populateStore();
    switchStoreTab(state.storeEditor.activeTab);
  }

  function renderSettings(){
    clearAlert();
    setHeader("Settings","Account and technical information","");

    var user=window.Clikker.currentFirebaseUser||{};

    el.clikkerCreatorView.innerHTML=
      '<section class="ccx-card">'+
        '<div class="ccx-card__head"><div><h2>Account information</h2><p>Your authentication and workspace identifiers.</p></div></div>'+
        '<div class="ccx-card__body"><div class="ccx-repeat-list">'+
          setting("Email",user.email||"—")+
          setting("Account role",titleCase(state.access.role||"creator"))+
          setting("Account status",titleCase(state.access.status||"active"))+
          setting("User ID",user.uid||"—")+
          setting("Creator ID",(state.creator&&state.creator.id)||"—")+
          setting("Store ID",(state.store&&state.store.id)||"—")+
        '</div></div>'+
      '</section>';
  }

  function setting(key,value){
    return '<div class="ccx-repeat-item">'+
      '<div><h4>'+escapeHTML(key)+'</h4><p>'+escapeHTML(value)+'</p></div>'+
    '</div>';
  }

  function populateStore(){
    var s=state.store||{}, r=s.raw||{}, c=state.creator||{}, cr=c.raw||{};
    var social=s.socialLinks||r.socialLinks||r.social_links||cr.socialLinks||{};
    var cred=s.credibility||r.credibility||cr.credibility||{};
    var brand=s.branding||r.branding||{};
    var sections=s.sections||r.sections||{};
    var contact=s.contact||r.contact||{};
    var location=s.location||r.location||cr.location||{};

    setValue("storeProfileDisplayName",c.displayName||cr.name||s.storeName||"");
    setValue("storeProfileHandle",s.slug||c.handle||"");
    setValue("storeProfileTagline",s.tagline||"");
    setValue("storeProfilePrimaryCategory",s.category||r.category||cr.category||"");
    setValue("storeProfileSecondaryCategories",(s.secondaryCategories||r.secondaryCategories||[]).join(", "));
    setValue("storeProfileLanguages",(s.languages||r.languages||cr.languages||[]).join(", "));
    setValue("storeProfileCountry",location.country||"");
    setValue("storeProfileCity",location.city||"");
    setValue("storeProfileAudience",s.audience||r.audience||"");
    setValue("storeProfileBio",s.about||s.shortBio||c.bio||cr.bio||"");
    setValue("storeProfileSupportEmail",contact.supportEmail||s.supportEmail||r.support_email||"");
    setValue("storeProfileBusinessEmail",contact.businessEmail||r.business_email||"");
    setValue("storeProfileWhatsAppNumber",contact.whatsappNumber||r.whatsapp_number||"");
    setValue("storeProfileResponseTime",contact.responseTime||"Within 24 hours");
    setValue("storeProfileSupportHours",contact.supportHours||"");
    setValue("storeProfileContactForm",String(contact.contactFormEnabled!==false));

    ["Instagram","YouTube","TikTok","Facebook","LinkedIn","Twitter","Website","WhatsApp"].forEach(function(name){
      var key=name.toLowerCase();
      setValue("storeSocial"+name,social[key]||social[name==="LinkedIn"?"linkedin":key]||"");
    });
    setChecked("storeShowSocialLinks",brand.showSocialLinks!==false);
    setChecked("storeShowFollowerCount",brand.showFollowerCount===true);

    setValue("storeCredibilityExperienceYears",cred.experienceYears||0);
    setValue("storeCredibilityFollowers",cred.followersCount||0);
    setValue("storeCredibilityCustomers",cred.customersServed||0);
    setValue("storeCredibilityExpertise",(cred.expertise||[]).join(", "));
    setValue("storeCredibilityCertifications",(cred.certifications||[]).join("\n"));
    setValue("storeCredibilityMediaMentions",(cred.mediaMentions||[]).join("\n"));
    state.storeEditor.achievements=clone(cred.achievements||[]);
    state.storeEditor.brands=clone(cred.brandsWorkedWith||[]);

    setValue("storeBrandPrimaryColor",brand.primaryColor||s.primaryColor||"#101828");
    setValue("storeBrandSecondaryColor",brand.secondaryColor||s.secondaryColor||"#667085");
    setValue("storeBrandButtonColor",brand.buttonColor||"#101828");
    setValue("storeBrandTextColor",brand.textColor||"#101828");
    setValue("storeBrandLayout",brand.storeLayout||"modern");
    setValue("storeBrandProductCardStyle",brand.productCardStyle||"clean");
    setValue("storeBrandBannerPosition",brand.bannerPosition||"center");
    setValue("storeBrandWelcomeMessage",brand.welcomeMessage||"");
    syncColorPickers();

    setChecked("storeSectionHero",sections.hero!==false);
    setChecked("storeSectionProducts",sections.products!==false);
    setChecked("storeSectionAbout",sections.about!==false);
    setChecked("storeSectionSocials",sections.socials!==false);
    setChecked("storeSectionAchievements",sections.achievements!==false);
    setChecked("storeSectionBrands",sections.brands!==false);
    setChecked("storeSectionTestimonials",sections.testimonials===true);
    setChecked("storeSectionFAQ",sections.faq===true);
    setChecked("storeSectionContact",sections.contact!==false);
    setChecked("storeSectionFeaturedContent",sections.featuredContent===true);
    setValue("storeProfileStatus",s.status||"draft");
    setValue("storeProfileVisibility",s.visibility||"private");

    state.storeEditor.profileImageFile=null;
    state.storeEditor.bannerImageFile=null;
    state.storeEditor.dirty=false;
    renderStoreImages();
    renderAchievements();
    renderBrands();
    updateStoreAll();
  }

  function setValue(id,value){var node=byId(id);if(node)node.value=value==null?"":value;}
  function setChecked(id,value){var node=byId(id);if(node)node.checked=!!value;}
  function syncColorPickers(){
    [["storeBrandPrimaryColorPicker","storeBrandPrimaryColor","#101828"],["storeBrandSecondaryColorPicker","storeBrandSecondaryColor","#667085"],["storeBrandButtonColorPicker","storeBrandButtonColor","#101828"],["storeBrandTextColorPicker","storeBrandTextColor","#101828"]].forEach(function(pair){
      byId(pair[0]).value=normalizeHex(byId(pair[1]).value,pair[2]);
    });
  }

  function switchStoreTab(tab){
    state.storeEditor.activeTab=tab||"profile";
    el.clikkerStoreEditorTabs.querySelectorAll("[data-store-tab]").forEach(function(btn){btn.classList.toggle("is-active",btn.dataset.storeTab===state.storeEditor.activeTab);});
    el.clikkerStoreEditor.querySelectorAll("[data-store-panel]").forEach(function(panel){panel.classList.toggle("is-active",panel.dataset.storePanel===state.storeEditor.activeTab);});
    updateStoreAll();
  }

  function collectStore(){
    return {
      displayName:clean(byId("storeProfileDisplayName").value),
      handle:slugify(byId("storeProfileHandle").value),
      tagline:clean(byId("storeProfileTagline").value),
      category:byId("storeProfilePrimaryCategory").value,
      secondaryCategories:splitList(byId("storeProfileSecondaryCategories").value),
      languages:splitList(byId("storeProfileLanguages").value),
      location:{country:clean(byId("storeProfileCountry").value),city:clean(byId("storeProfileCity").value)},
      audience:clean(byId("storeProfileAudience").value),
      bio:clean(byId("storeProfileBio").value),
      contact:{
        supportEmail:clean(byId("storeProfileSupportEmail").value),
        businessEmail:clean(byId("storeProfileBusinessEmail").value),
        whatsappNumber:clean(byId("storeProfileWhatsAppNumber").value),
        responseTime:byId("storeProfileResponseTime").value,
        supportHours:clean(byId("storeProfileSupportHours").value),
        contactFormEnabled:byId("storeProfileContactForm").value==="true"
      },
      socialLinks:{
        instagram:clean(byId("storeSocialInstagram").value),youtube:clean(byId("storeSocialYouTube").value),
        tiktok:clean(byId("storeSocialTikTok").value),facebook:clean(byId("storeSocialFacebook").value),
        linkedin:clean(byId("storeSocialLinkedIn").value),twitter:clean(byId("storeSocialTwitter").value),
        website:clean(byId("storeSocialWebsite").value),whatsapp:clean(byId("storeSocialWhatsApp").value)
      },
      credibility:{
        experienceYears:Number(byId("storeCredibilityExperienceYears").value||0),
        followersCount:Number(byId("storeCredibilityFollowers").value||0),
        customersServed:Number(byId("storeCredibilityCustomers").value||0),
        expertise:splitList(byId("storeCredibilityExpertise").value),
        achievements:clone(state.storeEditor.achievements),
        brandsWorkedWith:clone(state.storeEditor.brands),
        certifications:splitList(byId("storeCredibilityCertifications").value),
        mediaMentions:splitList(byId("storeCredibilityMediaMentions").value)
      },
      branding:{
        primaryColor:normalizeHex(byId("storeBrandPrimaryColor").value,"#101828"),
        secondaryColor:normalizeHex(byId("storeBrandSecondaryColor").value,"#667085"),
        buttonColor:normalizeHex(byId("storeBrandButtonColor").value,"#101828"),
        textColor:normalizeHex(byId("storeBrandTextColor").value,"#101828"),
        storeLayout:byId("storeBrandLayout").value,productCardStyle:byId("storeBrandProductCardStyle").value,
        bannerPosition:byId("storeBrandBannerPosition").value,welcomeMessage:clean(byId("storeBrandWelcomeMessage").value),
        showSocialLinks:byId("storeShowSocialLinks").checked,showFollowerCount:byId("storeShowFollowerCount").checked
      },
      sections:{
        hero:byId("storeSectionHero").checked,products:byId("storeSectionProducts").checked,
        about:byId("storeSectionAbout").checked,socials:byId("storeSectionSocials").checked,
        achievements:byId("storeSectionAchievements").checked,brands:byId("storeSectionBrands").checked,
        testimonials:byId("storeSectionTestimonials").checked,faq:byId("storeSectionFAQ").checked,
        contact:byId("storeSectionContact").checked,featuredContent:byId("storeSectionFeaturedContent").checked
      },
      status:byId("storeProfileStatus").value,visibility:byId("storeProfileVisibility").value
    };
  }

  function storeReadiness(p){
    var existingProfile=
      state.store.profileImage||
      (state.store.raw&&(state.store.raw.profileImage||state.store.raw.profile_image))||
      (state.creator&&state.creator.profileImage)||
      firebaseAccountPhoto();
    var essentials=[
      check("Creator name",p.displayName.length>=2,"profile"),
      check("Public username",p.handle.length>=3,"profile"),
      check("Tagline",p.tagline.length>=5,"profile"),
      check("Main category",!!p.category,"profile"),
      check("Bio",p.bio.length>=40,"profile"),
      check("Support email",isEmail(p.contact.supportEmail),"profile"),
      check("Profile photo",!!(state.storeEditor.profileImageFile||existingProfile),"images"),
      check("Published product",state.products.some(function(x){return x.status==="published";}),"preview")
    ];
    var strength=essentials.concat([
      check("Cover banner",!!(state.storeEditor.bannerImageFile||state.store.bannerImage||(state.store.raw&&(state.store.raw.bannerImage||state.store.raw.banner_image))),"images"),
      check("Language",p.languages.length>0,"profile"),
      check("Audience",!!p.audience,"profile"),
      check("Social link",Object.keys(p.socialLinks).some(function(k){return !!p.socialLinks[k];}),"socials"),
      check("Expertise",p.credibility.expertise.length>0,"credibility"),
      check("Credibility",p.credibility.achievements.length>0||p.credibility.brandsWorkedWith.length>0,"credibility")
    ]);
    var essentialPass=essentials.filter(function(x){return x.complete;}).length;
    var strengthPass=strength.filter(function(x){return x.complete;}).length;
    return {
      canPublish:essentialPass===essentials.length,
      readinessScore:Math.round(essentialPass/essentials.length*100),
      strengthScore:Math.round(strengthPass/strength.length*100),
      essentials:essentials,
      checks:strength
    };
  }
  function check(label,complete,tab){return {label:label,complete:!!complete,tab:tab};}
  function isEmail(value){return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(clean(value));}
  function isURL(value){if(!clean(value))return true;try{var u=new URL(clean(value));return u.protocol==="http:"||u.protocol==="https:";}catch(_){return false;}}

  function updateStoreAll(){
    if(el.clikkerStoreEditor.hidden)return;
    var p=collectStore(),r=storeReadiness(p);
    el.clikkerStoreProfileScore.textContent=r.strengthScore+"%";
    el.clikkerStoreProfileBar.style.width=r.strengthScore+"%";
    el.storeProfileChecklist.innerHTML=r.checks.map(function(x){return '<button class="ccx-store-checklist__item '+(x.complete?'is-complete':'')+'" data-store-check-tab="'+x.tab+'"><span>'+escapeHTML(x.label)+'</span><strong>'+(x.complete?'✓':'Fix')+'</strong></button>';}).join("");
    el.storeProfileChecklist.querySelectorAll("[data-store-check-tab]").forEach(function(btn){btn.onclick=function(){switchStoreTab(btn.dataset.storeCheckTab);};});
    byId("storeLivePreviewName").textContent=p.displayName||"Creator name";
    byId("storeLivePreviewTagline").textContent=p.tagline||"Creator tagline will appear here.";
    byId("storeLivePreviewBio").textContent=p.bio||"Creator bio will appear here.";
    byId("storeLivePreviewSocials").innerHTML=Object.keys(p.socialLinks).filter(function(k){return p.socialLinks[k];}).map(function(k){return "<span>"+escapeHTML(k.charAt(0).toUpperCase()+k.slice(1))+"</span>";}).join("");
    byId("storeLivePreviewName").closest(".ccx-store-preview__banner").style.background="linear-gradient(135deg,"+p.branding.primaryColor+","+p.branding.secondaryColor+")";
    byId("storeOpenPrivatePreview").href="/pages/c?creator="+encodeURIComponent(p.handle||state.store.slug||"")+"&preview=1";
    byId("storeProfilePublishSummary").innerHTML='<div class="ccx-card__body"><h3>Publication readiness: '+r.readinessScore+'%</h3><p class="ccx-help-copy">'+(r.canPublish?'Your store meets the minimum publication requirements.':'Complete the essential items marked Fix. Optional profile-strength items will not block publishing.')+'</p></div>';
    byId("storePublishProfile").disabled=state.storeEditor.saving||!r.canPublish;
    if(el.storeProfileStatusLabel)el.storeProfileStatusLabel.textContent=titleCase(p.status||"draft");
    if(el.storeProfileVisibilityLabel)el.storeProfileVisibilityLabel.textContent=titleCase(p.visibility||"private");
    updateStoreLiveImages(p);
  }

  function markStoreDirty(){state.storeEditor.dirty=true;byId("storeProfileSaveStatus").textContent="Unsaved changes";updateStoreAll();}

  function renderStoreImages(){
    imagePreview(
      "storeProfileImagePreview",
      state.storeEditor.profileImageFile,
      state.store.profileImage||(state.creator&&state.creator.profileImage)||firebaseAccountPhoto(),
      "No profile photo"
    );
    imagePreview("storeBannerImagePreview",state.storeEditor.bannerImageFile,state.store.bannerImage,"No cover banner");
  }
  function imagePreview(id,file,url,text){
    var node=byId(id);node.innerHTML="";
    if(file||url){var img=document.createElement("img");img.src=file?URL.createObjectURL(file):url;img.alt="";node.appendChild(img);}else node.textContent=text;
  }
  function updateStoreLiveImages(p){
    var avatar=byId("storeLivePreviewAvatar"),file=state.storeEditor.profileImageFile,url=state.store.profileImage||(state.creator&&state.creator.profileImage)||firebaseAccountPhoto();
    avatar.innerHTML="";
    if(file||url){var img=document.createElement("img");img.src=file?URL.createObjectURL(file):url;img.alt=p.displayName;avatar.appendChild(img);}else avatar.textContent=(p.displayName||"C").charAt(0).toUpperCase();
    var banner=byId("storeLivePreviewBanner"),bfile=state.storeEditor.bannerImageFile,burl=state.store.bannerImage;
    if(bfile||burl){banner.hidden=false;banner.src=bfile?URL.createObjectURL(bfile):burl;banner.style.objectPosition=p.branding.bannerPosition;}else{banner.hidden=true;banner.removeAttribute("src");}
  }

  function renderAchievements(){
    var list=byId("storeAchievementList"),empty=byId("storeAchievementEmpty");
    empty.hidden=state.storeEditor.achievements.length>0;list.hidden=!state.storeEditor.achievements.length;
    list.innerHTML=state.storeEditor.achievements.map(function(item,i){var title=typeof item==="string"?item:item.title||"";return '<div class="ccx-repeat-item"><h4>'+escapeHTML(title)+'</h4><div><button class="ccx-icon-btn" data-edit-achievement="'+i+'">✎</button><button class="ccx-icon-btn" data-delete-achievement="'+i+'">×</button></div></div>';}).join("");
    list.querySelectorAll("[data-edit-achievement]").forEach(function(b){b.onclick=function(){editAchievement(Number(b.dataset.editAchievement));};});
    list.querySelectorAll("[data-delete-achievement]").forEach(function(b){b.onclick=function(){state.storeEditor.achievements.splice(Number(b.dataset.deleteAchievement),1);markStoreDirty();renderAchievements();};});
  }
  function editAchievement(i){
    var current=i>=0?state.storeEditor.achievements[i]:null,title=prompt("Achievement title:",typeof current==="string"?current:(current&&current.title)||"");
    if(title===null||!clean(title))return;
    var detail=prompt("Short detail:",typeof current==="object"&&current?current.detail||"":"");
    var item={title:clean(title),detail:clean(detail||"")};
    if(i>=0)state.storeEditor.achievements[i]=item;else state.storeEditor.achievements.push(item);
    markStoreDirty();renderAchievements();
  }
  function renderBrands(){
    var list=byId("storeBrandList"),empty=byId("storeBrandEmpty");
    empty.hidden=state.storeEditor.brands.length>0;list.hidden=!state.storeEditor.brands.length;
    list.innerHTML=state.storeEditor.brands.map(function(item,i){var name=typeof item==="string"?item:item.name||"";return '<div class="ccx-repeat-item"><h4>'+escapeHTML(name)+'</h4><div><button class="ccx-icon-btn" data-edit-brand="'+i+'">✎</button><button class="ccx-icon-btn" data-delete-brand="'+i+'">×</button></div></div>';}).join("");
    list.querySelectorAll("[data-edit-brand]").forEach(function(b){b.onclick=function(){editBrand(Number(b.dataset.editBrand));};});
    list.querySelectorAll("[data-delete-brand]").forEach(function(b){b.onclick=function(){state.storeEditor.brands.splice(Number(b.dataset.deleteBrand),1);markStoreDirty();renderBrands();};});
  }
  function editBrand(i){
    var current=i>=0?state.storeEditor.brands[i]:null,name=prompt("Brand name:",typeof current==="string"?current:(current&&current.name)||"");
    if(name===null||!clean(name))return;
    var detail=prompt("Short detail:",typeof current==="object"&&current?current.detail||"":"");
    var item={name:clean(name),detail:clean(detail||"")};
    if(i>=0)state.storeEditor.brands[i]=item;else state.storeEditor.brands.push(item);
    markStoreDirty();renderBrands();
  }

  async function saveStore(mode){
    var p=collectStore(),r=storeReadiness(p);
    if(!p.displayName||!p.handle||!p.tagline){switchStoreTab("profile");showStoreMessage("Creator name, public username and tagline are required.","error");return;}
    if(!isEmail(p.contact.supportEmail)){switchStoreTab("profile");showStoreMessage("Enter a valid support email.","error");return;}
    if(mode==="publish"&&!r.canPublish){switchStoreTab("preview");showStoreMessage("Complete the essential publication requirements first.","error");return;}
    state.storeEditor.saving=true;setStoreBusy(true);
    try{
      await reserveStoreHandle(p.handle);
      var uploads=await uploadStoreImages();
      var currentStatus=clean(state.store.status||"draft");
      var isAlreadyPublic=currentStatus==="published"&&state.store.visibility==="public";
      var payload={
        storeName:p.displayName,slug:p.handle,tagline:p.tagline,category:p.category,
        secondaryCategories:p.secondaryCategories,languages:p.languages,location:p.location,
        audience:p.audience,about:p.bio,shortBio:p.bio,supportEmail:p.contact.supportEmail,
        contact:p.contact,socialLinks:p.socialLinks,credibility:p.credibility,
        branding:p.branding,sections:p.sections,
        status:mode==="publish"?"published":(isAlreadyPublic?"published":"draft"),
        visibility:mode==="publish"?"public":(isAlreadyPublic?"public":"private"),
        schemaVersion:5,updatedAt:serverTimestamp()
      };
      if(uploads.profileImageURL)payload.profileImage=uploads.profileImageURL;
      if(uploads.bannerImageURL)payload.bannerImage=uploads.bannerImageURL;
      var creatorPayload={displayName:p.displayName,handle:p.handle,bio:p.bio,category:p.category,secondaryCategories:p.secondaryCategories,languages:p.languages,location:p.location,socialLinks:p.socialLinks,credibility:p.credibility,updatedAt:serverTimestamp()};
      if(uploads.profileImageURL)creatorPayload.profileImage=uploads.profileImageURL;
      var batch=db().batch();
      batch.set(db().collection("stores").doc(state.store.id),payload,{merge:true});
      if(state.creator.id)batch.set(db().collection("creators").doc(state.creator.id),creatorPayload,{merge:true});
      await batch.commit();
      state.store=Object.assign({},state.store,payload,{id:state.store.id});
      state.creator=Object.assign({},state.creator,creatorPayload,{id:state.creator.id});
      state.storeEditor.profileImageFile=null;state.storeEditor.bannerImageFile=null;state.storeEditor.dirty=false;
      setValue("storeProfileStatus",payload.status);setValue("storeProfileVisibility",payload.visibility);
      byId("storeProfileSaveStatus").textContent=mode==="publish"?"Store published":"Draft saved";
      showStoreMessage(mode==="publish"?"Creator store published successfully.":"Store draft saved successfully.","success");
      renderStoreImages();updateStoreAll();renderUser();
    }catch(error){console.error(error);showStoreMessage(error.message||"Unable to save profile.","error");}
    finally{state.storeEditor.saving=false;setStoreBusy(false);updateStoreAll();}
  }

  async function reserveStoreHandle(handle){
    var normalized=slugify(handle);
    if(normalized.length<3)throw new Error("Public username must contain at least 3 characters.");
    var oldHandle=slugify(state.store.slug||"");
    var target=db().collection("storeHandles").doc(normalized);
    var oldRef=oldHandle&&oldHandle!==normalized?db().collection("storeHandles").doc(oldHandle):null;
    await db().runTransaction(async function(tx){
      var snap=await tx.get(target);
      if(snap.exists){var data=snap.data()||{};if(data.storeId!==state.store.id)throw new Error("This public username is already taken.");}
      tx.set(target,{handle:normalized,storeId:state.store.id,creatorId:state.creator.id,ownerId:uid(),status:"active",updatedAt:serverTimestamp()},{merge:true});
      if(oldRef)tx.delete(oldRef);
    });
  }

  function showStoreMessage(msg,type){var n=el.clikkerStoreEditorAlert;n.className="ccx-alert is-visible ccx-alert--"+type;n.textContent=msg;}
  function setStoreBusy(busy){byId("storeSaveDraft").disabled=busy;byId("storePublishProfile").disabled=busy;if(busy)byId("storeProfileSaveStatus").textContent="Saving…";}
  async function uploadStoreImages(){
    var result={};
    if(state.storeEditor.profileImageFile){var a=await uploadFile(state.storeEditor.profileImageFile,"creator-stores/"+uid()+"/"+state.store.id+"/profile");result.profileImageURL=a.downloadURL;}
    if(state.storeEditor.bannerImageFile){var b=await uploadFile(state.storeEditor.bannerImageFile,"creator-stores/"+uid()+"/"+state.store.id+"/banner");result.bannerImageURL=b.downloadURL;}
    return result;
  }
  async function uploadFile(file,path,category){
    if(!window.Clikker.uploadFile)throw new Error("Upload helper unavailable.");
    return withTimeout(
      window.Clikker.uploadFile({file:file,category:category||"image",path:path}),
      TIMEOUTS.upload,
      "Uploading the file"
    );
  }
  function validateFile(file,kind){
    if(!file)return;
    var max=kind==="image"?5*1024*1024:50*1024*1024;
    if(file.size>max)throw new Error(kind==="image"?"Image must be 5 MB or smaller.":"File must be 50 MB or smaller.");
    if(kind==="image"&&!/^image\/(jpeg|png|webp)$/i.test(file.type))throw new Error("Use a JPG, PNG or WebP image.");
  }
  function titleCase(v){return clean(v).replace(/[_-]+/g," ").replace(/\b\w/g,function(c){return c.toUpperCase();});}

  function ensureRequiredBuyerContact(fields){
    var normalized=clone(Array.isArray(fields)?fields:[]);
    var hasContact=normalized.some(function(field){
      var key=clean(field&&field.key).toLowerCase();
      var type=clean(field&&field.type).toLowerCase();
      return field&&field.required!==false&&(
        type==="email"||
        type==="tel"||
        /email|phone|mobile|whatsapp/.test(key)
      );
    });

    if(!hasContact){
      var nameIndex=normalized.findIndex(function(field){
        return /^(customername|buyername|name)$/.test(
          clean(field&&field.key).toLowerCase().replace(/[^a-z0-9]/g,"")
        );
      });

      normalized.splice(nameIndex>=0?nameIndex+1:0,0,
        buyer("customerEmail","Email address","email",true)
      );
    }

    return normalized;
  }

  function productEditorIsPublished(){
    var product=state.productEditor&&state.productEditor.product;
    return !!(
      product &&
      clean(product.status).toLowerCase()==="published"
    );
  }

  function setProductFooterState(text,stateName){
    if(!el.clikkerProductSaveState)return;
    var target=el.clikkerProductSaveState.querySelector("strong")||
      el.clikkerProductSaveState;
    target.textContent=text||"";
    el.clikkerProductSaveState.dataset.state=stateName||"";
  }

  function setProductSaveButtonPrimary(primary){
    if(!el.clikkerSaveProductDraft)return;
    el.clikkerSaveProductDraft.classList.toggle("ccx-btn--primary",!!primary);
    el.clikkerSaveProductDraft.classList.toggle("ccx-btn--secondary",!primary);
  }

  function syncProductEditorActions(){
    if(!state.productEditor||!state.productEditor.product)return;

    var published=productEditorIsPublished();
    var dirty=state.productEditor.dirty===true;
    var isNew=state.productEditor.isNew===true;
    var busy=state.productEditor.saving===true;

    if(el.clikkerPublishProduct){
      /*
        A product that is already public never needs another Publish button.
        Draft/new products keep the existing Publish product flow.
      */
      el.clikkerPublishProduct.hidden=published;
    }

    if(el.clikkerSaveProductDraft){
      if(published){
        /*
          Published + unchanged: no save action is needed.
          Published + edited: expose one clear primary action, Save changes.
        */
        el.clikkerSaveProductDraft.hidden=!dirty;
        el.clikkerSaveProductDraft.textContent=busy?"Saving changes…":"Save changes";
        el.clikkerSaveProductDraft.setAttribute(
          "aria-label",
          "Save changes to this published product"
        );
        setProductSaveButtonPrimary(true);
      }else{
        el.clikkerSaveProductDraft.hidden=false;
        el.clikkerSaveProductDraft.textContent=busy?"Saving draft…":"Save draft";
        el.clikkerSaveProductDraft.setAttribute(
          "aria-label",
          isNew?"Save this new product as a draft":"Save product draft"
        );
        setProductSaveButtonPrimary(false);
      }
    }

    if(el.clikkerCancelProductEdit){
      el.clikkerCancelProductEdit.textContent=
        published&&!dirty?"Close":"Cancel";
    }

    if(el.clikkerArchiveProduct){
      el.clikkerArchiveProduct.hidden=!state.productEditor.persisted;
    }

    if(!busy){
      if(isNew&&!state.productEditor.persisted){
        setProductFooterState("Not saved","new");
      }else if(dirty){
        setProductFooterState("Unsaved changes","dirty");
      }else{
        setProductFooterState("Saved","saved");
      }
    }
  }

  function openProductEditor(idOrProduct,options){
    var product=typeof idOrProduct==="object"?idOrProduct:state.products.find(function(p){return p.id===idOrProduct;});
    if(!product)return;

    if(isArchivedProduct(product)&&!(options&&options.allowArchived)){
      state.productFilter="archived";
      renderProducts();
      showAlert("Restore this archived product before editing it.","info");
      return;
    }
    cleanupProductObjectURLs();
    state.productEditor.product=applyWorkflowDefaults(product);
    state.productEditor.buyerFields=ensureRequiredBuyerContact(
      state.productEditor.product.buyerFields||
      schemaOf(typeOf(state.productEditor.product)).buyerFields
    );
    state.productEditor.dirty=false;
    state.productEditor.isNew=!!(options&&options.isNew)||String(product.id).indexOf("temp_")===0;
    state.productEditor.persisted=!state.productEditor.isNew;
    state.productEditor.coverImageFile=null;
    state.productEditor.fulfilmentFiles={};
    populateProductEditor();
    switchProductTab("basic");
    el.clikkerProductEditor.classList.add("is-open");
    el.clikkerProductEditor.setAttribute("aria-hidden","false");
    document.body.style.overflow="hidden";
  }

  function populateProductEditor(){
    var p=state.productEditor.product,t=typeOf(p),s=schemaOf(t);
    setValue("productEditorName",p.title||"");setValue("productEditorCategory",p.category||"");setValue("productEditorPrice",p.price||0);
    setValue("productEditorCurrency",p.currency||"INR");setValue("productEditorPriceModel",p.priceModel||"fixed");
    setValue("productEditorBadge",p.badge||"");setValue("productEditorSortOrder",p.sortOrder||1);
    setValue("productEditorVisibility",p.visibility||"private");setValue("productEditorShortDescription",p.shortDescription||p.short_description||"");
    setValue("productEditorDescription",p.description||"");setValue("productEditorFeatured",String(p.featured===true));
    setValue("productEditorCustomerInstructions",p.customerInstructions||"");setValue("productEditorStatus",p.status||"draft");
    if(el.productEditorVisibilityLabel)el.productEditorVisibilityLabel.textContent=p.status==="published"?"Public when store is published":"Private while draft";
    var coverInput=byId("productEditorCoverImage");if(coverInput)coverInput.value="";
    renderProductCoverPreview(p);
    el.clikkerProductEditorIcon.textContent=iconOf(t);el.clikkerProductEditorTitle.textContent=(state.productEditor.isNew?"Create ":"Configure ")+(p.title||labelOf(t));el.clikkerProductEditorType.textContent=labelOf(t);
    el.clikkerProductEditorSaveStatus.textContent=state.productEditor.isNew?"Not saved yet":"Saved";
    renderFulfilment(p,s);renderBuyerFields();populateProductTerms(p);updateProductAll();
    syncProductEditorActions();
  }

  function renderFulfilment(p,s){
    var values={};
    s.fulfilment.forEach(function(field){
      var value=p[field.key];
      if(value===undefined||value===null||value==="")value=clone(field.defaultValue);
      values[field.key]=value;
    });

    function optionMarkup(option,current){
      var normalized=typeof option==="object"
        ? option
        : {label:String(option),value:String(option),disabled:false};
      return '<option value="'+escapeHTML(normalized.value)+'"'+
        (String(normalized.value)===String(current)?" selected":"")+
        (normalized.disabled?" disabled":"")+'>'+
        escapeHTML(normalized.label)+'</option>';
    }

    function fieldVisible(field){
      if(!field.visibleWhen)return true;
      var current=values[field.visibleWhen.field];
      if(Object.prototype.hasOwnProperty.call(field.visibleWhen,"equals")){
        return current===field.visibleWhen.equals;
      }
      if(Object.prototype.hasOwnProperty.call(field.visibleWhen,"notEquals")){
        return current!==field.visibleWhen.notEquals;
      }
      return true;
    }

    el.clikkerProductFulfilmentFields.innerHTML=
      '<div class="ccx-grid ccx-grid--2">'+
      s.fulfilment.map(function(f){
        var id="productFulfilment_"+f.key;
        var v=values[f.key];
        var wide=f.input==="textarea"||f.input==="file";
        var hidden=fieldVisible(f)?"":' hidden';
        var required=f.required?' <span>*</span>':'';
        var help=f.helpText?'<small>'+escapeHTML(f.helpText)+'</small>':'';

        if(f.input==="textarea"){
          return '<div class="ccx-field'+(wide?' ccx-onboarding__field--wide':'')+
            '" data-fulfilment-wrap="'+escapeHTML(f.key)+'"'+hidden+'>'+
            '<label>'+escapeHTML(f.label)+required+'</label>'+
            '<textarea id="'+id+'" data-fulfilment-key="'+escapeHTML(f.key)+
            '" class="ccx-textarea" rows="'+Number(f.rows||4)+'">'+
            escapeHTML(v||"")+'</textarea>'+help+'</div>';
        }

        if(f.input==="select"){
          return '<div class="ccx-field" data-fulfilment-wrap="'+
            escapeHTML(f.key)+'"'+hidden+'><label>'+escapeHTML(f.label)+
            required+'</label><select id="'+id+'" data-fulfilment-key="'+
            escapeHTML(f.key)+'" class="ccx-select">'+
            (f.options||[]).map(function(option){
              return optionMarkup(option,v);
            }).join("")+'</select>'+help+'</div>';
        }

        if(f.input==="toggle"||f.input==="checkbox"){
          return '<div data-fulfilment-wrap="'+escapeHTML(f.key)+'"'+hidden+'>'+
            '<label class="ccx-section-toggle"><span><strong>'+
            escapeHTML(f.label)+'</strong>'+
            (f.helpText?'<span>'+escapeHTML(f.helpText)+'</span>':'')+
            '</span><input id="'+id+'" data-fulfilment-key="'+
            escapeHTML(f.key)+'" type="checkbox" '+(v===true?"checked":"")+
            '></label></div>';
        }

        if(f.input==="file"||f.input==="image"){
          return '<div class="ccx-field ccx-onboarding__field--wide" '+
            'data-fulfilment-wrap="'+escapeHTML(f.key)+'"'+hidden+'>'+
            '<label>'+escapeHTML(f.label)+required+'</label>'+
            '<input id="'+id+'" data-fulfilment-key="'+escapeHTML(f.key)+
            '" data-fulfilment-file="true" class="ccx-input" type="file" accept="'+
            escapeHTML(f.accept||"")+'"><small>'+
            (p[f.key]&&p[f.key].fileName
              ?'Current file: '+escapeHTML(p[f.key].fileName)
              :(f.helpText?escapeHTML(f.helpText):'Choose a protected delivery file. Maximum 50 MB.'))+
            '</small></div>';
        }

        var inputType=f.input==="number"||f.input==="currency"?"number":
          (f.input==="date"||f.input==="time"||f.input==="datetime-local"||
           f.input==="email"||f.input==="tel"||f.input==="url"
            ?f.input:"text");

        return '<div class="ccx-field" data-fulfilment-wrap="'+
          escapeHTML(f.key)+'"'+hidden+'><label>'+escapeHTML(f.label)+
          required+'</label><input id="'+id+'" data-fulfilment-key="'+
          escapeHTML(f.key)+'" class="ccx-input" type="'+inputType+
          '" value="'+escapeHTML(v==null?"":v)+'" placeholder="'+
          escapeHTML(f.placeholder||"")+'"'+
          (f.min!=null?' min="'+f.min+'"':'')+
          (f.max!=null?' max="'+f.max+'"':'')+
          (f.step!=null?' step="'+f.step+'"':'')+
          '>'+help+'</div>';
      }).join("")+'</div>';

    function refreshConditionalFields(){
      s.fulfilment.forEach(function(field){
        var node=byId("productFulfilment_"+field.key);
        if(node){
          values[field.key]=
            field.input==="toggle"||field.input==="checkbox"
              ?node.checked
              :node.value;
        }
      });

      s.fulfilment.forEach(function(field){
        var wrap=el.clikkerProductFulfilmentFields.querySelector(
          '[data-fulfilment-wrap="'+field.key+'"]'
        );
        if(wrap)wrap.hidden=!fieldVisible(field);
      });
    }

    el.clikkerProductFulfilmentFields
      .querySelectorAll("[data-fulfilment-key]")
      .forEach(function(node){
        node.oninput=function(){
          refreshConditionalFields();
          markProductDirty();
        };
        node.onchange=function(){
          refreshConditionalFields();
          markProductDirty();
        };
      });

    refreshConditionalFields();
  }

  function renderBuyerFields(){
    var list=el.clikkerBuyerFieldList,fields=state.productEditor.buyerFields;
    el.clikkerBuyerFieldEmpty.hidden=fields.length>0;list.hidden=!fields.length;
    list.innerHTML=fields.map(function(f,i){return '<article class="ccx-form-field-card"><span class="ccx-form-field-card__handle">↕</span><div><h4>'+escapeHTML(f.label)+'</h4><p>'+escapeHTML(f.type)+(f.required?" · required":" · optional")+'</p></div><div class="ccx-form-field-card__actions"><button class="ccx-icon-btn" data-edit-field="'+i+'">✎</button><button class="ccx-icon-btn" data-delete-field="'+i+'">×</button></div></article>';}).join("");
    list.querySelectorAll("[data-edit-field]").forEach(function(b){b.onclick=function(){openFieldDrawer(Number(b.dataset.editField));};});
    list.querySelectorAll("[data-delete-field]").forEach(function(b){b.onclick=function(){state.productEditor.buyerFields.splice(Number(b.dataset.deleteField),1);markProductDirty();renderBuyerFields();};});
    renderBuyerPreview();
  }

  function populateProductTerms(p){
    var policies=p.policies||defaultPolicies();
    ["Refund","Cancellation","Rescheduling","Revision","Usage","Custom"].forEach(function(name){
      var key=name.toLowerCase(),en=byId("productTerms"+name+"Enabled"),ta=byId("productTerms"+name);
      if(en)en.checked=policies[key]&&policies[key].enabled!==false;
      if(ta)ta.value=policies[key]?policies[key].text:"";
    });
  }

  function collectProduct(){
    var p=clone(state.productEditor.product),s=schemaOf(typeOf(p));
    p.ownerId=uid();p.creatorId=state.creator.id;p.storeId=state.store.id;
    p.productType=typeOf(p);
    p.workflowType=p.productType;
    p.fulfilmentType=p.productType;
    p.fulfillmentType=p.productType;
    p.type=p.productType;
    p.schemaVersion=Number(
      (ProductEngine.getWorkflowMeta(p.productType)||{}).schemaVersion||1
    );
    p.title=clean(byId("productEditorName").value);p.category=clean(byId("productEditorCategory").value);p.price=Number(byId("productEditorPrice").value||0);
    p.currency=byId("productEditorCurrency").value;p.priceModel=byId("productEditorPriceModel").value;p.badge=clean(byId("productEditorBadge").value);
    p.sortOrder=Math.max(1,Number(byId("productEditorSortOrder").value||1));
    p.shortDescription=clean(byId("productEditorShortDescription").value);p.description=clean(byId("productEditorDescription").value);
    p.featured=byId("productEditorFeatured").value==="true";p.customerInstructions=clean(byId("productEditorCustomerInstructions").value);
    p.status=clean(state.productEditor.product.status||"draft");p.visibility=p.status==="published"?"public":"private";
    p.buyerFields=clone(state.productEditor.buyerFields);
    s.fulfilment.forEach(function(f){
      var n=byId("productFulfilment_"+f.key);if(!n)return;
      if(f.input==="file"){if(state.productEditor.fulfilmentFiles[f.key])p[f.key]={pending:true,fileName:state.productEditor.fulfilmentFiles[f.key].name,size:state.productEditor.fulfilmentFiles[f.key].size,type:state.productEditor.fulfilmentFiles[f.key].type};return;}
      p[f.key]=f.input==="toggle"?n.checked:f.input==="number"?Number(n.value||0):clean(n.value);
    });
    p.policies={};
    ["Refund","Cancellation","Rescheduling","Revision","Usage","Custom"].forEach(function(name){var key=name.toLowerCase();p.policies[key]={enabled:byId("productTerms"+name+"Enabled").checked,text:clean(byId("productTerms"+name).value)};});
    return p;
  }

  function productReadiness(p){
    var type=typeOf(p);
    var s=schemaOf(type);
    var workflow=ProductEngine.getWorkflow(type);

    /*
      Convert the proven flat product document into the Engine's normalized
      shape only for validation. Firestore storage remains unchanged.
    */
    var engineProduct=clone(p);
    engineProduct.workflowType=type;
    engineProduct.fulfilmentType=type;
    engineProduct.type=type;
    engineProduct.description=clean(p.description||p.shortDescription||"");
    engineProduct.fulfilment={};

    s.fulfilment.forEach(function(field){
      engineProduct.fulfilment[field.key]=clone(p[field.key]);
    });

    var validation=ProductEngine.validateProduct(engineProduct);
    var checks=[];

    function add(label,complete,tab){
      checks.push(check(label,complete,tab));
    }

    var titleErrors=
      validation.fieldErrors&&validation.fieldErrors.title||[];
    var priceErrors=
      validation.fieldErrors&&validation.fieldErrors.price||[];
    var descriptionErrors=
      validation.fieldErrors&&validation.fieldErrors.description||[];

    add("Product name",titleErrors.length===0,"basic");
    add("Valid price",priceErrors.length===0,"basic");
    add("Product description",descriptionErrors.length===0,"basic");

    /*
      Name + email remain the only universal buyer-form essentials.
      Extra buyer questions are creator/product choices.
    */
    var buyerFields=Array.isArray(p.buyerFields)?p.buyerFields:[];
    var hasName=buyerFields.some(function(field){
      var key=clean(field&&field.key).toLowerCase();
      return field&&field.required!==false&&(
        /^(customer_name|customername|buyer_name|buyername|name)$/.test(key)
      );
    });
    var hasEmail=buyerFields.some(function(field){
      var key=clean(field&&field.key).toLowerCase();
      var fieldType=clean(field&&field.type).toLowerCase();
      return field&&field.required!==false&&(
        fieldType==="email"||/email/.test(key)
      );
    });

    add("Buyer name & email",hasName&&hasEmail,"customer-form");

    /*
      Only fields explicitly marked publishRequired by Workflow v1.2.2
      become checklist blockers. Defaults/recommended settings do not.
    */
    s.fulfilment.filter(function(field){
      return field.publishRequired===true;
    }).forEach(function(field){
      var key="fulfilment."+field.key;
      var errors=validation.fieldErrors&&validation.fieldErrors[key]||[];
      add(field.label,errors.length===0,"fulfilment");
    });

    /*
      Workflow hooks handle conditional requirements such as:
      Custom platform only when platform=Custom,
      Other platform only when promotion platform=Other.
      Surface those only when the condition actually fails.
    */
    var knownErrorMessages={};
    Object.keys(validation.fieldErrors||{}).forEach(function(key){
      (validation.fieldErrors[key]||[]).forEach(function(message){
        knownErrorMessages[message]=true;
      });
    });

    (validation.errors||[]).forEach(function(message){
      if(knownErrorMessages[message])return;

      var label=clean(message)
        .replace(/\s+is required.*$/i,"")
        .replace(/[.!]+$/,"")||
        "Product setup";

      if(!checks.some(function(item){
        return item.complete===false&&item.label===label;
      })){
        add(label,false,"fulfilment");
      }
    });

    /*
      Helpful but non-blocking creator guidance.
      These never affect canPublish.
    */
    var recommendations=[];
    if(!clean(p.shortDescription)){
      recommendations.push({
        label:"Add a short description",
        tab:"basic"
      });
    }
    if(!clean(p.customerInstructions)){
      recommendations.push({
        label:"Add buyer instructions",
        tab:"basic"
      });
    }

    var requiredChecks=checks;
    var pass=requiredChecks.filter(function(item){return item.complete;}).length;

    return {
      score:requiredChecks.length
        ?Math.round(pass/requiredChecks.length*100)
        :100,
      checks:requiredChecks,
      recommendations:recommendations,
      canPublish:validation.valid,
      validation:validation
    };
  }


  function updateProductAll(){
    if(!state.productEditor.product)return;
    var p=collectProduct(),r=productReadiness(p),t=typeOf(p);
    var published=productEditorIsPublished();

    renderProductCoverPreview(p);el.clikkerEditorPreviewType.textContent=labelOf(t);
    el.clikkerEditorPreviewTitle.textContent=p.title||"Product title";el.clikkerEditorPreviewDescription.textContent=p.shortDescription||"Product description";
    el.clikkerEditorPreviewPrice.textContent=money(p.price,p.currency);el.clikkerEditorPreviewStatus.textContent=p.status;
    el.clikkerProductReadinessScore.textContent=r.score+"%";el.clikkerProductReadinessBar.style.width=r.score+"%";
    el.clikkerProductReadinessList.innerHTML=r.checks.map(function(x){return '<div class="ccx-readiness-item '+(x.complete?"is-complete":"has-error")+'"><span>'+escapeHTML(x.label)+'</span><strong>'+(x.complete?"✓":"Fix")+'</strong></div>';}).join("");

    if(el.clikkerPublishProduct){
      el.clikkerPublishProduct.disabled=state.productEditor.saving;
    }

    el.clikkerProductPublishSummary.innerHTML=
      '<div class="ccx-card__body"><h3>Product readiness: '+r.score+'%</h3><p class="ccx-help-copy">'+
      (
        published
          ?(r.canPublish
              ?'This product is published. Change only what you want, then save the live update.'
              :'Only the essential items marked Fix must be completed before saving this live product.')
          :(r.canPublish
              ?'Ready to publish. Recommended defaults are already filled; change only what you want.'
              :'Only the essential items marked Fix must be completed before publishing.')
      )+
      '</p></div>';

    if(el.productEditorVisibilityLabel){
      el.productEditorVisibilityLabel.textContent=
        published?"Published · visible on the creator store":"Private while draft";
    }

    updateProductStepButtons();
    renderBuyerPreview();
    syncProductEditorActions();
  }

  function markProductDirty(){
    if(!state.productEditor.product||state.productEditor.saving)return;
    state.productEditor.dirty=true;
    el.clikkerProductEditorSaveStatus.textContent="Unsaved changes";
    setProductFooterState("Unsaved changes","dirty");
    updateProductAll();
  }
  var PRODUCT_TABS=["basic","fulfilment","customer-form","terms","preview"];
  function switchProductTab(tab){
    state.productEditor.activeTab=PRODUCT_TABS.indexOf(tab)>=0?tab:"basic";
    el.clikkerProductEditorTabs.querySelectorAll("[data-product-tab]").forEach(function(b){b.classList.toggle("is-active",b.dataset.productTab===state.productEditor.activeTab);});
    el.clikkerProductEditor.querySelectorAll("[data-product-panel]").forEach(function(p){p.classList.toggle("is-active",p.dataset.productPanel===state.productEditor.activeTab);});
    var index=PRODUCT_TABS.indexOf(state.productEditor.activeTab);
    el.clikkerProductEditor.querySelectorAll(".ccx-editor-guide span").forEach(function(n,i){n.classList.toggle("is-active",i===index);});
    updateProductAll();
  }
  function updateProductStepButtons(){
    var index=PRODUCT_TABS.indexOf(state.productEditor.activeTab);
    if(el.clikkerProductPreviousStep)el.clikkerProductPreviousStep.hidden=index<=0;
    if(el.clikkerProductNextStep){el.clikkerProductNextStep.hidden=index>=PRODUCT_TABS.length-1;el.clikkerProductNextStep.textContent=index===PRODUCT_TABS.length-2?"Review →":"Next →";}
  }
  function moveProductStep(direction){
    var index=PRODUCT_TABS.indexOf(state.productEditor.activeTab),next=Math.max(0,Math.min(PRODUCT_TABS.length-1,index+direction));
    switchProductTab(PRODUCT_TABS[next]);
  }

  function normalizedProductTitle(value){
    return clean(value)
      .toLowerCase()
      .replace(/\s+/g," ")
      .replace(/[^\p{L}\p{N}\s'-]/gu,"")
      .trim();
  }

  async function ensureUniqueProductTitle(product){
    var wanted=normalizedProductTitle(product.title);
    if(!wanted)throw new Error("Add a valid product name.");

    var currentId=clean(product.id);
    var localDuplicate=state.products.some(function(existing){
      return clean(existing.id)!==currentId &&
        clean(existing.status||"draft").toLowerCase()!=="archived" &&
        normalizedProductTitle(existing.title)===wanted;
    });

    if(localDuplicate){
      throw new Error(
        'A product named "'+product.title+'" already exists. Use a different product name.'
      );
    }

    /*
      Recheck Firestore to protect against stale tabs or a fast double-create.
      This uses the same ownerId query that is already working in v7.5.1.
    */
    try{
      var snap=await withTimeout(
        db().collection("products").where("ownerId","==",uid()).get(),
        TIMEOUTS.query,
        "Checking the product name"
      );

      var remoteDuplicate=snap.docs.some(function(doc){
        var data=doc.data()||{};
        return doc.id!==currentId &&
          clean(data.status||"draft").toLowerCase()!=="archived" &&
          normalizedProductTitle(data.title)===wanted;
      });

      if(remoteDuplicate){
        throw new Error(
          'A product named "'+product.title+'" already exists. Use a different product name.'
        );
      }
    }catch(error){
      /*
        Preserve an intentional duplicate error, but do not block saving merely
        because the optional server recheck was unavailable.
      */
      if(/already exists/i.test(clean(error&&error.message)))throw error;
      optionalFallbackLog("[Clikker Products] Duplicate-name pre-check fallback",error);
    }
  }

  function productSavingOverlay(){
    var dialog=el.clikkerProductEditor&&
      el.clikkerProductEditor.querySelector(".ccx-editor-dialog");
    if(!dialog)return null;

    var overlay=dialog.querySelector("[data-product-saving-overlay]");
    if(!overlay){
      overlay=document.createElement("div");
      overlay.setAttribute("data-product-saving-overlay","");
      overlay.className="ccx-product-saving-overlay";
      overlay.innerHTML=
        '<div class="ccx-product-saving-overlay__card" role="status" aria-live="polite">'+
          '<span class="ccx-spinner" aria-hidden="true"></span>'+
          '<strong data-saving-title>Saving product…</strong>'+
          '<small data-saving-help>Please wait. Do not close or click again.</small>'+
        '</div>';
      dialog.appendChild(overlay);
    }
    return overlay;
  }

  function showProductSavingState(mode){
    var overlay=productSavingOverlay();
    if(!overlay)return;
    var title=overlay.querySelector("[data-saving-title]");
    var help=overlay.querySelector("[data-saving-help]");
    var spinner=overlay.querySelector(".ccx-spinner");

    overlay.classList.add("is-visible","is-saving");
    overlay.classList.remove("is-success","is-error");
    if(spinner)spinner.hidden=false;
    if(title)title.textContent=
      mode==="publish"
        ?"Publishing product…"
        :mode==="update"
          ?"Saving changes…"
          :"Saving draft…";
    if(help)help.textContent="Please wait. This action can only be submitted once.";
  }

  function showProductSavedState(mode,productTitle){
    var overlay=productSavingOverlay();
    if(!overlay)return;
    var title=overlay.querySelector("[data-saving-title]");
    var help=overlay.querySelector("[data-saving-help]");
    var spinner=overlay.querySelector(".ccx-spinner");

    overlay.classList.add("is-visible","is-success");
    overlay.classList.remove("is-saving","is-error");
    if(spinner)spinner.hidden=true;
    if(title)title.textContent=
      mode==="publish"
        ?"Product published successfully"
        :mode==="update"
          ?"Changes saved successfully"
          :"Draft saved successfully";
    if(help)help.textContent='"'+clean(productTitle||"Product")+'" is safely saved.';
  }

  function hideProductSavingState(){
    var overlay=productSavingOverlay();
    if(!overlay)return;
    overlay.classList.remove("is-visible","is-saving","is-success","is-error");
  }

  async function saveProduct(mode){
    if(state.productEditor.saving)return;

    var p=collectProduct(),r=productReadiness(p);
    var requiresPublicReadiness=mode==="publish"||mode==="update";
    if(requiresPublicReadiness&&!r.canPublish){
      var missing=r.checks.filter(function(item){return !item.complete;});
      var firstSection=missing.length?missing[0].section:"preview";
      switchProductTab(firstSection||"preview");
      showProductMessage(
        (mode==="update"?"Please complete: ":"Before publishing, complete: ")+
          missing.map(function(item){return item.label;}).join(", ")+".",
        "error"
      );
      if(el.clikkerProductEditorAlert&&typeof el.clikkerProductEditorAlert.scrollIntoView==="function"){
        el.clikkerProductEditorAlert.scrollIntoView({behavior:"smooth",block:"nearest"});
      }
      return;
    }

    /*
      Lock immediately, before any asynchronous duplicate check or upload.
      This prevents rapid repeated clicks from creating multiple documents.
    */
    state.productEditor.saving=true;
    setProductBusy(true,mode);
    showProductSavingState(mode);

    try{
      await ensureUniqueProductTitle(p);

      var docRef=state.productEditor.persisted
        ?db().collection("products").doc(p.id)
        :db().collection("products").doc();

      if(!state.productEditor.persisted)p.id=docRef.id;

      var uploads=await uploadProductAssets(p.id);
      if(uploads.coverImage){
        p.coverImage=uploads.coverImage;
        p.coverImageURL=uploads.coverImage.downloadURL;
      }
      Object.keys(uploads.fulfilmentFiles).forEach(function(key){
        p[key]=uploads.fulfilmentFiles[key];
      });

      p.status=(mode==="publish"||mode==="update")
        ?"published"
        :(state.productEditor.product.status==="published"?"published":"draft");
      p.visibility=p.status==="published"?"public":"private";
      p.titleKey=normalizedProductTitle(p.title);
      p.schemaVersion=Number(
        (ProductEngine.getWorkflowMeta(p.productType)||{}).schemaVersion||1
      );
      p.updatedAt=serverTimestamp();
      if(!state.productEditor.persisted)p.createdAt=serverTimestamp();

      await docRef.set(p,{merge:true});

      var local=clone(p);
      var i=state.products.findIndex(function(x){return x.id===p.id;});
      if(i>=0)state.products[i]=local;
      else state.products.push(local);

      state.products.sort(function(a,b){
        return Number(a.sortOrder||999)-Number(b.sortOrder||999);
      });

      state.productEditor.product=local;
      state.productEditor.persisted=true;
      state.productEditor.isNew=false;
      state.productEditor.coverImageFile=null;
      state.productEditor.fulfilmentFiles={};
      state.productEditor.dirty=false;

      el.clikkerProductEditorSaveStatus.textContent=
        mode==="publish"
          ?"Published and saved"
          :mode==="update"
            ?"Changes saved"
            :"Draft saved";

      setProductFooterState(
        mode==="publish"
          ?"Published"
          :mode==="update"
            ?"Changes saved"
            :"Draft saved",
        "saved"
      );

      showProductMessage(
        mode==="publish"
          ?"Success — “"+p.title+"” is published and visible on your creator store."
          :mode==="update"
            ?"Success — changes to “"+p.title+"” are saved and the product remains published."
            :"Success — “"+p.title+"” has been saved as a private draft.",
        "success"
      );
      showProductSavedState(mode,p.title);

      populateProductEditor();

      if(mode==="update"){
        /*
          populateProductEditor() intentionally normalizes the editor after the
          successful write. Restore explicit success wording so the creator can
          immediately see that the live product was updated.
        */
        el.clikkerProductEditorSaveStatus.textContent="Changes saved";
        setProductFooterState("Changes saved","saved");
        syncProductEditorActions();
      }

      /*
        Keep the success state visible long enough to be understood.
        A first-time Publish closes the editor; draft/update saves remain open.
      */
      await new Promise(function(resolve){setTimeout(resolve,900);});

      if(mode==="publish"){
        hideProductSavingState();
        closeProductEditor(true);
        renderProducts();
      }else{
        hideProductSavingState();
        renderProducts();
        if(mode==="update"){
          syncProductEditorActions();
        }
      }
    }catch(error){
      console.error(error);
      hideProductSavingState();
      showProductMessage(
        error.message||"Unable to save product. Please try again.",
        "error"
      );
    }finally{
      state.productEditor.saving=false;
      setProductBusy(false,mode);
      if(state.productEditor.product)updateProductAll();
    }
  }
  async function uploadProductAssets(productId){
    var result={coverImage:null,fulfilmentFiles:{}};
    if(state.productEditor.coverImageFile){validateFile(state.productEditor.coverImageFile,"image");var cover=await uploadFile(state.productEditor.coverImageFile,"creator-products/"+uid()+"/"+productId+"/cover","image");result.coverImage={downloadURL:cover.downloadURL,storagePath:cover.storagePath||cover.path||"",fileName:state.productEditor.coverImageFile.name,type:state.productEditor.coverImageFile.type,size:state.productEditor.coverImageFile.size};}
    var keys=Object.keys(state.productEditor.fulfilmentFiles);
    for(var i=0;i<keys.length;i++){
      var key=keys[i],file=state.productEditor.fulfilmentFiles[key];validateFile(file,"file");
      var uploaded=await uploadFile(file,"creator-products/"+uid()+"/"+productId+"/delivery/"+key,"digital_product");
      result.fulfilmentFiles[key]={downloadURL:uploaded.downloadURL,storagePath:uploaded.storagePath||uploaded.path||"",fileName:file.name,type:file.type,size:file.size,uploadedAt:new Date().toISOString()};
    }
    return result;
  }
  function setProductBusy(busy,mode){
    var nodes=[
      el.clikkerSaveProductDraft,
      el.clikkerPublishProduct,
      el.clikkerArchiveProduct,
      el.clikkerCancelProductEdit,
      el.clikkerProductEditorClose,
      el.clikkerProductPreviousStep,
      el.clikkerProductNextStep
    ];

    nodes.forEach(function(node){
      if(!node)return;
      node.disabled=busy;
      node.setAttribute("aria-disabled",busy?"true":"false");
    });

    if(el.clikkerProductEditor){
      el.clikkerProductEditor.setAttribute("aria-busy",busy?"true":"false");
      el.clikkerProductEditor.classList.toggle("is-saving",busy);

      el.clikkerProductEditor
        .querySelectorAll("input,select,textarea,[data-product-tab],[data-add-buyer-field]")
        .forEach(function(node){
          if(busy){
            if(!node.hasAttribute("data-save-lock-disabled")){
              node.setAttribute(
                "data-save-lock-disabled",
                node.disabled?"already":"temporary"
              );
            }
            node.disabled=true;
          }else if(node.getAttribute("data-save-lock-disabled")==="temporary"){
            node.disabled=false;
            node.removeAttribute("data-save-lock-disabled");
          }else if(node.getAttribute("data-save-lock-disabled")==="already"){
            node.removeAttribute("data-save-lock-disabled");
          }
        });
    }

    if(el.clikkerSaveProductDraft&&busy){
      el.clikkerSaveProductDraft.textContent=
        mode==="update"
          ?"Saving changes…"
          :mode==="draft"
            ?"Saving draft…"
            :"Please wait…";
    }

    if(el.clikkerPublishProduct&&busy){
      el.clikkerPublishProduct.textContent=
        mode==="publish"?"Publishing…":"Please wait…";
    }

    if(busy&&el.clikkerProductEditorSaveStatus){
      el.clikkerProductEditorSaveStatus.textContent=
        mode==="publish"
          ?"Publishing securely…"
          :mode==="update"
            ?"Saving changes…"
            :"Saving securely…";
      setProductFooterState(
        mode==="publish"
          ?"Publishing…"
          :mode==="update"
            ?"Saving changes…"
            :"Saving…",
        "saving"
      );
    }

    if(!busy&&state.productEditor.product){
      syncProductEditorActions();
    }
  }
  function showProductMessage(msg,type){
    if(!el.clikkerProductEditorAlert)return;
    el.clikkerProductEditorAlert.className="ccx-alert is-visible ccx-alert--"+type;
    el.clikkerProductEditorAlert.textContent=msg;
    el.clikkerProductEditorAlert.setAttribute("role",type==="error"?"alert":"status");
  }
  function closeProductEditor(force){
    if(state.productEditor.saving)return;
    if(!force&&state.productEditor.dirty&&!confirm("Close without saving changes?"))return;
    cleanupProductObjectURLs();
    el.clikkerProductEditor.classList.remove("is-open");el.clikkerProductEditor.setAttribute("aria-hidden","true");document.body.style.overflow="";
    state.productEditor.product=null;state.productEditor.coverImageFile=null;state.productEditor.fulfilmentFiles={};state.productEditor.dirty=false;
    if(el.clikkerSaveProductDraft){
      el.clikkerSaveProductDraft.hidden=false;
      el.clikkerSaveProductDraft.textContent="Save draft";
      setProductSaveButtonPrimary(false);
    }
    if(el.clikkerPublishProduct){
      el.clikkerPublishProduct.hidden=false;
      el.clikkerPublishProduct.textContent="Publish product";
    }
    if(el.clikkerCancelProductEdit){
      el.clikkerCancelProductEdit.textContent="Cancel";
    }
  }
  async function archiveProduct(){
    if(!state.productEditor.persisted){
      closeProductEditor(true);
      return;
    }

    var product=state.productEditor.product||{};
    if(isArchivedProduct(product)){
      closeProductEditor(true);
      return;
    }

    if(!confirm(
      'Archive "'+(product.title||"this product")+'"? It will be removed from your active product list and unavailable for new purchases. You can restore it later.'
    )){
      return;
    }

    setProductBusy(true);
    try{
      await db().collection("products").doc(product.id).set({
        status:"archived",
        visibility:"private",
        archivedAt:serverTimestamp(),
        updatedAt:serverTimestamp()
      },{merge:true});

      closeProductEditor(true);
      await loadProducts();
      state.productFilter="all";
      renderProducts();
      showAlert(
        '"'+(product.title||"Product")+'" was archived. You can restore it from the Archived tab.',
        "success"
      );
    }catch(error){
      showProductMessage(
        firebaseMessage(error,"Unable to archive this product right now."),
        "error"
      );
    }finally{
      setProductBusy(false);
    }
  }
  function renderProductCoverPreview(p){
    var node=el.clikkerEditorPreviewCover;
    if(!node)return;
    node.innerHTML="";

    var file=state.productEditor.coverImageFile;
    var url=file?makeObjectURL(file):productCoverURL(p);

    if(url){
      var img=document.createElement("img");
      img.src=url;
      img.alt=productCoverAlt(p);
      img.decoding="async";
      img.style.cssText="width:100%;height:100%;object-fit:cover;display:block";
      node.appendChild(img);
    }else{
      node.textContent=iconOf(typeOf(p));
    }
  }
  function makeObjectURL(file){var url=URL.createObjectURL(file);state.productEditor.objectURLs.push(url);return url;}
  function cleanupProductObjectURLs(){state.productEditor.objectURLs.forEach(function(url){try{URL.revokeObjectURL(url);}catch(_){}});state.productEditor.objectURLs=[];}

  function openFieldDrawer(index){
    state.productEditor.fieldEditIndex=index;
    var f=index>=0?state.productEditor.buyerFields[index]:buyer("","","text",true);
    el.clikkerBuyerFieldDrawerTitle.textContent=index>=0?"Edit customer field":"Add customer field";
    el.buyerFieldLabel.value=f.label||"";el.buyerFieldKey.value=f.key||"";el.buyerFieldType.value=f.type||"text";
    el.buyerFieldPlaceholder.value=f.placeholder||"";el.buyerFieldHelpText.value=f.helpText||"";el.buyerFieldRequired.checked=f.required!==false;
    el.buyerFieldOptions.value=(f.options||[]).join("\n");el.buyerFieldOptionsWrap.hidden=el.buyerFieldType.value!=="select";
    el.clikkerBuyerFieldDrawer.classList.add("is-open");
  }
  function closeFieldDrawer(){el.clikkerBuyerFieldDrawer.classList.remove("is-open");}
  function saveField(){
    var label=clean(el.buyerFieldLabel.value),key=slugify(el.buyerFieldKey.value||label).replaceAll("-","_");
    if(!label||!key)return alert("Field label and key are required.");
    var duplicate=state.productEditor.buyerFields.some(function(x,i){return i!==state.productEditor.fieldEditIndex&&x.key===key;});
    if(duplicate)return alert("Each customer field must have a unique key.");
    var existing=state.productEditor.fieldEditIndex>=0?state.productEditor.buyerFields[state.productEditor.fieldEditIndex]:null;
    var f={label:label,key:key,type:el.buyerFieldType.value,placeholder:clean(el.buyerFieldPlaceholder.value),helpText:clean(el.buyerFieldHelpText.value),required:el.buyerFieldRequired.checked,options:el.buyerFieldType.value==="select"?splitList(el.buyerFieldOptions.value):[],system:!!(existing&&existing.system)};
    if(state.productEditor.fieldEditIndex>=0)state.productEditor.buyerFields[state.productEditor.fieldEditIndex]=f;else state.productEditor.buyerFields.push(f);
    closeFieldDrawer();markProductDirty();renderBuyerFields();
  }
  function renderBuyerPreview(){el.clikkerCustomerFormPreview.innerHTML=state.productEditor.buyerFields.map(function(f){return '<div class="ccx-readiness-item"><span>'+escapeHTML(f.label)+'</span><strong>'+escapeHTML(f.type)+'</strong></div>';}).join("");}


  /* ==========================================================================
     PAID ORDERS / PERSONAL REPLY FULFILMENT
     ========================================================================== */

  function injectOrdersStyles(){
    if(byId("clikkerOrdersRuntimeStyles"))return;

    var style=document.createElement("style");
    style.id="clikkerOrdersRuntimeStyles";
    style.textContent=
      ".ccx-nav__count{margin-left:auto;min-width:22px;height:22px;padding:0 6px;border-radius:999px;display:inline-grid;place-items:center;background:#d92d20;color:#fff;font-size:10px;font-weight:900}"+
      ".ccx-orders{display:grid;gap:20px}.ccx-orders__hero{padding:26px;border:1px solid #e4e7ec;border-radius:22px;display:grid;grid-template-columns:minmax(0,1fr) auto;gap:24px;background:linear-gradient(145deg,#fff,#f8fafc);box-shadow:0 8px 24px rgba(16,24,40,.05)}"+
      ".ccx-orders__hero h2{margin:0;font-size:30px;letter-spacing:-.04em}.ccx-orders__hero p{max-width:650px;margin:8px 0 0;color:#667085;line-height:1.65}.ccx-orders__summary{display:grid;grid-template-columns:repeat(4,minmax(100px,1fr));gap:10px}.ccx-orders__summary article{padding:14px;border:1px solid #e4e7ec;border-radius:14px;background:#fff}.ccx-orders__summary span{display:block;color:#667085;font-size:10px;font-weight:800}.ccx-orders__summary strong{display:block;margin-top:5px;font-size:20px}"+
      ".ccx-orders__toolbar{display:flex;align-items:center;justify-content:space-between;gap:16px;flex-wrap:wrap}.ccx-orders__filters{display:flex;gap:7px;flex-wrap:wrap}.ccx-orders__filters button{min-height:40px;padding:0 13px;border:1px solid #e4e7ec;border-radius:999px;background:#fff;color:#475467;font-weight:800}.ccx-orders__filters button.is-active{border-color:#101828;background:#101828;color:#fff}.ccx-orders__filters button span{margin-left:5px;opacity:.75}.ccx-orders__tools{display:flex;gap:9px}.ccx-search{min-height:42px;padding:0 13px;border:1px solid #d0d5dd;border-radius:12px;display:flex;align-items:center;gap:8px;background:#fff}.ccx-search input{width:240px;border:0;outline:0;background:transparent}"+
      ".ccx-orders__list{display:grid;gap:12px}.ccx-order-card{padding:18px;border:1px solid #e4e7ec;border-radius:18px;display:grid;grid-template-columns:minmax(0,1fr) auto;gap:18px;align-items:center;background:#fff;box-shadow:0 2px 8px rgba(16,24,40,.04)}.ccx-order-card:hover{border-color:#b8c0cc;box-shadow:0 10px 28px rgba(16,24,40,.08)}.ccx-order-card__top{display:flex;gap:10px;align-items:center;flex-wrap:wrap}.ccx-order-card h3{margin:9px 0 4px;font-size:17px}.ccx-order-card p{margin:0;color:#667085;line-height:1.55}.ccx-order-card__meta{margin-top:12px;display:flex;gap:8px;flex-wrap:wrap}.ccx-order-card__meta span{padding:6px 9px;border-radius:999px;background:#f2f4f7;color:#475467;font-size:10px;font-weight:750}.ccx-order-card__amount{text-align:right}.ccx-order-card__amount strong{display:block;font-size:20px}.ccx-order-card__amount small{display:block;margin:4px 0 10px;color:#667085}"+
      ".ccx-status{display:inline-flex;padding:6px 9px;border-radius:999px;background:#f2f4f7;color:#475467;font-size:9px;font-weight:900;text-transform:uppercase}.ccx-status--new{background:#eff8ff;color:#175cd3}.ccx-status--progress{background:#fffaeb;color:#b54708}.ccx-status--delivered{background:#ecfdf3;color:#067647}.ccx-order-drawer{position:fixed;inset:0;z-index:500}.ccx-order-drawer__backdrop{position:absolute;inset:0;background:rgba(16,24,40,.56);backdrop-filter:blur(4px)}.ccx-order-drawer__panel{position:absolute;top:0;right:0;width:min(720px,100%);height:100dvh;max-height:100dvh;overflow:hidden;background:#fff;box-shadow:-24px 0 70px rgba(16,24,40,.2)}.ccx-order-drawer__head{position:absolute;top:0;left:0;right:0;z-index:5;min-height:112px;padding:20px 24px;border-bottom:1px solid #e4e7ec;display:flex;justify-content:space-between;gap:18px;align-items:center;background:#fff}.ccx-order-drawer__foot{position:absolute;left:0;right:0;bottom:0;z-index:6;min-height:82px;padding:16px 24px;border-top:1px solid #e4e7ec;display:flex;justify-content:space-between;gap:18px;align-items:center;background:#fff;box-shadow:0 -12px 32px rgba(16,24,40,.1)}.ccx-order-drawer__head h2{margin:8px 0 3px}.ccx-order-drawer__head p{margin:0;color:#667085}.ccx-order-drawer__body{position:absolute;top:112px;left:0;right:0;bottom:82px;padding:22px 24px 28px;overflow-y:auto;overscroll-behavior:contain;background:#f8fafc}.ccx-order-section{margin-bottom:16px;padding:20px;border:1px solid #e4e7ec;border-radius:18px;background:#fff}.ccx-order-section>header{display:flex;gap:12px;margin-bottom:17px}.ccx-order-section h3{margin:0}.ccx-order-section header p{margin:4px 0 0;color:#667085}.ccx-order-section__number{width:30px;height:30px;border-radius:10px;display:grid;place-items:center;background:#101828;color:#fff;font-weight:900}.ccx-order-details{margin:0;display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:12px}.ccx-order-details div,.ccx-order-request>div{padding:13px;border-radius:12px;background:#f8fafc}.ccx-order-details dt,.ccx-order-request span{color:#667085;font-size:9px;font-weight:850;text-transform:uppercase}.ccx-order-details dd{margin:5px 0 0;font-weight:850}.ccx-order-request{display:grid;gap:10px}.ccx-order-request strong,.ccx-order-request p{display:block;margin:5px 0 0;white-space:pre-wrap}.ccx-order-timeline{margin:0;padding:0;list-style:none;display:grid;gap:10px}.ccx-order-timeline li{padding-left:18px;position:relative}.ccx-order-timeline li:before{content:'';position:absolute;left:0;top:7px;width:8px;height:8px;border-radius:50%;background:#12b76a}.ccx-order-drawer__actions{display:flex;gap:9px;flex-wrap:wrap}.ccx-icon-btn{width:42px;height:42px;border:1px solid #e4e7ec;border-radius:12px;background:#fff;font-size:24px}"+
      "@media(max-width:900px){.ccx-orders__hero{grid-template-columns:1fr}.ccx-orders__summary{grid-template-columns:repeat(2,1fr)}.ccx-order-card{grid-template-columns:1fr}.ccx-order-card__amount{text-align:left}.ccx-search input{width:170px}}@media(max-width:560px){.ccx-orders__summary{grid-template-columns:1fr 1fr}.ccx-order-details{grid-template-columns:1fr}.ccx-order-drawer__foot{align-items:stretch;flex-direction:column}.ccx-order-drawer__actions{display:grid}.ccx-order-drawer__actions .ccx-btn{width:100%}}";
    document.head.appendChild(style);
  }

  function dateValue(value){
    if(!value)return null;
    try{
      if(typeof value.toDate==="function")return value.toDate();
      if(value.seconds)return new Date(value.seconds*1000);
      var parsed=new Date(value);
      return isNaN(parsed.getTime())?null:parsed;
    }catch(_){return null;}
  }

  function dateText(value){
    var date=dateValue(value);
    if(!date)return "—";
    return new Intl.DateTimeFormat("en-IN",{
      day:"2-digit",month:"short",year:"numeric",hour:"2-digit",minute:"2-digit"
    }).format(date);
  }

  function orderCreatorId(){
    var raw=state.creator&&state.creator.raw||{};
    return clean(
      (state.creator&&state.creator.id)||
      raw.id||
      raw.creatorId||
      raw.creator_id||
      uid()
    );
  }

  function orderStoreId(){
    return clean(state.store&&state.store.id);
  }

  function orderStatusKey(order){
    var status=clean(order.fulfilmentStatus||order.fulfillmentStatus||"not_started").toLowerCase();
    if(status==="delivered"||status==="completed")return "delivered";
    if(status==="in_progress"||status==="started"||status==="processing")return "in_progress";
    return "new";
  }

  function orderStatusLabel(order){
    var key=orderStatusKey(order);
    return key==="in_progress"?"In progress":key==="delivered"?"Delivered":"New";
  }

  function orderStatusClass(order){
    var key=orderStatusKey(order);
    return key==="in_progress"?"progress":key==="delivered"?"delivered":"new";
  }

  function orderRequirements(order){
    return order&&order.buyerRequirements&&typeof order.buyerRequirements==="object"
      ? order.buyerRequirements
      : {};
  }

  function requirementValue(order,keys,fallback){
    var requirements=orderRequirements(order);
    for(var i=0;i<keys.length;i++){
      var value=requirements[keys[i]];
      if(value!==undefined&&value!==null&&value!=="")return value;
    }
    return fallback||"";
  }

  function buyerName(order){
    return clean(
      (order.buyer&&order.buyer.name)||
      requirementValue(order,["customerName","buyerName","name"],"Customer")
    );
  }

  function preferredReplyFormat(order){
    return clean(requirementValue(order,[
      "preferredReplyFormat","preferredFormat","replyFormat",
      "reply_format","preferred_reply_format"
    ],"Creator can choose"));
  }

  function orderQuestion(order){
    return clean(requirementValue(order,[
      "question","message","questionOrMessage","customerQuestion","requirements"
    ],"No question provided."));
  }

  function orderInstagram(order){
    return clean(requirementValue(order,[
      "instagramUsername","instagram","instagramHandle","socialUsername"
    ],"—"));
  }

  function orderAmount(order){
    return Number(
      (order.amount&&order.amount.total)||
      order.shopifyTotalPaid||
      order.shopifyAmount||
      0
    );
  }

  function deliveryDeadline(order){
    var paid=dateValue(order.paidAt||order.paymentConfirmedAt||order.createdAt);
    if(!paid)return null;
    var hours=Number(
      (order.productSnapshot&&order.productSnapshot.deliveryHours)||
      order.deliveryHours||
      48
    );
    return new Date(paid.getTime()+hours*60*60*1000);
  }

  async function loadOrders(showFailure){
    if(state.ordersLoading)return;
    state.ordersLoading=true;

    var creatorId=orderCreatorId();
    var storeId=orderStoreId();
    var attempts=[
      {
        label:"ownerId",
        enabled:!!uid(),
        query:function(){
          return db().collection("orders").where("ownerId","==",uid()).get();
        }
      },
      {
        label:"creatorId",
        enabled:!!creatorId,
        query:function(){
          return db().collection("orders")
            .where("creatorId","==",creatorId).get();
        }
      },
      {
        label:"creator_id",
        enabled:!!creatorId,
        query:function(){
          return db().collection("orders")
            .where("creator_id","==",creatorId).get();
        }
      },
      {
        label:"storeId",
        enabled:!!storeId,
        query:function(){
          return db().collection("orders")
            .where("storeId","==",storeId).get();
        }
      },
      {
        label:"store_id",
        enabled:!!storeId,
        query:function(){
          return db().collection("orders")
            .where("store_id","==",storeId).get();
        }
      }
    ];

    var rows=[];
    var errors=[];

    try{
      for(var i=0;i<attempts.length;i++){
        if(!attempts[i].enabled)continue;

        try{
          var snap=await withTimeout(
            attempts[i].query(),
            TIMEOUTS.query,
            "Loading creator orders"
          );

          rows=snap.docs.map(function(doc){
            return Object.assign({id:doc.id},doc.data());
          });

          console.info(
            "[Clikker Orders] Loaded",
            rows.length,
            "using",
            attempts[i].label
          );
          break;
        }catch(error){
          errors.push({query:attempts[i].label,error:error});
        }
      }

      if(!rows.length&&errors.length){
        var orderPermissionOnly=errors.length&&errors.every(function(item){
          return isPermissionError(item&&item.error);
        });
        if(!orderPermissionOnly){
          console.warn("[Clikker Orders] Creator queries failed",errors);
        }
        if(showFailure){
          showAlert(
            "Orders could not be loaded right now. Please refresh and try again.",
            "error"
          );
        }
      }

      state.orders=rows.filter(function(order){
        return clean(order.paymentStatus).toLowerCase()==="paid";
      }).sort(function(a,b){
        var da=dateValue(a.paidAt||a.paymentConfirmedAt||a.createdAt);
        var dbb=dateValue(b.paidAt||b.paymentConfirmedAt||b.createdAt);
        return (dbb?dbb.getTime():0)-(da?da.getTime():0);
      });
    }finally{
      state.ordersLoading=false;
      updateOrdersNavCount();
    }
  }

  function updateOrdersNavCount(){
    var count=state.orders.filter(function(order){
      return orderStatusKey(order)==="new";
    }).length;

    if(el.clikkerOrdersNavCount){
      el.clikkerOrdersNavCount.textContent=String(count);
      el.clikkerOrdersNavCount.hidden=count===0;
    }
  }

  function filteredOrders(){
    var search=clean(state.orderSearch).toLowerCase();

    return state.orders.filter(function(order){
      var matchesStatus=state.orderFilter==="all"||
        orderStatusKey(order)===state.orderFilter;
      if(!matchesStatus)return false;
      if(!search)return true;

      var haystack=[
        order.orderNumber,order.shopifyOrderName,
        buyerName(order),orderQuestion(order),
        order.productSnapshot&&order.productSnapshot.title
      ].map(clean).join(" ").toLowerCase();

      return haystack.indexOf(search)>=0;
    });
  }

  function orderCard(order){
    var type=typeOf(order);
    var title=clean(
      order.productSnapshot&&order.productSnapshot.title||
      labelOf(type)
    );
    var deadline=deliveryDeadline(order);
    var overdue=deadline&&deadline.getTime()<Date.now()&&orderStatusKey(order)!=="delivered";
    var requirements=orderRequirements(order);
    var summary=clean(
      requirements.question||
      requirements.messageInstructions||
      requirements.callReason||
      requirements.promotionDetails||
      requirements.requirements||
      requirements.customerNote||
      requirements.joiningReason||
      requirements.interest||
      "Open the order to review buyer requirements."
    );

    return '<article class="ccx-order-card">'+
      '<div>'+
        '<div class="ccx-order-card__top">'+
          '<span class="ccx-status ccx-status--'+orderStatusClass(order)+'">'+escapeHTML(orderStatusLabel(order))+'</span>'+
          '<span>'+escapeHTML(order.orderNumber||order.shopifyOrderName||order.id)+'</span>'+
          '<span>'+escapeHTML(iconOf(type)+" "+labelOf(type))+'</span>'+
          (overdue?'<span class="ccx-status" style="background:#fef3f2;color:#b42318">Overdue</span>':'')+
        '</div>'+
        '<h3>'+escapeHTML(title)+' · '+escapeHTML(buyerName(order))+'</h3>'+
        '<p>'+escapeHTML(summary)+'</p>'+
        '<div class="ccx-order-card__meta">'+
          '<span>'+escapeHTML(labelOf(type))+'</span>'+
          '<span>Paid '+escapeHTML(dateText(order.paidAt||order.paymentConfirmedAt))+'</span>'+
          '<span>Due '+escapeHTML(dateText(deadline))+'</span>'+
        '</div>'+
      '</div>'+
      '<div class="ccx-order-card__amount">'+
        '<strong>'+escapeHTML(money(orderAmount(order),(order.amount&&order.amount.currency)||order.shopifyPaidCurrency||"INR"))+'</strong>'+
        '<small>'+escapeHTML(order.shopifyOrderName||"Shopify paid")+'</small>'+
        '<button class="ccx-btn ccx-btn--primary" type="button" data-open-order="'+escapeHTML(order.id)+'">Open order</button>'+
      '</div>'+
    '</article>';
  }

  function updateOrderSummary(){
    var counts={new:0,in_progress:0,delivered:0};
    var total=0;

    state.orders.forEach(function(order){
      counts[orderStatusKey(order)]++;
      total+=orderAmount(order);
    });

    [
      ["clikkerOrdersNewCount",counts.new],
      ["clikkerOrdersProgressCount",counts.in_progress],
      ["clikkerOrdersDeliveredCount",counts.delivered],
      ["clikkerOrdersNewFilterCount",counts.new],
      ["clikkerOrdersProgressFilterCount",counts.in_progress],
      ["clikkerOrdersDeliveredFilterCount",counts.delivered],
      ["clikkerOrdersAllFilterCount",state.orders.length]
    ].forEach(function(pair){
      var node=byId(pair[0]);if(node)node.textContent=String(pair[1]);
    });

    var paid=byId("clikkerOrdersPaidValue");
    if(paid)paid.textContent=money(total,"INR");
    updateOrdersNavCount();
  }

  function renderOrdersList(){
    var list=byId("clikkerOrdersList");
    var empty=byId("clikkerOrdersEmpty");
    var rows=filteredOrders();

    if(!list||!empty)return;

    list.innerHTML=rows.map(orderCard).join("");
    empty.hidden=rows.length>0;

    if(!rows.length){
      var title=byId("clikkerOrdersEmptyTitle");
      var message=byId("clikkerOrdersEmptyMessage");
      if(title)title.textContent=state.orderSearch?"No matching orders":
        state.orderFilter==="new"?"No new orders":
        state.orderFilter==="in_progress"?"No orders in progress":
        state.orderFilter==="delivered"?"No delivered orders":"No paid orders";
      if(message)message.textContent=state.orderSearch
        ?"Try another order number, buyer name or product."
        :"Paid customer orders will appear here automatically.";
    }

    list.querySelectorAll("[data-open-order]").forEach(function(button){
      button.onclick=function(){openOrder(button.dataset.openOrder);};
    });

    updateOrderSummary();
  }

  async function renderOrders(){
    clearAlert();
    injectOrdersStyles();
    setHeader("Orders","Manage paid orders and complete every creator delivery",
      '<button class="ccx-btn ccx-btn--secondary" id="clikkerOrdersTopRefresh" type="button">Refresh</button>');

    var template=el.clikkerOrdersViewTemplate||byId("clikkerOrdersViewTemplate");
    if(!template){
      el.clikkerCreatorView.innerHTML='<div class="ccx-empty"><h3>Orders interface missing</h3><p>Install the updated page.clikker-profile.liquid file.</p></div>';
      return;
    }

    el.clikkerCreatorView.innerHTML="";
    el.clikkerCreatorView.appendChild(template.content.cloneNode(true));

    var share=byId("clikkerOrdersShareStore");
    if(share&&state.store&&state.store.slug){
      share.href="/pages/c?creator="+encodeURIComponent(state.store.slug);
    }

    byId("clikkerOrdersFilters").querySelectorAll("[data-order-filter]").forEach(function(button){
      var active=button.dataset.orderFilter===state.orderFilter;
      button.classList.toggle("is-active",active);
      button.setAttribute("aria-selected",active?"true":"false");
      button.onclick=function(){
        state.orderFilter=button.dataset.orderFilter;
        byId("clikkerOrdersFilters").querySelectorAll("[data-order-filter]").forEach(function(item){
          var selected=item===button;
          item.classList.toggle("is-active",selected);
          item.setAttribute("aria-selected",selected?"true":"false");
        });
        renderOrdersList();
      };
    });

    var search=byId("clikkerOrdersSearch");
    search.value=state.orderSearch;
    search.oninput=function(){
      state.orderSearch=this.value;
      renderOrdersList();
    };

    async function refreshOrders(){
      var loading=byId("clikkerOrdersLoading");
      var list=byId("clikkerOrdersList");
      if(loading)loading.hidden=false;
      if(list)list.setAttribute("aria-busy","true");
      await loadOrders(true);
      if(loading)loading.hidden=true;
      if(list)list.removeAttribute("aria-busy");
      renderOrdersList();
    }

    byId("clikkerOrdersRefresh").onclick=refreshOrders;
    var topRefresh=byId("clikkerOrdersTopRefresh");
    if(topRefresh)topRefresh.onclick=refreshOrders;

    renderOrdersList();
    if(!state.orders.length)await refreshOrders();
  }

  var ORDER_FULFILMENT_CONFIG = {
    creator_reply: {
      title:"Deliver the Personal Reply",
      help:"Add the final response, voice note, video or secure link.",
      summary:"Respond in the format promised to the buyer.",
      formats:["text","voice_note","video","external_link"],
      defaultFormat:"text",
      noteLabel:"Reply or delivery message",
      noteHelp:"Write the response here or add a short note explaining the linked delivery.",
      linkLabel:"Voice, video or delivery link",
      linkHelp:"Required when the response is hosted outside Clikker.",
      fileLabel:"Upload reply file",
      fileHelp:"Optional audio, video, image or document delivery."
    },
    video_message: {
      title:"Deliver the Video Message",
      help:"Upload the completed video or provide a secure video link.",
      summary:"Check the recipient, occasion, instructions and things to avoid before delivery.",
      formats:["video","file","external_link"],
      defaultFormat:"video",
      noteLabel:"Message to the buyer",
      noteHelp:"Add a short note that will appear with the delivered video.",
      linkLabel:"Secure video link",
      linkHelp:"Use a private HTTPS link when the video is hosted outside Clikker.",
      fileLabel:"Upload completed video",
      fileHelp:"Upload the final video file. Maximum 50 MB in this dashboard."
    },
    scheduled_call: {
      title:"Confirm the 1-to-1 Call",
      help:"Set the confirmed date, time, platform and meeting details.",
      summary:"Confirm a time with the buyer before marking the booking delivered.",
      formats:["meeting","external_link"],
      defaultFormat:"meeting",
      noteLabel:"Call instructions",
      noteHelp:"Add joining instructions, preparation notes or contact details.",
      linkLabel:"Meeting link",
      linkHelp:"Add the Google Meet, Zoom or other secure meeting URL.",
      fileLabel:"Optional preparation file",
      fileHelp:"Attach an agenda, worksheet or preparation document.",
      schedule:true
    },
    social_promotion: {
      title:"Complete the Social Promotion",
      help:"Record approval and provide the published promotion URL.",
      summary:"Review the brand, campaign goal, promotion details and requested date.",
      formats:["published_url","external_link","file"],
      defaultFormat:"published_url",
      noteLabel:"Promotion report",
      noteHelp:"Explain what was published, when it was posted and any relevant result.",
      linkLabel:"Published content URL",
      linkHelp:"Add the live Instagram, YouTube or other promotion URL.",
      fileLabel:"Optional proof or report",
      fileHelp:"Upload a screenshot, report or approved creative."
    },
    digital_download: {
      title:"Deliver the Digital Product",
      help:"Upload the purchased file or provide a secure download link.",
      summary:"The buyer should receive immediate, reliable access to the purchased resource.",
      formats:["file","external_link"],
      defaultFormat:"file",
      noteLabel:"Download instructions",
      noteHelp:"Add access, licence, password or usage instructions.",
      linkLabel:"Secure download link",
      linkHelp:"Use an HTTPS link when the file is hosted outside Clikker.",
      fileLabel:"Upload digital product",
      fileHelp:"Upload the final guide, template, audio, video, ZIP or document."
    },
    content_access: {
      title:"Grant Exclusive Content Access",
      help:"Provide the private access link and any joining instructions.",
      summary:"Confirm the access duration and content included in the buyer's purchase.",
      formats:["access_link","external_link","file"],
      defaultFormat:"access_link",
      noteLabel:"Access instructions",
      noteHelp:"Explain how to sign in, what is included and when access expires.",
      linkLabel:"Private content link",
      linkHelp:"Add the secure library, course, folder or content URL.",
      fileLabel:"Optional access file",
      fileHelp:"Upload a guide, welcome pack or included resource."
    },
    community_access: {
      title:"Grant Community Access",
      help:"Provide the private invitation link and community joining instructions.",
      summary:"Confirm the platform, buyer contact details and rules agreement.",
      formats:["access_link","external_link"],
      defaultFormat:"access_link",
      noteLabel:"Community joining instructions",
      noteHelp:"Explain how to join, identify themselves and follow the community rules.",
      linkLabel:"Private invitation link",
      linkHelp:"Add the WhatsApp, Telegram, Discord or other invitation URL.",
      fileLabel:"Optional welcome file",
      fileHelp:"Upload community guidelines or a welcome document."
    },
    custom_service: {
      title:"Deliver the Custom Service",
      help:"Add the completed deliverable, secure link, file and buyer-facing note.",
      summary:"Review the agreed requirements and deliverable before submission.",
      formats:["text","file","external_link","video"],
      defaultFormat:"file",
      noteLabel:"Delivery note",
      noteHelp:"Summarize what was completed and explain any next steps.",
      linkLabel:"Delivery link",
      linkHelp:"Add a secure HTTPS link when the work is hosted externally.",
      fileLabel:"Upload completed work",
      fileHelp:"Upload the final file, document, image, audio, video or ZIP."
    }
  };

  function orderBuyerEmail(order){
    var requirements=orderRequirements(order);
    return clean(
      order.shopifyCustomerEmail||
      (order.buyer&&order.buyer.email)||
      requirements.customerEmail||
      requirements.email||
      "—"
    );
  }

  function orderBuyerPhone(order){
    var requirements=orderRequirements(order);
    return clean(
      (order.buyer&&order.buyer.phone)||
      requirements.customerPhone||
      requirements.phone||
      requirements.whatsappNumber||
      "—"
    );
  }

  function humanFieldLabel(key){
    var known={
      customerName:"Buyer name",
      buyerName:"Buyer name",
      customerEmail:"Email",
      customerPhone:"Phone",
      instagramUsername:"Instagram username",
      question:"Question or message",
      preferredReplyFormat:"Preferred reply format",
      preferredFormat:"Preferred reply format",
      recipientName:"Recipient name",
      occasion:"Occasion",
      messageInstructions:"Message instructions",
      thingsToAvoid:"Things to avoid",
      callReason:"Call reason",
      preferredDate:"Preferred date",
      preferredSlot:"Preferred time slot",
      brandName:"Brand name",
      brandURL:"Brand URL",
      campaignGoal:"Campaign goal",
      promotionDetails:"Promotion details",
      customerNote:"Buyer note",
      interest:"Buyer interest",
      joiningReason:"Joining reason",
      rulesAgreement:"Community rules agreed",
      requirements:"Requirements",
      referenceURL:"Reference URL",
      referenceFile:"Reference file"
    };
    return known[key]||titleCase(key);
  }

  function displayRequirementValue(value){
    if(value===true)return "Yes";
    if(value===false)return "No";
    if(value==null||value==="")return "";
    if(typeof value==="object"){
      if(value.downloadURL)return value.downloadURL;
      if(value.url)return value.url;
      if(value.name)return value.name;
      try{return JSON.stringify(value);}
      catch(_){return String(value);}
    }
    return String(value);
  }

  function renderOrderRequirements(order){
    if(!el.clikkerOrderRequirementsList)return;
    var requirements=orderRequirements(order);
    var hidden={customerName:1,buyerName:1,name:1,customerEmail:1,email:1,customerPhone:1,phone:1};
    var rows=Object.keys(requirements).filter(function(key){
      return !hidden[key]&&displayRequirementValue(requirements[key]);
    });

    el.clikkerOrderRequirementsList.innerHTML=rows.map(function(key){
      var value=displayRequirementValue(requirements[key]);
      var safeValue=escapeHTML(value);
      var content=/^https?:\/\//i.test(value)
        ? '<a href="'+safeValue+'" target="_blank" rel="noopener noreferrer">'+safeValue+'</a>'
        : '<p>'+safeValue+'</p>';
      return '<article class="ccx-order-dynamic-item">'+
        '<span>'+escapeHTML(humanFieldLabel(key))+'</span>'+
        content+
      '</article>';
    }).join("");
  }

  function deliveryConfig(order){
    return ORDER_FULFILMENT_CONFIG[typeOf(order)]||ORDER_FULFILMENT_CONFIG.custom_service;
  }

  function deliveryFormatLabel(format){
    var labels={
      text:"Text response",
      voice_note:"Voice note",
      video:"Video",
      video_reply:"Video",
      file:"Uploaded file",
      external_link:"Secure external link",
      meeting:"Meeting or call",
      access_link:"Access or invitation link",
      published_url:"Published content URL"
    };
    return labels[format]||titleCase(format);
  }

  function configureDeliveryFormatOptions(config,currentValue){
    if(!el.clikkerOrderDeliveryFormat)return;
    var allowed=config.formats||[];
    var options=['<option value="">Choose delivery method</option>'].concat(
      allowed.map(function(format){
        return '<option value="'+escapeHTML(format)+'">'+escapeHTML(deliveryFormatLabel(format))+'</option>';
      })
    );
    el.clikkerOrderDeliveryFormat.innerHTML=options.join("");
    var selected=clean(currentValue);
    if(selected==="video_reply")selected="video";
    el.clikkerOrderDeliveryFormat.value=allowed.indexOf(selected)>=0
      ? selected
      : (config.defaultFormat||"");
  }

  function configureOrderFulfilment(order,delivery){
    var type=typeOf(order);
    var config=deliveryConfig(order);
    var title=clean(order.productSnapshot&&order.productSnapshot.title||labelOf(type));

    if(el.clikkerOrderDrawer)el.clikkerOrderDrawer.dataset.orderType=type;
    if(el.clikkerOrderTypeIcon)el.clikkerOrderTypeIcon.textContent=iconOf(type);
    if(el.clikkerOrderTypeLabel)el.clikkerOrderTypeLabel.textContent=labelOf(type);
    if(el.clikkerOrderProductTitle)el.clikkerOrderProductTitle.textContent=title;
    if(el.clikkerOrderFulfilmentTitle)el.clikkerOrderFulfilmentTitle.textContent=config.title;
    if(el.clikkerOrderFulfilmentHelp)el.clikkerOrderFulfilmentHelp.textContent=config.help;
    if(el.clikkerOrderFulfilmentProduct)el.clikkerOrderFulfilmentProduct.textContent=title;
    if(el.clikkerOrderFulfilmentSummary)el.clikkerOrderFulfilmentSummary.textContent=config.summary;
    if(el.clikkerOrderReplyTextLabel)el.clikkerOrderReplyTextLabel.textContent=config.noteLabel;
    if(el.clikkerOrderReplyTextHelp)el.clikkerOrderReplyTextHelp.textContent=config.noteHelp;
    if(el.clikkerOrderDeliveryLinkLabel)el.clikkerOrderDeliveryLinkLabel.textContent=config.linkLabel;
    if(el.clikkerOrderDeliveryLinkHelp)el.clikkerOrderDeliveryLinkHelp.textContent=config.linkHelp;
    if(el.clikkerOrderDeliveryFileLabel)el.clikkerOrderDeliveryFileLabel.textContent=config.fileLabel;
    if(el.clikkerOrderDeliveryFileHelp)el.clikkerOrderDeliveryFileHelp.textContent=config.fileHelp;
    if(el.clikkerOrderScheduleFields)el.clikkerOrderScheduleFields.hidden=!config.schedule;

    configureDeliveryFormatOptions(config,delivery.format||order.deliveryFormat||"");

    if(el.clikkerOrderDynamicFulfilmentFields){
      var items=[];
      var requirements=orderRequirements(order);
      if(type==="scheduled_call"){
        if(requirements.preferredDate)items.push(["Requested date",requirements.preferredDate]);
        if(requirements.preferredSlot)items.push(["Requested time",requirements.preferredSlot]);
        if(requirements.callReason)items.push(["Call reason",requirements.callReason]);
      }else if(type==="video_message"){
        if(requirements.recipientName)items.push(["Recipient",requirements.recipientName]);
        if(requirements.occasion)items.push(["Occasion",requirements.occasion]);
      }else if(type==="social_promotion"){
        if(requirements.brandName)items.push(["Brand",requirements.brandName]);
        if(requirements.preferredDate)items.push(["Requested posting date",requirements.preferredDate]);
      }else if(type==="community_access"){
        if(requirements.customerPhone)items.push(["WhatsApp number",requirements.customerPhone]);
      }

      el.clikkerOrderDynamicFulfilmentFields.innerHTML=items.map(function(item){
        return '<article class="ccx-order-dynamic-item"><span>'+escapeHTML(item[0])+'</span><strong>'+escapeHTML(item[1])+'</strong></article>';
      }).join("");
    }
  }

  function orderTimeline(order){
    var rows=[
      {label:"Payment confirmed",date:order.paymentConfirmedAt||order.paidAt,show:true},
      {label:"Creator started fulfilment",date:order.fulfilmentStartedAt||order.fulfillmentStartedAt,show:orderStatusKey(order)!=="new"},
      {label:"Delivery saved",date:order.deliverySavedAt||order.replySavedAt,show:!!(order.deliverySavedAt||order.replySavedAt)},
      {label:"Order delivered",date:order.deliveredAt,show:orderStatusKey(order)==="delivered"}
    ];

    return rows.filter(function(row){return row.show;}).map(function(row){
      return '<li><strong>'+escapeHTML(row.label)+'</strong><div>'+escapeHTML(dateText(row.date))+'</div></li>';
    }).join("");
  }

  function renderOrderDrawer(order){
    var type=typeOf(order);
    var delivery=order.delivery||order.creatorDelivery||{};
    var status=orderStatusKey(order);

    el.clikkerOrderDrawerStatus.className="ccx-status ccx-status--"+orderStatusClass(order);
    el.clikkerOrderDrawerStatus.textContent=orderStatusLabel(order);
    el.clikkerOrderDrawerTitle.textContent=clean(
      order.productSnapshot&&order.productSnapshot.title||
      labelOf(type)+" order"
    );
    el.clikkerOrderDrawerMeta.textContent=
      (order.orderNumber||order.id)+" · "+(order.shopifyOrderName||"Shopify paid order");
    el.clikkerOrderBuyerName.textContent=buyerName(order);
    if(el.clikkerOrderBuyerEmail)el.clikkerOrderBuyerEmail.textContent=orderBuyerEmail(order);
    if(el.clikkerOrderBuyerPhone)el.clikkerOrderBuyerPhone.textContent=orderBuyerPhone(order);
    if(el.clikkerOrderInstagram)el.clikkerOrderInstagram.textContent=orderInstagram(order);
    el.clikkerOrderPaidAmount.textContent=money(
      orderAmount(order),(order.amount&&order.amount.currency)||order.shopifyPaidCurrency||"INR"
    );
    el.clikkerOrderShopifyName.textContent=clean(order.shopifyOrderName||"—");
    el.clikkerOrderPaidAt.textContent=dateText(order.paidAt||order.paymentConfirmedAt);
    el.clikkerOrderDeadline.textContent=dateText(deliveryDeadline(order));
    if(el.clikkerOrderPreferredFormat)el.clikkerOrderPreferredFormat.textContent=preferredReplyFormat(order);
    if(el.clikkerOrderQuestion)el.clikkerOrderQuestion.textContent=orderQuestion(order);

    renderOrderRequirements(order);
    configureOrderFulfilment(order,delivery);

    el.clikkerOrderDeliveryLink.value=clean(delivery.link||order.deliveryLink||"");
    el.clikkerOrderReplyText.value=clean(
      delivery.replyText||
      delivery.note||
      order.replyText||
      order.deliveryNote||
      ""
    );
    el.clikkerOrderReplyCount.textContent=el.clikkerOrderReplyText.value.length+" / 5000";

    if(el.clikkerOrderScheduledAt){
      var scheduled=clean(delivery.scheduledAt||order.scheduledAt||"");
      if(scheduled&&scheduled.length>=16)scheduled=scheduled.slice(0,16);
      el.clikkerOrderScheduledAt.value=scheduled;
    }
    if(el.clikkerOrderDeliveryPlatform){
      el.clikkerOrderDeliveryPlatform.value=clean(delivery.platform||order.deliveryPlatform||"");
    }
    if(el.clikkerOrderDeliveryFile){
      el.clikkerOrderDeliveryFile.value="";
    }
    state.orderDeliveryFile=null;

    if(el.clikkerOrderDeliveryFileState){
      var fileName=clean(delivery.fileName||order.deliveryFileName||"");
      var downloadURL=clean(delivery.downloadURL||order.deliveryFileURL||"");
      el.clikkerOrderDeliveryFileState.textContent=fileName
        ? "Current file: "+fileName
        : (downloadURL?"A delivery file is already attached.":"No new file selected.");
    }

    el.clikkerOrderTimelineList.innerHTML=orderTimeline(order);
    el.clikkerOrderSaveStatus.textContent="No unsaved changes";

    if(el.clikkerOrderFulfilmentState){
      el.clikkerOrderFulfilmentState.textContent=orderStatusLabel(order);
      el.clikkerOrderFulfilmentState.className="ccx-status ccx-status--"+orderStatusClass(order);
    }

    el.clikkerOrderStart.hidden=status!=="new";
    el.clikkerOrderSaveReply.hidden=status==="delivered";
    el.clikkerOrderMarkDelivered.hidden=status==="delivered";
    if(status!=="delivered")el.clikkerOrderMarkDelivered.textContent="Submit & Mark Delivered";
  }

  function openOrder(orderId){
    var order=state.orders.find(function(item){return item.id===orderId;});
    if(!order)return;

    state.activeOrder=order;
    state.orderDeliveryFile=null;
    renderOrderDrawer(order);
    el.clikkerOrderDrawer.hidden=false;
    el.clikkerOrderDrawer.setAttribute("aria-hidden","false");
    document.body.classList.add("ccx-order-drawer-open");
    setTimeout(function(){el.clikkerOrderDrawerClose.focus();},20);
  }

  function closeOrderDrawer(){
    if(!el.clikkerOrderDrawer)return;
    el.clikkerOrderDrawer.hidden=true;
    el.clikkerOrderDrawer.setAttribute("aria-hidden","true");
    document.body.classList.remove("ccx-order-drawer-open");
    state.activeOrder=null;
    state.orderDeliveryFile=null;
  }

  function showOrderMessage(message,type){
    el.clikkerOrderDrawerAlert.className="ccx-alert is-visible ccx-alert--"+(type||"info");
    el.clikkerOrderDrawerAlert.textContent=message;
  }

  function setOrderBusy(busy,label){
    [el.clikkerOrderStart,el.clikkerOrderSaveReply,el.clikkerOrderMarkDelivered].forEach(function(button){
      if(button)button.disabled=busy;
    });
    if(el.clikkerOrderDeliveryFile)el.clikkerOrderDeliveryFile.disabled=busy;
    if(label)el.clikkerOrderSaveStatus.textContent=label;
  }

  async function updateActiveOrder(fields,successMessage){
    if(!state.activeOrder)return;
    setOrderBusy(true,"Saving…");

    try{
      await withTimeout(
        db().collection("orders").doc(state.activeOrder.id).update(
          Object.assign({},fields,{updatedAt:serverTimestamp()})
        ),
        TIMEOUTS.transaction,
        "Updating the order"
      );

      Object.assign(state.activeOrder,fields);
      var index=state.orders.findIndex(function(item){return item.id===state.activeOrder.id;});
      if(index>=0)Object.assign(state.orders[index],fields);

      renderOrderDrawer(state.activeOrder);
      renderOrdersList();
      showOrderMessage(successMessage||"Order updated.","success");
      el.clikkerOrderSaveStatus.textContent="Saved";
    }catch(error){
      console.error("[Clikker Order Update]",error);
      showOrderMessage(firebaseMessage(error,"The order could not be updated."),"error");
      el.clikkerOrderSaveStatus.textContent="Save failed";
    }finally{
      setOrderBusy(false);
    }
  }

  async function startActiveOrder(){
    if(!state.activeOrder)return;
    await updateActiveOrder({
      fulfilmentStatus:"in_progress",
      fulfilmentStartedAt:serverTimestamp()
    },"Order moved to In Progress.");
  }

  function safeFileName(name){
    return clean(name).replace(/[^a-zA-Z0-9._-]+/g,"-").slice(-120)||"delivery-file";
  }

  async function uploadActiveOrderDeliveryFile(){
    var file=state.orderDeliveryFile;
    if(!file)return null;
    validateFile(file,"document");

    if(el.clikkerOrderDeliveryFileState){
      el.clikkerOrderDeliveryFileState.textContent="Uploading "+file.name+"…";
    }

    var path="creator-orders/"+uid()+"/"+state.activeOrder.id+"/delivery/"+
      Date.now()+"-"+safeFileName(file.name);
    var uploaded=await uploadFile(file,path,"delivery");

    return {
      downloadURL:clean(uploaded.downloadURL||uploaded.url),
      fileName:file.name,
      fileType:file.type||"",
      fileSize:Number(file.size||0),
      storagePath:clean(uploaded.storagePath||uploaded.path||path),
      uploadedAt:new Date().toISOString()
    };
  }

  function collectDelivery(){
    var existing=state.activeOrder&&(
      state.activeOrder.delivery||
      state.activeOrder.creatorDelivery
    )||{};

    return {
      format:clean(el.clikkerOrderDeliveryFormat.value),
      link:clean(el.clikkerOrderDeliveryLink.value),
      replyText:clean(el.clikkerOrderReplyText.value),
      note:clean(el.clikkerOrderReplyText.value),
      downloadURL:clean(existing.downloadURL||state.activeOrder.deliveryFileURL||""),
      fileName:clean(existing.fileName||state.activeOrder.deliveryFileName||""),
      fileType:clean(existing.fileType||""),
      fileSize:Number(existing.fileSize||0),
      storagePath:clean(existing.storagePath||""),
      scheduledAt:el.clikkerOrderScheduledAt?clean(el.clikkerOrderScheduledAt.value):"",
      platform:el.clikkerOrderDeliveryPlatform?clean(el.clikkerOrderDeliveryPlatform.value):""
    };
  }

  function validateDelivery(delivery,forDelivery){
    var errors=[];
    var type=state.activeOrder?typeOf(state.activeOrder):"custom_service";
    var hasFile=!!(state.orderDeliveryFile||delivery.downloadURL);

    if(!delivery.format)errors.push("Choose the delivery method.");
    if(delivery.link&&!/^https:\/\//i.test(delivery.link)){
      errors.push("Delivery links must start with https://.");
    }

    if(["external_link","access_link","published_url"].indexOf(delivery.format)>=0&&!delivery.link){
      errors.push("Add the required secure link.");
    }

    if(delivery.format==="meeting"){
      if(!delivery.scheduledAt)errors.push("Add the confirmed call date and time.");
      if(!delivery.platform)errors.push("Add the call platform.");
      if(!delivery.link)errors.push("Add the meeting link.");
    }

    if(delivery.format==="file"&&!hasFile){
      errors.push("Upload the delivery file.");
    }

    if(delivery.format==="video"&&!hasFile&&!delivery.link){
      errors.push("Upload the video or add a secure video link.");
    }

    if(delivery.format==="voice_note"&&!hasFile&&!delivery.link){
      errors.push("Upload the voice note or add a secure link.");
    }

    if(type==="community_access"&&!delivery.link){
      errors.push("Add the private community invitation link.");
    }

    if(type==="content_access"&&!delivery.link&&!hasFile){
      errors.push("Add the private content link or an access file.");
    }

    if(forDelivery&&!delivery.replyText&&!delivery.link&&!hasFile&&delivery.format!=="meeting"){
      errors.push("Add a delivery note, secure link or uploaded file.");
    }
    return errors;
  }

  async function prepareDeliveryForSave(forDelivery){
    var delivery=collectDelivery();
    var earlyErrors=validateDelivery(delivery,forDelivery);
    var onlyFileMissing=earlyErrors.length===1&&
      /upload|video|voice note/i.test(earlyErrors[0])&&
      !!state.orderDeliveryFile;

    if(earlyErrors.length&&!onlyFileMissing){
      throw new Error(earlyErrors.join(" "));
    }

    if(state.orderDeliveryFile){
      var uploaded=await uploadActiveOrderDeliveryFile();
      delivery=Object.assign({},delivery,uploaded||{});
    }

    var errors=validateDelivery(delivery,forDelivery);
    if(errors.length)throw new Error(errors.join(" "));
    return delivery;
  }

  async function saveActiveDelivery(){
    if(!state.activeOrder)return;
    setOrderBusy(true,state.orderDeliveryFile?"Uploading delivery…":"Saving delivery…");

    try{
      var delivery=await prepareDeliveryForSave(false);
      await updateActiveOrder({
        fulfilmentStatus:orderStatusKey(state.activeOrder)==="new"
          ?"in_progress"
          :clean(state.activeOrder.fulfilmentStatus||"in_progress"),
        delivery:delivery,
        deliverySavedAt:serverTimestamp(),
        replySavedAt:FieldValueDeleteFallback()
      },"Delivery saved. It has not been marked delivered yet.");
    }catch(error){
      console.error("[Clikker Save Delivery]",error);
      showOrderMessage(firebaseMessage(error,"The delivery could not be saved."),"error");
      el.clikkerOrderSaveStatus.textContent="Save failed";
      setOrderBusy(false);
    }
  }

  function FieldValueDeleteFallback(){
    return window.firebase.firestore.FieldValue.delete();
  }

  async function markActiveOrderDelivered(){
    if(!state.activeOrder)return;
    setOrderBusy(true,state.orderDeliveryFile?"Uploading and delivering…":"Delivering order…");

    try{
      var delivery=await prepareDeliveryForSave(true);
      if(!window.confirm("Submit this delivery and mark the paid order as delivered?")){
        setOrderBusy(false);
        return;
      }

      await updateActiveOrder({
        fulfilmentStatus:"delivered",
        orderStatus:"fulfilled",
        delivery:delivery,
        deliverySavedAt:serverTimestamp(),
        deliveredAt:serverTimestamp()
      },"Order marked delivered. The buyer delivery email will be sent automatically.");
    }catch(error){
      console.error("[Clikker Mark Delivered]",error);
      showOrderMessage(firebaseMessage(error,"The order could not be delivered."),"error");
      el.clikkerOrderSaveStatus.textContent="Delivery failed";
      setOrderBusy(false);
    }
  }



  function bind(){
    el.clikkerCreatorRetry.onclick=boot;

    if(el.clikkerOnboardingAvatar){
      el.clikkerOnboardingAvatar.onchange=function(){
        var file=this.files&&this.files[0]||null;
        try{
          validateFile(file,"image");
          state.onboarding.profileImageFile=file;
          renderOnboardingAvatar();
          clearOnboardingMessage();
        }catch(error){
          this.value="";
          state.onboarding.profileImageFile=null;
          onboardingMessage(error.message,"error");
        }
      };
    }

    if(el.clikkerOnboardingDigitalFile){
      el.clikkerOnboardingDigitalFile.onchange=function(){
        var file=this.files&&this.files[0]||null;
        try{
          validateFile(file,"file");
          state.onboarding.digitalFile=file;
          if(el.clikkerOnboardingDigitalFileHelp){
            el.clikkerOnboardingDigitalFileHelp.textContent=file
              ? file.name+" · "+Math.max(1,Math.round(file.size/1024))+" KB selected"
              : "Maximum 50 MB. Buyers receive this file after payment.";
          }
          clearOnboardingMessage();
        }catch(error){
          this.value="";
          state.onboarding.digitalFile=null;
          if(el.clikkerOnboardingDigitalFileHelp){
            el.clikkerOnboardingDigitalFileHelp.textContent="Maximum 50 MB. Buyers receive this file after payment.";
          }
          onboardingMessage(error.message,"error");
        }
      };
    }

    if(el.clikkerOnboardingName){
      el.clikkerOnboardingName.addEventListener("input",function(){
        if(!state.onboarding.profileImageFile)renderOnboardingAvatar();
        if(!clean(el.clikkerOnboardingHandle.value)||el.clikkerOnboardingHandle.value===state.onboarding.originalHandle){
          var suggestion=slugify(this.value);
          el.clikkerOnboardingHandle.value=suggestion;
          state.onboarding.originalHandle=suggestion;
          checkOnboardingHandle(false);
        }
      });
    }

    if(el.clikkerOnboardingHandle){
      el.clikkerOnboardingHandle.addEventListener("input",function(){
        state.onboarding.handleAvailable=null;
        checkOnboardingHandle(false);
      });
      el.clikkerOnboardingHandle.addEventListener("blur",function(){
        checkOnboardingHandle(true);
      });
    }

    if(el.clikkerOnboardingProductChoices){
      el.clikkerOnboardingProductChoices.querySelectorAll("[data-onboarding-product]").forEach(function(button){
        button.onclick=function(){selectOnboardingProduct(button);};
      });
    }

    [
      el.clikkerOnboardingProductTitle,
      el.clikkerOnboardingProductPrice,
      el.clikkerOnboardingProductCurrency,
      el.clikkerOnboardingDeliveryHours,
      el.clikkerOnboardingProductDescription
    ].forEach(function(node){
      if(!node)return;
      node.addEventListener("input",updateOnboardingOfferPreview);
      node.addEventListener("change",updateOnboardingOfferPreview);
    });

    if(el.clikkerOnboardingBack)el.clikkerOnboardingBack.onclick=function(){moveOnboardingStep(-1);};
    if(el.clikkerOnboardingNext)el.clikkerOnboardingNext.onclick=function(){moveOnboardingStep(1);};
    if(el.clikkerOnboardingCreate)el.clikkerOnboardingCreate.onclick=createOnboardingStore;
    if(el.clikkerOnboardingPublishConfirmation){
      el.clikkerOnboardingPublishConfirmation.addEventListener("change",function(){
        if(this.checked)clearOnboardingMessage();
      });
    }
    if(el.clikkerOnboardingCopyLink)el.clikkerOnboardingCopyLink.onclick=copyOnboardingLink;
    if(el.clikkerOnboardingOpenDashboard)el.clikkerOnboardingOpenDashboard.onclick=openDashboardAfterOnboarding;
    if(el.clikkerQuickOnboarding){
      el.clikkerQuickOnboarding.addEventListener("keydown",function(event){
        if(event.key!=="Enter"||event.shiftKey||event.isComposing)return;
        var target=event.target;
        if(target&&(/textarea|button|select/i).test(target.tagName))return;
        if(state.onboarding.saving)return;
        event.preventDefault();
        if(Number(state.onboarding.step)===3)createOnboardingStore();
        else moveOnboardingStep(1);
      });
    }
    injectOrdersStyles();

    if(el.clikkerOrderDrawer){
      el.clikkerOrderDrawer.querySelectorAll("[data-close-order-drawer]").forEach(function(node){
        node.onclick=closeOrderDrawer;
      });
    }
    if(el.clikkerOrderStart)el.clikkerOrderStart.onclick=startActiveOrder;
    if(el.clikkerOrderSaveReply)el.clikkerOrderSaveReply.onclick=saveActiveDelivery;
    if(el.clikkerOrderMarkDelivered)el.clikkerOrderMarkDelivered.onclick=markActiveOrderDelivered;
    if(el.clikkerOrderReplyText){
      el.clikkerOrderReplyText.addEventListener("input",function(){
        el.clikkerOrderReplyCount.textContent=this.value.length+" / 5000";
        el.clikkerOrderSaveStatus.textContent="Unsaved changes";
      });
    }
    [
      el.clikkerOrderDeliveryFormat,
      el.clikkerOrderDeliveryLink,
      el.clikkerOrderScheduledAt,
      el.clikkerOrderDeliveryPlatform
    ].forEach(function(node){
      if(node)node.addEventListener("input",function(){
        el.clikkerOrderSaveStatus.textContent="Unsaved changes";
      });
      if(node)node.addEventListener("change",function(){
        el.clikkerOrderSaveStatus.textContent="Unsaved changes";
      });
    });

    if(el.clikkerOrderDeliveryFile){
      el.clikkerOrderDeliveryFile.addEventListener("change",function(){
        var file=this.files&&this.files[0]||null;
        try{
          validateFile(file,"document");
          state.orderDeliveryFile=file;
          if(el.clikkerOrderDeliveryFileState){
            el.clikkerOrderDeliveryFileState.textContent=file
              ? file.name+" · "+Math.max(1,Math.round(file.size/1024))+" KB selected"
              : "No new file selected.";
          }
          el.clikkerOrderSaveStatus.textContent="Unsaved changes";
          showOrderMessage("Delivery file selected. Save or submit the order to upload it.","info");
        }catch(error){
          this.value="";
          state.orderDeliveryFile=null;
          if(el.clikkerOrderDeliveryFileState)el.clikkerOrderDeliveryFileState.textContent="No new file selected.";
          showOrderMessage(error.message,"error");
        }
      });
    }
    document.addEventListener("keydown",function(event){
      if(event.key==="Escape"&&el.clikkerOrderDrawer&&!el.clikkerOrderDrawer.hidden){
        closeOrderDrawer();
      }
    });

    el.clikkerCreatorMobileMenu.onclick=function(){el.clikkerCreatorSidebar.classList.toggle("is-open");};
    el.clikkerCreatorNavigation.querySelectorAll("[data-view]").forEach(function(btn){btn.onclick=function(){if(!btn.disabled)renderView(btn.dataset.view);};});
    el.clikkerCreatorLogout.onclick=async function(){
      await window.Clikker.logout({redirect:false});
      location.href=ROUTES.login;
    };

    el.clikkerStoreEditorTabs.querySelectorAll("[data-store-tab]").forEach(function(btn){btn.onclick=function(){switchStoreTab(btn.dataset.storeTab);};});
    el.clikkerStoreEditor.querySelectorAll("input,select,textarea").forEach(function(n){n.addEventListener("input",markStoreDirty);n.addEventListener("change",markStoreDirty);});
    [["storeBrandPrimaryColorPicker","storeBrandPrimaryColor"],["storeBrandSecondaryColorPicker","storeBrandSecondaryColor"],["storeBrandButtonColorPicker","storeBrandButtonColor"],["storeBrandTextColorPicker","storeBrandTextColor"]].forEach(function(pair){
      byId(pair[0]).oninput=function(){byId(pair[1]).value=byId(pair[0]).value;markStoreDirty();};
    });
    byId("storeProfileImage").onchange=function(){state.storeEditor.profileImageFile=this.files[0]||null;renderStoreImages();markStoreDirty();};
    byId("storeBannerImage").onchange=function(){state.storeEditor.bannerImageFile=this.files[0]||null;renderStoreImages();markStoreDirty();};
    byId("storeAddAchievement").onclick=function(){editAchievement(-1);};
    byId("storeAddBrand").onclick=function(){editBrand(-1);};
    byId("storeSaveDraft").onclick=function(){saveStore("draft");};
    byId("storePublishProfile").onclick=function(){saveStore("publish");};
    if(byId("storeOpenPrivatePreview"))byId("storeOpenPrivatePreview").onclick=function(e){if(!clean(byId("storeProfileHandle").value)){e.preventDefault();showStoreMessage("Add a public username before previewing the store.","error");}};

    el.clikkerProductEditorClose.onclick=function(){closeProductEditor(false);};
    el.clikkerCancelProductEdit.onclick=function(){closeProductEditor(false);};
    el.clikkerProductEditorTabs.querySelectorAll("[data-product-tab]").forEach(function(btn){btn.onclick=function(){switchProductTab(btn.dataset.productTab);};});
    if(el.clikkerProductPreviousStep)el.clikkerProductPreviousStep.onclick=function(){moveProductStep(-1);};
    if(el.clikkerProductNextStep)el.clikkerProductNextStep.onclick=function(){moveProductStep(1);};
    el.clikkerProductEditor.querySelectorAll("input,select,textarea").forEach(function(n){
      if(!n.closest("#clikkerStoreEditor")){n.addEventListener("input",markProductDirty);n.addEventListener("change",markProductDirty);}
    });
    var coverInput=byId("productEditorCoverImage");if(coverInput)coverInput.onchange=function(){var file=this.files[0]||null;try{validateFile(file,"image");state.productEditor.coverImageFile=file;renderProductCoverPreview(collectProduct());markProductDirty();}catch(error){this.value="";state.productEditor.coverImageFile=null;showProductMessage(error.message,"error");}};
    el.clikkerProductFulfilmentFields.addEventListener("change",function(e){var input=e.target.closest("[data-fulfilment-file]");if(!input)return;var file=input.files[0]||null;try{validateFile(file,"file");if(file)state.productEditor.fulfilmentFiles[input.dataset.fulfilmentKey]=file;else delete state.productEditor.fulfilmentFiles[input.dataset.fulfilmentKey];markProductDirty();}catch(error){input.value="";delete state.productEditor.fulfilmentFiles[input.dataset.fulfilmentKey];showProductMessage(error.message,"error");}});
    el.clikkerLoadRecommendedFields.onclick=function(){state.productEditor.buyerFields=ensureRequiredBuyerContact(schemaOf(typeOf(state.productEditor.product)).buyerFields);markProductDirty();renderBuyerFields();};
    el.clikkerAddBuyerField.onclick=function(){openFieldDrawer(-1);};
    el.clikkerBuyerFieldDrawerClose.onclick=closeFieldDrawer;el.clikkerCancelBuyerField.onclick=closeFieldDrawer;el.clikkerSaveBuyerField.onclick=saveField;
    el.buyerFieldType.onchange=function(){el.buyerFieldOptionsWrap.hidden=this.value!=="select";};
    el.clikkerSaveProductDraft.onclick=function(){
      saveProduct(productEditorIsPublished()?"update":"draft");
    };
    el.clikkerPublishProduct.onclick=function(){saveProduct("publish");};
    el.clikkerArchiveProduct.onclick=archiveProduct;



    window.addEventListener("beforeunload",function(e){if(state.storeEditor.dirty||state.productEditor.dirty||state.onboarding.saving){e.preventDefault();e.returnValue="";}});
  }

  function init(){cache();bind();boot();}
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init,{once:true});else init();
})();
